{
  "a11y": {
    "activeBatches": "Batch attivi, {{count}} in sospeso",
    "activeBatchesButton": "Batch attivi",
    "addToFavorites": "Aggiungi ai preferiti",
    "addTag": "Aggiungi tag",
    "audioPlayer": "Lettore audio",
    "backupCode": "Codice di backup",
    "cancelAllDownloads": "Annulla tutti i download",
    "clearAllNotifications": "Cancella tutte le notifiche",
    "clearSelection": "Cancella selezione",
    "clearUploadQueue": "Svuota coda caricamento",
    "copyLink": "Copia link",
    "closePanel": "Chiudi pannello",
    "composerFab": "Componi nuova email",
    "detailsPanel": "Pannello dettagli",
    "emailSending": "Invio email in corso",
    "emptyFilesTable": "Nessun file da visualizzare",
    "editFileTags": "Modifica tag file",
    "fileTagsCount": "Tag, {{count}}",
    "enterFilePasswordForm": "Inserisci password file",
    "expandUploadProgress": "Espandi avanzamento caricamento",
    "fileTypesFilter": "Filtra per tipo di file",
    "onlyExpiredFilter": "Filtra condivisioni scadute",
    "expiringWithinDaysFilter": "Filtra condivisioni in scadenza entro giorni",
    "filters": "Filtri",
    "fullscreen": "Schermo intero",
    "fileMoveForm": "Sposta file",
    "filePublicLinkForm": "Impostazioni link pubblico",
    "filesTable": "Elenco file",
    "globalSearch": "Cerca file",
    "goBack": "Indietro",
    "groupForm": "Modulo gruppo",
    "loading": "Caricamento in corso",
    "minimizeUploadProgress": "Riduci avanzamento caricamento",
    "mute": "Disattiva audio",
    "mainNavigation": "Navigazione principale",
    "markAllRead": "Segna tutte le notifiche come lette",
    "notificationsButton": "Notifiche",
    "notificationsCount": "Notifiche, {{count}} non lette",
    "notificationsList": "Elenco notifiche",
    "openEmailsSection": "Apri sezione Email",
    "openFileMenu": "Apri menu azioni file",
    "openFolder": "Apri cartella {{name}}",
    "openList": "Apri {{name}}",
    "openMoreActions": "Apri altre azioni",
    "openFilesSection": "Apri sezione File",
    "otpCode": "Codice monouso",
    "pendingGrants": "Richieste di accesso in sospeso, {{count}}",
    "pendingGrantsButton": "Richieste di accesso in sospeso",
    "playbackProgress": "Avanzamento riproduzione, {{current}} di {{duration}}",
    "playPause": "Riproduci o metti in pausa",
    "quickShare": "Caricamento quick share, {{percent}} percento",
    "removeFromFavorites": "Rimuovi dai preferiti",
    "removeException": "Rimuovi eccezione",
    "removeSharedFile": "Rimuovi file condiviso",
    "searchExactMatch": "Ricerca corrispondenza esatta",
    "searchWholeWord": "Parola intera",
    "sectionSelector": "Selettore sezione",
    "selectCountry": "Seleziona {{country}}",
    "settingsSearch": "Cerca nelle impostazioni",
    "skipToMain": "Salta al contenuto principale",
    "tagActions": "Azioni per il tag {{name}}",
    "tagNotSelected": "non selezionato",
    "tagSelected": "selezionato",
    "tagToggle": "{{name}}, {{state}}",
    "textEditor": "Editor di testo",
    "totpCode": "Codice autenticatore",
    "unmute": "Attiva audio",
    "activityMap": "Mappa mondiale attività per paese",
    "cancelAllFailed": "Annulla tutti i batch falliti",
    "copyBackupCodes": "Copia codici di backup",
    "deleteSelected": "Elimina selezionati",
    "downloadBackupCodes": "Scarica codici di backup",
    "downloadProgress": "Avanzamento download",
    "exitEditMode": "Esci dalla modalità modifica",
    "expandDownloadProgress": "Espandi avanzamento download",
    "exportCsv": "Esporta in CSV",
    "imageEditor": "Editor immagini",
    "markdownEditor": "Editor markdown",
    "markdownHeading": "Stile intestazione",
    "markdownLinkActions": "Azioni collegamento",
    "markdownToolbar": "Barra di formattazione",
    "minimizeDownloadProgress": "Riduci avanzamento download",
    "pdfViewer": "Visualizzatore documenti PDF",
    "printDashboard": "Stampa dashboard",
    "refreshFolderStats": "Aggiorna statistiche cartella",
    "refreshList": "Aggiorna elenco",
    "removeFile": "Rimuovi file",
    "saveFile": "Salva file",
    "selectUser": "Seleziona {{name}}",
    "viewUploadErrors": "Visualizza errori di caricamento",
    "uploadProgress": "Avanzamento caricamento",
    "viewAsGrid": "Visualizza come griglia",
    "viewAsList": "Visualizza come elenco",
    "userForm": "Modulo utente",
    "userMenu": "Menu account utente",
    "viewRiskIndicator": "{{name}}, visualizza dettagli",
    "verifyingFile": "Verifica file in corso",
    "videoPlayer": "Lettore video",
    "volume": "Volume, {{percent}} percento",
    "messageInput": "Campo messaggio",
    "sendMessage": "Invia messaggio",
    "stopGenerating": "Interrompi generazione"
  },
  "antivirus": {
    "quarantine": {
      "title": "Quarantena",
      "description": "Esamina file infetti, errori di scansione e file saltati; rilascia i falsi positivi.",
      "empty": "Nessun file corrisponde a questo filtro",
      "rescan": "Nuova scansione",
      "release": "Rilascia",
      "delete": "Elimina",
      "rescanSuccess": "Nuova scansione accodata",
      "releaseSuccess": "File rilasciato dalla quarantena",
      "releaseModalTitle": "Rilascia file dalla quarantena",
      "releaseConfirmDescription": "Rilasciare \"{{fileName}}\" dalla quarantena? Il file tornerà disponibile. Indica un motivo per il registro di audit.",
      "releaseReasonLabel": "Motivo",
      "releaseReasonPlaceholder": "Spiega perché il file va rilasciato",
      "releaseReasonRequired": "Il motivo del rilascio è obbligatorio",
      "deleteConfirmTitle": "Eliminare il file in quarantena?",
      "deleteConfirmDescription": "Spostare \"{{fileName}}\" nel cestino? Usa il percorso di eliminazione file ordinario.",
      "status": {
        "infected": "Infetto",
        "error": "Errore",
        "skipped": "Saltato",
        "toolarge": "Troppo grande"
      },
      "columns": {
        "name": "Nome file",
        "threat": "Minaccia",
        "engine": "Motore",
        "ownerEmail": "Email proprietario",
        "scannedAt": "Scansionato il",
        "actions": "Azioni"
      },
      "errors": {
        "loadFailed": "Impossibile caricare i file in quarantena",
        "rescanFailed": "Impossibile accodare la nuova scansione",
        "releaseFailed": "Impossibile rilasciare il file",
        "deleteFailed": "Impossibile eliminare il file",
        "invalidParams": "Filtro o motivo di rilascio non valido"
      }
    }
  },
  "account": {
    "title": "Account",
    "description": "Gestisci profilo, preferenze e sicurezza.",
    "navAria": "Sezioni account",
    "profile": "Profilo",
    "profileDescription": "Aggiorna nome e cognome. L'email non si può modificare qui.",
    "profileUnavailable": "Profilo non disponibile.",
    "profileUpdated": "Profilo aggiornato",
    "preferences": "Preferenze",
    "preferencesDescription": "Lingua, aspetto e accessibilità.",
    "languageDescription": "Scegli la lingua dell'interfaccia.",
    "appearanceDescription": "Scegli chiaro, scuro o segui il sistema.",
    "accessibilityDescription": "Attiva alto contrasto e riduzione animazioni.",
    "security": "Sicurezza",
    "securityDescription": "Autenticazione a due fattori e passkey.",
    "twoFactorDescription": "Aggiungi o gestisci i codici dell'app authenticator.",
    "passkeysDescription": "Registra e gestisci le passkey di questo account.",
    "openTwoFactor": "Gestisci 2FA",
    "openPasskeys": "Gestisci passkey",
    "sessions": "Sessioni",
    "sessionsDescription": "Gestisci le sessioni attive e gli sblocchi cartella.",
    "activeSessionsDescription": "Rivedi e revoca le sessioni browser attive.",
    "folderSessionsDescription": "Gestisci le sessioni di sblocco password delle cartelle.",
    "openActiveSessions": "Gestisci sessioni attive",
    "openFolderSessions": "Gestisci sessioni cartella",
    "publicLinks": "Link pubblici",
    "publicLinksDescription": "Visualizza e revoca i link pubblici che hai creato.",
    "publicLinksCtaDescription": "Apri l'elenco dei tuoi link pubblici.",
    "openPublicLinks": "Gestisci link pubblici"
  },
  "pageTitle": {
    "app": "Filegrant",
    "login": "Accesso",
    "logout": "Esci",
    "settings": "Impostazioni",
    "account": "Account",
    "filesPersonal": "File",
    "filesReceived": "Ricevuti",
    "filesShared": "Condivisi",
    "filesFavorites": "Preferiti",
    "filesRecent": "Recenti",
    "filesHidden": "Nascosti",
    "filesTrash": "Cestino",
    "publicLink": "Link pubblico",
    "emails": "Email",
    "emailsInbox": "Posta in arrivo",
    "emailsSent": "Inviati",
    "emailsDrafts": "Bozze",
    "emailsFavorites": "Email preferite",
    "emailsArchive": "Archivio",
    "emailsTrash": "Cestino email",
    "users": "Utenti",
    "groups": "Gruppi",
    "dashboard": "Dashboard",
    "salesDashboard": "Dashboard vendite",
    "activityLogs": "Log attività",
    "antivirusQuarantine": "Quarantena",
    "viewer": "Visualizzatore",
    "office": "Office",
    "quickShare": "Quick Share",
    "store": "Store",
    "purchase": "Acquisto",
    "paymentSuccess": "Pagamento riuscito",
    "fileShareRequests": "Richieste di condivisione",
    "protectedFile": "File protetto",
    "extensionAuthorize": "Autorizzazione estensione",
    "sharePointStatus": "Stato SharePoint"
  },
  "activityLogOperationTypes": {
    "CreateFile": "File creato",
    "CreateFolder": "Cartella creata",
    "CreateFileFailed": "Creazione file non riuscita",
    "CreateFolderFailed": "Creazione cartella non riuscita",
    "ReadFile": "File visualizzato",
    "ReadFolder": "Cartella visualizzata",
    "DownloadFile": "File scaricato",
    "DownloadFileEncrypted": "File cifrato scaricato",
    "DownloadFileZip": "File scaricato come Zip",
    "SearchFiles": "Ricerca file",
    "ReadFileFailed": "Visualizzazione file non riuscita",
    "ReadFolderFailed": "Visualizzazione cartella non riuscita",
    "DownloadFileFailed": "Download file non riuscito",
    "DownloadFileEncFailed": "Download file cifrato non riuscito",
    "DownloadFileZipFailed": "Download file Zip non riuscito",
    "UpdateFile": "File aggiornato",
    "RenameFile": "File rinominato",
    "MoveFile": "File spostato",
    "DuplicateFile": "File duplicato",
    "UploadFile": "File caricato",
    "UpdateFileFailed": "Aggiornamento file non riuscito",
    "RenameFileFailed": "Rinomina file non riuscita",
    "MoveFileFailed": "Spostamento file non riuscito",
    "DuplicateFileFailed": "Duplicazione file non riuscita",
    "UploadFileFailed": "Caricamento file non riuscito",
    "DeleteFileToRecycleBin": "File spostato nel cestino",
    "DeleteFolderToRecycleBin": "Cartella spostata nel cestino",
    "DeleteFileToRecycleBinFailed": "Spostamento file nel cestino non riuscito",
    "DeleteFolderToRecycleBinFailed": "Spostamento cartella nel cestino non riuscito",
    "DeleteFilePermanently": "File eliminato definitivamente",
    "DeleteFolderPermanently": "Cartella eliminata definitivamente",
    "DeleteFilePermanentlyFailed": "Eliminazione definitiva file non riuscita",
    "DeleteFolderPermanentlyFailed": "Eliminazione definitiva cartella non riuscita",
    "ShareFile": "File condiviso",
    "ShareFolder": "Cartella condivisa",
    "RevokeShare": "Condivisione revocata",
    "ShareFileFailed": "Condivisione file non riuscita",
    "ShareFolderFailed": "Condivisione cartella non riuscita",
    "RevokeShareFailed": "Revoca condivisione non riuscita",
    "ViewAuditLog": "Registro di controllo visualizzato",
    "ExportAuditLog": "Registro di controllo esportato",
    "ViewAuditLogFailed": "Visualizzazione registro di controllo non riuscita",
    "ExportAuditLogFailed": "Esportazione registro di controllo non riuscita",
    "PurgeAuditLog": "Registro di controllo ripulito (conservazione)",
    "GrantAccess": "Accesso concesso",
    "RevokeAccess": "Accesso revocato",
    "GrantAccessFailed": "Concessione accesso non riuscita",
    "RevokeAccessFailed": "Revoca accesso non riuscita",
    "CreateVersion": "Versione creata",
    "RevertVersion": "Versione ripristinata",
    "CreateVersionFailed": "Creazione versione non riuscita",
    "RevertVersionFailed": "Ripristino versione non riuscito",
    "CommentFile": "Commento aggiunto",
    "ReplyComment": "Risposta al commento",
    "AssignTask": "Attività assegnata",
    "CommentFileFailed": "Commento non riuscito",
    "ReplyCommentFailed": "Risposta al commento non riuscita",
    "AssignTaskFailed": "Assegnazione attività non riuscita",
    "PreviewFile": "Anteprima file",
    "HiddenFile": "File nascosto",
    "UnhiddenFile": "File reso visibile",
    "AddToFavorites": "Aggiunto ai preferiti",
    "RemoveFromFavorites": "Rimosso dai preferiti",
    "PreviewFileFailed": "Anteprima file non riuscita",
    "HiddenFileFailed": "Nascondi file non riuscito",
    "UnhiddenFileFailed": "Rendi visibile file non riuscito",
    "AddToFavoritesFailed": "Aggiunta ai preferiti non riuscita",
    "RemoveFromFavoritesFailed": "Rimozione dai preferiti non riuscita",
    "CreateUser": "Utente creato",
    "EditUser": "Utente modificato",
    "RemoveUser": "Utente rimosso",
    "CreateGroup": "Gruppo creato",
    "EditGroup": "Gruppo modificato",
    "RemoveGroup": "Gruppo rimosso",
    "OnBehalfOfAccess": "Accesso per conto di un utente",
    "OnBehalfOfOperation": "Operazione per conto di un utente",
    "CreateUserFailed": "Creazione utente non riuscita",
    "EditUserFailed": "Modifica utente non riuscita",
    "RemoveUserFailed": "Rimozione utente non riuscita",
    "CreateGroupFailed": "Creazione gruppo non riuscita",
    "EditGroupFailed": "Modifica gruppo non riuscita",
    "RemoveGroupFailed": "Rimozione gruppo non riuscita",
    "OnBehalfOfAccessFailed": "Accesso per conto di non riuscito",
    "OnBehalfOfOperationFailed": "Operazione per conto di non riuscita",
    "LogIn": "Accesso eseguito",
    "LogOut": "Disconnessione eseguita",
    "OTPRequest": "OTP richiesto",
    "LogInFailed": "Accesso non riuscito",
    "LogOutFailed": "Disconnessione non riuscita",
    "OTPRequestFailed": "Richiesta OTP non riuscita",
    "AddTag": "Tag aggiunto",
    "RemoveTag": "Tag rimosso",
    "UpdateTag": "Tag aggiornato",
    "ListTags": "Tag elencati",
    "AddTagFailed": "Aggiunta tag non riuscita",
    "RemoveTagFailed": "Rimozione tag non riuscita",
    "UpdateTagFailed": "Aggiornamento tag non riuscito",
    "ListTagsFailed": "Elenco tag non riuscito",
    "RestoreFile": "File ripristinato",
    "TagFile": "Tag aggiunti al file",
    "RemoveTagFile": "Tag rimossi dal file",
    "EncryptFile": "File cifrato",
    "DecryptFile": "File decifrato",
    "ChangeFileOwner": "Proprietario del file cambiato",
    "SetFileExpiration": "Scadenza del file impostata",
    "GenerateShareLink": "Link di condivisione generato",
    "ValidateUser": "Utente validato",
    "SignFile": "File firmato",
    "FileDescription": "Descrizione del file impostata",
    "ShortCut": "Collegamento file creato",
    "RestoreFileFailed": "Ripristino file non riuscito",
    "TagFileFailed": "Aggiunta tag al file non riuscita",
    "RemoveTagFileFailed": "Rimozione tag dal file non riuscita",
    "EncryptFileFailed": "Cifratura file non riuscita",
    "DecryptFileFailed": "Decifratura file non riuscita",
    "ChangeFileOwnerFailed": "Cambio proprietario file non riuscito",
    "SetFileExpirationFailed": "Impostazione scadenza non riuscita",
    "GenerateShareLinkFailed": "Generazione link di condivisione non riuscita",
    "ValidateUserFailed": "Validazione utente non riuscita",
    "SignFileFailed": "Firma file non riuscita",
    "FileDescriptionFailed": "Impostazione descrizione file non riuscita",
    "ShortCutFailed": "Creazione collegamento file non riuscita",
    "ScreenCaptureAttempt": "Tentativo di cattura schermo",
    "ClipboardCopyAttempt": "Tentativo di copia negli appunti",
    "UnauthorizedAccessAttempt": "Tentativo di accesso non autorizzato",
    "ScreenCaptureAttemptFailed": "Tentativo di cattura schermo non riuscito",
    "ClipboardCopyAttemptFailed": "Tentativo di copia negli appunti non riuscito",
    "UnauthorizedAccessAttemptFailed": "Tentativo di accesso non autorizzato non riuscito",
    "MalwareDetection": "Malware rilevato",
    "MalwareRemoval": "Malware rimosso",
    "SuspiciousActivityDetected": "Attività sospetta rilevata",
    "IntrusionDetection": "Intrusione rilevata",
    "IntrusionPrevention": "Intrusione prevenuta",
    "DataLeakageAttempt": "Tentativo di data leakage",
    "DataLeakageAttemptFailed": "Tentativo di data leakage non riuscito",
    "PhishingAttemptDetected": "Tentativo di phishing rilevato",
    "RansomwareAttackDetected": "Ransomware rilevato",
    "BruteForceAttackDetected": "Attacco brute force rilevato",
    "TwoFactorAuthEnabled": "Autenticazione a due fattori abilitata",
    "TwoFactorAuthDisabled": "Autenticazione a due fattori disabilitata",
    "TwoFactorAuthAttemptFailed": "Tentativo 2FA non riuscito",
    "PasswordChange": "Password cambiata",
    "PasswordChangeFailed": "Cambio password non riuscito",
    "SecuritySettingsUpdate": "Impostazioni di sicurezza aggiornate",
    "SecuritySettingsUpdateFailed": "Aggiornamento impostazioni di sicurezza non riuscito",
    "FirewallRuleChange": "Regola firewall modificata",
    "FirewallRuleChangeFailed": "Modifica regola firewall non riuscita",
    "EncryptionKeyManagement": "Gestione chiavi di cifratura",
    "EncryptionKeyManagementFailed": "Gestione chiavi di cifratura non riuscita",
    "AccessControlPolicyChange": "Politica di controllo accessi modificata",
    "AccessControlPolicyChangeFailed": "Modifica politica di controllo accessi non riuscita",
    "SecurityPatchApplied": "Patch di sicurezza applicata",
    "SecurityPatchAppliedFailed": "Applicazione patch di sicurezza non riuscita",
    "LastCheckToken": "Ultimo controllo token",
    "UpdateSetting": "Aggiornamento Impostazione",
    "ViewGroupsList": "Elenco gruppi visualizzato",
    "ViewUsersList": "Elenco utenti visualizzato",
    "ViewTrash": "Cestino visualizzato",
    "ViewArchivedFiles": "File nascosti visualizzati",
    "ViewFavoriteFiles": "File preferiti visualizzati",
    "ViewSharedFiles": "File condivisi visualizzati",
    "ViewReceivedFiles": "File ricevuti visualizzati",
    "ViewSettings": "Impostazioni visualizzate",
    "EmailSent": "Email inviata",
    "EmailRead": "Email letta",
    "EmailSaveDraft": "Bozza salvata",
    "EmailUpdateDraft": "Bozza aggiornata",
    "EmailTrash": "Email spostata nel cestino",
    "EmailRestore": "Email ripristinata dal cestino",
    "EmailDelete": "Email eliminata definitivamente",
    "EmailArchive": "Email archiviata",
    "EmailUnarchive": "Email dearchiviata",
    "EmailFavourite": "Email aggiunta ai preferiti",
    "EmailUnfavourite": "Email rimossa dai preferiti",
    "EmailAttachmentRemoved": "Allegato rimosso dall'email inviata",
    "EmailRecipientRemoved": "Destinatario rimosso dall'email inviata",
    "EmailReplied": "Risposta email inviata",
    "EmailForwarded": "Email inoltrata",
    "CreateSetting": "Impostazione creata",
    "DeleteSetting": "Impostazione eliminata",
    "PaymentSessionCreated": "Sessione di pagamento creata",
    "PaymentCompleted": "Pagamento completato",
    "SessionRevoked": "Sessione revocata",
    "AllSessionsRevoked": "Tutte le sessioni revocate",
    "AdminSessionRevoked": "Sessione utente revocata dall'admin",
    "CreateCompany": "Azienda creata",
    "UpdateCompany": "Azienda aggiornata",
    "BackOfficeCreateUser": "Utente creato da back office",
    "BackOfficeUpdateUser": "Utente aggiornato da back office",
    "SystemMaintenance": "Manutenzione di sistema",
    "CreateCertificate": "Certificato creato",
    "CreateAccessRule": "Regola di accesso creata",
    "VersionRetention": "Retention versioni applicata",
    "CleanupDeletedVersions": "Versioni eliminate ripulite",
    "CreateIdentityProvider": "Identity provider creato",
    "UpdateIdentityProvider": "Identity provider aggiornato",
    "CreateAIAgent": "Agente AI creato",
    "UpdateAIAgent": "Agente AI aggiornato",
    "DeleteAIAgent": "Agente AI eliminato",
    "AIChatRequest": "Richiesta chat AI",
    "AIChatWithDocument": "Chat AI con documento",
    "AIChatDeleteConversation": "Conversazione chat AI eliminata",
    "CancelBatch": "Batch annullato",
    "CancelFileJobs": "Job file annullati",
    "RetryFileJobs": "Riprova job file",
    "InviteUsers": "Utenti invitati",
    "ViewExecutiveReport": "Report esecutivo visualizzato",
    "CreatePublicLink": "Link pubblico creato",
    "RevokePublicLink": "Link pubblico revocato",
    "PublicLinkAccess": "Accesso tramite link pubblico",
    "PublicLinkDownload": "Download tramite link pubblico",
    "PublicLinkViewerAccess": "Accesso visualizzatore tramite link pubblico",
    "PublicLinkAccessFailed": "Accesso link pubblico non riuscito",
    "IpRegionLoginBlocked": "Accesso bloccato da IP/regione",
    "IpRegionFileOperationBlocked": "Operazione file bloccata da IP/regione",
    "EntraIdSyncStarted": "Sincronizzazione Entra ID avviata",
    "EntraIdSyncCompleted": "Sincronizzazione Entra ID completata",
    "EntraIdUserImported": "Utente importato da Entra ID",
    "EntraIdGroupImported": "Gruppo importato da Entra ID",
    "EntraIdSyncFailed": "Sincronizzazione Entra ID non riuscita",
    "SetFolderPassword": "Password cartella impostata",
    "RemoveFolderPassword": "Password cartella rimossa",
    "FolderPasswordVerified": "Password cartella verificata",
    "FolderPasswordFailed": "Verifica password cartella non riuscita",
    "FolderPasswordLockout": "Blocco per troppi tentativi password cartella",
    "FolderPasswordSessionRevoked": "Sessione password cartella revocata",
    "FolderPasswordResetOtpRequested": "OTP reset password cartella richiesto",
    "FolderPasswordResetWithOtp": "Reset password cartella con OTP",
    "FolderPasswordResetOtpFailed": "Reset password cartella con OTP non riuscito",
    "TotpExemptionGranted": "Esenzione TOTP concessa",
    "TotpExemptionRevoked": "Esenzione TOTP revocata",
    "TotpExemptionExpired": "Esenzione TOTP scaduta",
    "TransferOwnership": "Proprietà trasferita",
    "TransferOwnershipFailed": "Trasferimento proprietà non riuscito",
    "UserLoginTokenCreated": "Token di accesso creato",
    "UserLoginTokenDeleted": "Token di accesso eliminato",
    "UserLoginTokenStatusChanged": "Stato token di accesso modificato",
    "UserLoginTokenUsed": "Accesso con token di accesso",
    "UserLoginTokenFailed": "Autenticazione con token di accesso non riuscita",
    "PasskeyRegistered": "Passkey registrata",
    "PasskeyRemoved": "Passkey rimossa",
    "PasskeyRemovedByAdmin": "Passkey rimossa dall'amministratore",
    "PasskeyAuthenticationFailed": "Autenticazione passkey non riuscita",
    "PasskeyPasswordlessLogin": "Accesso senza password con passkey",
    "PasskeyBlocked": "Passkey bloccata",
    "SharePointFileEncrypted": "File SharePoint cifrato",
    "SharePointFileEncryptionFailed": "Cifratura del file SharePoint non riuscita",
    "SharePointFileEncryptionSkipped": "File SharePoint ignorato",
    "SharePointScanCycleCompleted": "Ciclo di scansione SharePoint completato",
    "SharePointScanCycleFailed": "Ciclo di scansione SharePoint non riuscito",
    "SharePointConnectionTested": "Connessione SharePoint verificata",
    "SharePointConnectionTestFailed": "Verifica della connessione SharePoint non riuscita",
    "SharePointPerimeterBrowsed": "Perimetro SharePoint esplorato",
    "SharePointViewerTokenIssued": "Token viewer SharePoint emesso",
    "SharePointViewerTokenDenied": "Token viewer SharePoint rifiutato",
    "SharePointEditSessionOpened": "Sessione di modifica SharePoint aperta",
    "SharePointEditSessionDenied": "Sessione di modifica SharePoint rifiutata",
    "SharePointFileEdited": "File SharePoint modificato",
    "DirectorySyncUserDisabled": "Sincronizzazione directory ha disabilitato utente",
    "DirectorySyncUserEnabled": "Sincronizzazione directory ha riabilitato utente",
    "DirectorySyncGroupMembersChanged": "Sincronizzazione directory ha modificato i membri del gruppo",
    "DirectorySyncStarted": "Sincronizzazione directory avviata",
    "DirectorySyncCompleted": "Sincronizzazione directory completata",
    "DirectorySyncFailed": "Sincronizzazione directory non riuscita",
    "DirectorySyncUserImported": "Utente importato dalla sincronizzazione directory",
    "DirectorySyncGroupImported": "Gruppo importato dalla sincronizzazione directory",
    "DirectorySyncConnectionTested": "Connessione directory verificata"
  },
  "activityLogTargetTypes": {
    "File": "File",
    "Folder": "Cartella",
    "Files": "File",
    "FilesAndFolders": "File e cartelle",
    "FilesAndTags": "File e tag",
    "FilesFoldersAndTags": "File, cartelle e tag",
    "User": "Utente",
    "Group": "Gruppo",
    "Share": "Voce di condivisione",
    "ShareLink": "Link di condivisione",
    "Version": "Versione di un file o documento",
    "Comment": "Commento su un documento o file",
    "Task": "Attività assegnata in collaborazione",
    "Permission": "Permesso",
    "AccessControl": "Voci di controllo accessi",
    "Admin": "Operazioni amministrative",
    "Configuration": "Configurazione di sistema",
    "Setting": "Impostazione",
    "Tag": "Tag/etichetta",
    "Metadata": "Voce di metadati",
    "Notification": "Notifica",
    "Workflow": "Workflow/processo",
    "Template": "Modello per documenti/file",
    "AuditLog": "Registro di controllo",
    "Security": "Target relativi alla sicurezza",
    "Monitoring": "Monitoraggio e logging",
    "Authentication": "Autenticazione",
    "TwoFactorAuth": "Autenticazione a due fattori",
    "Session": "Sessione o token utente",
    "Encryption": "Cifratura",
    "EncryptionKey": "Gestione chiavi di cifratura",
    "Payment": "Pagamento o transazione",
    "Company": "Azienda o tenant",
    "Certificate": "Certificato RSA per accesso enterprise",
    "AccessRule": "Regola di controllo accessi",
    "IdentityProvider": "Identity provider (es. Microsoft, Google)",
    "AIAgent": "Agente di classificazione IA",
    "AIChat": "Conversazione chat IA",
    "Batch": "Operazione batch",
    "Report": "Report esecutivo o altro",
    "Other": "Altri target generici",
    "GroupsList": "Gruppi",
    "UsersList": "Utenti",
    "SpecialFolder": "Cartella speciale",
    "SettingsList": "Impostazioni",
    "Email": "Email",
    "SharePointFile": "File SharePoint"
  },
  "realtime": {
    "connected": "Connesso",
    "connecting": "Connessione…",
    "disconnected": "Disconnesso",
    "reconnecting": "Riconnessione…"
  },
  "settings": {
    "settings": "Impostazioni",
    "unavailable": "Setting non disponibili al momento",
    "retry": "Clicca per riprovare",
    "authentication": "Autenticazione",
    "saveCard": {
      "message": "Clicca su <strong>Salva</strong> quando hai completato le modifiche."
    },
    "informations": "Informazioni",
    "preview": "Anteprima",
    "externalUserEnforcement": "Enforcement for external users",
    "externalUserEnforcementDescription": "Enforce viewing in Anti-Capture mode for all external users.",
    "tagBasedEncryption": "Tag-Based Encryption",
    "tagBasedEncryptionDescription": "Enforce viewing in Anti-Capture mode for files with specific tags.",
    "tagBasedEncryptionPlaceholder": "Tags (comma separated), - e.g. 'confidential, secret'",
    "companyBranding": {
      "title": "Branding azienda",
      "description": "Personalizza l'aspetto della piattaforma con il branding della tua azienda. Questo include l'impostazione del logo, dei colori e altri elementi visivi che verranno mostrati agli utenti.",
      "companyName": "Nome azienda",
      "preferredLanguage": "Lingua preferita",
      "companyLogos": "Loghi azienda",
      "companyLogosDescription": "La dimensione del file non può essere maggiore di 1MB",
      "loginPageLogo": "Logo pagina di login",
      "loginPageLogoDescription": "Imposta il logo che verrà mostrato sulla pagina di login per gli utenti. Suggerimenti: logo quadrato o orizzontale con sfondo trasparente con larghezza massima di 200px.",
      "topBarLogo": "Logo barra superiore",
      "topBarLogoDescription": "Imposta il logo che verrà mostrato sulla barra superiore della piattaforma. Suggerimenti: logo quadrato o orizzontale con sfondo trasparente.",
      "emailNotificationLogo": "Logo notifica email",
      "emailNotificationLogoDescription": "Imposta il logo da utilizzare nelle notifiche email inviate agli utenti.",
      "quickShareBackground": "Quick Share Background",
      "quickShareBackgroundDescription": "Imposta l'immagine di sfondo che verrà mostrato sulla pagina di quick share. Dimensione suggerita: 1200x1920 pixel",
      "companyColors": "Colori azienda",
      "topBarColors": "Colori barra superiore",
      "topBarColorsDescription": "Imposta il colore di sfondo e testo per la barra superiore della piattaforma.",
      "mainButtonsColors": "Colori pulsanti principali",
      "mainButtonsColorsDescription": "Imposta il colore di sfondo e testo per il pulsante principale.",
      "loginPageTitle": "Titolo pagina di login",
      "loginPageSubtitle": "Sottotitolo pagina di login",
      "loginTermsAndConditions": "Termini e condizioni di login",
      "loginPagePreview": "Anteprima della pagina di login e barra superiore",
      "mainButtonsPreview": "Anteprima testi e colori pulsanti principali",
      "emailNotificationsPreview": "Anteprima notifiche email",
      "quickSharePreview": "Anteprima sfondo quick share",
      "addLogo": "Aggiungi logo"
    },
    "emailCustomizations": {
      "title": "Personalizzazione email",
      "description": "Personalizza i template HTML utilizzati per le notifiche email inviate dalla piattaforma.",
      "language": "Lingua",
      "noTemplates": "Nessun template email disponibile",
      "subject": "Oggetto",
      "availablePlaceholders": "Segnaposto disponibili (clicca per inserire)",
      "preview": "Anteprima",
      "customized": "Personalizzato",
      "default": "Predefinito",
      "resetToDefault": "Ripristina predefinito",
      "resetTitle": "Ripristina template",
      "resetConfirm": "Ripristina",
      "resetConfirmDescription": "Le personalizzazioni verranno rimosse e il template verrà ripristinato a quello predefinito. Questa azione non può essere annullata.",
      "resetSuccess": "Template ripristinato",
      "resetError": "Errore nel ripristino del template",
      "saveSuccess": "Template salvato con successo",
      "saveError": "Errore nel salvataggio del template",
      "sendTest": "Invia Email di Test",
      "testSuccess": "Email di test inviata",
      "testError": "Errore nell'invio dell'email di test"
    },
    "downloadRestrictions": {
      "title": "Imposizione cifratura download",
      "description": "Controlla le impostazioni per le restrizioni di download per tutti i membri. Questo include l'imposizione della cifratura sui download, l'applicazione di regole specifiche per gli utenti esterni e l'override di queste impostazioni in base ai tag dei file.",
      "activeForAllTitle": "Ambito Utente",
      "activeForAllDescription": "Imponi la cifratura download per i membri che hanno già i permessi di download, sia perché sono proprietari o hanno ricevuto i permessi di modifica. Se non è abilitato, i download funzioneranno normalmente dove applicabile.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "externalUserEnforcementTitle": "Enforcement for external users",
      "externalUserEnforcementDescription": "Enforce download encryption for all external users",
      "tagBasedEncryptionTitle": "Cifratura basata su tag",
      "tagBasedEncryptionDescription": "Forza download cifrato con tag specifici",
      "tagBasedEncryptionPlaceholder": "Tags (comma separated), - e.g. 'confidential, secret'",
      "exceptionsRequiredForTags": "Le eccezioni sono richieste per impostare i tag",
      "tagsRequired": "Almeno un tag è richiesto quando ci sono più regole"
    },
    "downloadAllowedTags": {
      "title": "Tag consentiti per il download",
      "description": "Consente ai membri di scaricare i documenti condivisi con permessi di sola lettura.",
      "activeForAllTitle": "Ambito Utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti alle restrizioni impostate dall'amministratore. Questa impostazione può definire l'ambito dei permessi, le condizioni di applicazione e le eventuali eccezioni consentite.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica i membri che sono eccezioni alle restrizioni sopra indicate.",
      "externalUserEnforcementTitle": "Enforcement for external users",
      "externalUserEnforcementDescription": "Enforce download encryption for all external users",
      "tagsTitle": "Tag",
      "tagsDescription": "Abilita il download per i file in sola lettura solo per i file con questi tag.",
      "tagsPlaceholder": "Tag (separati da virgola), es. 'confidenziale, segreto'",
      "tagsRequired": "Almeno un tag è richiesto quando ci sono più regole"
    },
    "forcedAntiCaptureMode": {
      "title": "Modalità Anti-Capture forzata",
      "description": "Imponi la visualizzazione dei file condivisi con tag specifici solo in modalità Anti-Capture.",
      "forcedAntiCaptureModeTitle": "Imposizione Anti-Capture",
      "forcedAntiCaptureModeDescription": "Seleziona se applicare Anti-Capture a tutti o nessuno. L'abilitazione di Anti-Capture attiverà anche il download sicuro dei file.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "tagBasedEncryptionTitle": "Cifratura basata su tag",
      "tagBasedEncryptionDescription": "Applica questa regola solo ai file con tag specifici"
    },
    "aiTagging": {
      "title": "Tagging AI",
      "description": "Abilita il tagging AI per i file. Questo permetterà di assegnare automaticamente i tag ai file in base al loro contenuto.",
      "descriptionInternal": "Abilita il tagging AI per i file. Questo permetterà di assegnare automaticamente i tag ai file in base al loro contenuto. <DangerText>Nota: questo si applica solo ai file di dimensione inferiore a 250 MB. Le modifiche a queste impostazioni NON vengono applicate retroattivamente, il che significa che i file con tag esistenti non verranno classificati automaticamente.</DangerText>",
      "isRuleEnabledTitle": "Abilita regola tagging AI",
      "isRuleEnabledDescription": "Abilita la possibilità per gli utenti (Amministratori e Collaboratori) di far etichettare i propri file dall'AI in base al loro contenuto.",
      "isAutomaticClassificationEnabledTitle": "Abilita classificazione automatica",
      "isAutomaticClassificationEnabledDescription": "Abilita la classificazione automatica dei file in base al loro contenuto.",
      "ruleTargetTitle": "Target della regola",
      "ruleTargetDescription": "Seleziona il target della regola.",
      "tagsTitle": "Tag",
      "tagsDescription": "Applica questa regola solo ai file con tag specifici",
      "aiAgentTitle": "Agente AI",
      "aiAgentDescription": "Seleziona l'agente AI da utilizzare per il tagging dei file.",
      "aiAgentPlaceholder": "Seleziona un agente AI",
      "membersTitle": "Chi può classificare con l'agente selezionato",
      "membersDescription": "Scegli quali membri l'agente selezionato si applica.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Aggiungi gli utenti che non vuoi che abbiano la classificazione automatica",
      "exceptionsButtonText": "Gestisci utenti",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "filesTypeTitle": "Gestione estensione file",
      "filesTypeDescription": "Specifica le estensioni di file da classificare dall'agente selezionato.",
      "externalUserTitle": "Utente esterno",
      "externalUserDescription": "Consenti la classificazione da parte degli utenti esterni.",
      "filesTypePlaceholder": "Seleziona una o più",
      "folderIdsTitle": "Cartelle da classificare",
      "folderIdsDescription": "Seleziona le cartelle da classificare dall'agente selezionato."
    },
    "singleSignOn": {
      "title": "Single sign-on (SSO)",
      "enableTitle": "Abilita Single Sign-On",
      "description": "Abilita Single Sign-On (SSO) per la tua organizzazione. Questo permetterà ai tuoi utenti di accedere a Filegrant Enterprise utilizzando le loro credenziali esistenti da un provider di identità supportato.",
      "providers": "Providers",
      "providersDescription": "Seleziona i provider che vuoi abilitare per Single Sign-On (SSO).",
      "google": "Google",
      "microsoft": "Microsoft",
      "cybergrant": "CyberGrant",
      "notificationSsoEnableMessage": "La funzione Single Sign-On (SSO) sta per essere abilitata. Questo processo potrebbe richiedere alcuni minuti per completare. Per favore, rimani su questa pagina fino al completamento del processo.",
      "notificationSsoEnabledMessage": "La funzione Single Sign-On (SSO) è stata abilitata con successo.",
      "copyRedirectUriHint": "Copialo e aggiungilo nella configurazione del tuo IdP.",
      "redirectUri": "Redirect URI",
      "copyRedirectUriDesc": "Copialo e aggiungilo nella configurazione del tuo IdP.",
      "notificationSsoEnableTimeout": "Errore abilitazione SSO",
      "notificationSsoEnableTimeoutDesc": "Non è stato possibile abilitare la funzione Single Sign-On (SSO). Per favore, prova di nuovo.",
      "domainAlreadySet": "Questo dominio è già configurato",
      "mobileRedirectUri": "Redirect URI Mobile",
      "mobileRedirectUriHint": "Aggiungi questo redirect URI solo se vuoi abilitare l'SSO sull'app mobile.",
      "clientCertificate": "Certificato client",
      "certificateInUse": "Certificato in uso",
      "certificateThumbprint": "Impronta",
      "certificateExpiresAt": "Scadenza",
      "certificateExpired": "Questo certificato è scaduto il {{date}}. L'accesso SSO e la sync Entra ID falliranno finché non lo sostituisci.",
      "certificateExpiringSoon": "Questo certificato scade il {{date}} (tra {{days}} giorni).",
      "certificateTooLarge": "Il file del certificato è troppo grande. Usa un PKCS#12 (.pfx/.p12) entro il limite.",
      "certificateReadyToUpload": "Nuovo certificato selezionato. Inserisci la password (lascia vuota se assente) e salva.",
      "uploadCertificate": "Carica certificato",
      "replaceCertificate": "Sostituisci certificato",
      "clearCertificate": "Rimuovi certificato",
      "certificatePassword": "Password del certificato",
      "certificatePasswordHint": "Inserisci la password PKCS#12 a ogni nuovo upload; la password memorizzata non viene mai riusata. Lascia vuota se il file non ha password.",
      "certificatePasswordPlaceholder": "Password PKCS#12 (opzionale)",
      "noCredentialsWarning": "Nessun client secret o certificato configurato. Aggiungi almeno una credenziale prima di abilitare questo provider.",
      "clientIdChangeWarning": "Client ID modificato. Invia un nuovo client secret e/o ricarica il certificato, altrimenti le credenziali mascherate verranno cancellate.",
      "clientIdChangeBlocksSave": "Impossibile salvare: client ID modificato mantenendo credenziali mascherate",
      "clientIdChangeBlocksSaveHint": "Configurazione Microsoft {{index}}: inserisci un nuovo client secret e/o carica un certificato prima di salvare.",
      "certificateProblemEntry": "{{provider}} — configurazione {{index}}: {{message}}",
      "errors": {
        "certificateInvalid": "Il certificato client non è stato accettato",
        "certificateNotSupported": "I certificati non sono supportati per questo provider",
        "invalidConfiguration": "Configurazione Single Sign-On non valida"
      }
    },
    "fileDeletionRestriction": {
      "title": "Restrizione cancellazione file",
      "description": "Abilita il controllo granulare sull’eliminazione dei file da parte degli utenti. Questa impostazione consente di definire le autorizzazioni di eliminazione in base al ruolo dell’utente rispetto al file: creatore, proprietario o destinatario. Garantisce regole di gestione dei contenuti chiare e sicure, prevenendo eliminazioni non autorizzate e supportando la conformità alle politiche organizzative.",
      "allowDeletionFor": "Consenti la cancellazione per",
      "allowDeletionForDescription": "Scegli se tutti o nessuno degli utenti è autorizzato a cancellare i file.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "fileAccessTypeTitle": "Tipi di accesso autorizzati",
      "fileAccessTypeDescription": "Seleziona i tipi di accesso file/cartella che sono autorizzati a cancellare il file.",
      "owner": "Proprietario",
      "creator": "Creatore",
      "receiver": "Ricevente"
    },
    "adminRegisteredMemberVisibility": {
      "title": "Visibilità membri registrati amministratore",
      "description": "Controlla la visibilità dei membri registrati amministratore o gruppi agli utenti. Le opzioni includono consentire a tutti gli utenti di vedere i membri registrati amministratore o nessuno. La visibilità è principalmente attraverso la condivisione di file. Quando un utente condivide un file con un indirizzo email corrispondente a un membro registrato amministratore, l'utente vedrà il nome e il cognome del membro dopo la condivisione, anche se l'utente non ha il permesso di vedere i membri registrati amministratore come previsto da questa impostazione. Questa limitazione non si applica agli utenti o gruppi ai quali è stato assegnato lo stato Privato.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "sectionTitle": "Limiti di visibilità utente",
      "visibilityTitle": "Visibilità membri registrati amministratore",
      "visibilityDescription": "Controlla la visibilità dei membri registrati amministratore o gruppi agli utenti. Le opzioni includono consentire a tutti gli utenti di vedere i membri registrati amministratore o nessuno. La visibilità è principalmente attraverso la condivisione di file. Quando un utente condivide un file con un indirizzo email corrispondente a un membro registrato amministratore, l'utente vedrà il nome e il cognome del membro dopo la condivisione, anche se l'utente non ha il permesso di vedere i membri registrati amministratore come previsto da questa impostazione. Questa limitazione non si applica agli utenti o gruppi ai quali è stato assegnato lo stato Privato."
    },
    "aiFileSummary": {
      "title": "Riepilogo file AI",
      "description": "Abilita il riepilogo file AI per i file. Questo permetterà di generare automaticamente un riepilogo del file in base al suo contenuto.",
      "descriptionInternal": "Abilita il riepilogo file AI per i file. Questo permetterà di generare automaticamente un riepilogo del file in base al suo contenuto. <DangerText>Nota: questo si applica solo ai file di dimensione inferiore a 250 MB.</DangerText>",
      "activeForAllTitle": "Accesso riepilogo file AI",
      "activeForAllDescription": "Scegli se i riepiloghi file AI sono disponibili per tutti gli utenti o per nessuno.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "externalUserTitle": "Utente esterno",
      "externalUserDescription": "Consenti la generazione di riepiloghi da parte degli utenti esterni.",
      "filesTypeTitle": "Gestione estensione file",
      "filesTypeDescription": "Specifica le estensioni di file da riepilogare dall'AI.",
      "filesTypePlaceholder": "Seleziona una o più"
    },
    "aiFileChat": {
      "title": "Chat file AI",
      "description": "Abilita il chat file AI per i file. Questo permetterà agli utenti di chattare con il contenuto del file.",
      "descriptionInternal": "Abilita il chat file AI per i file. Questo permetterà agli utenti di chattare con il contenuto del file. <DangerText>Nota: questo si applica solo ai file di dimensione inferiore a 250 MB.</DangerText>",
      "activeForAllTitle": "Accesso chat file AI",
      "activeForAllDescription": "Scegli se il chat file AI è disponibile per tutti gli utenti o per nessuno.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "externalUserTitle": "Utente esterno",
      "externalUserDescription": "Consenti il chat con il contenuto del file da parte degli utenti esterni.",
      "filesTypeTitle": "Gestione estensione file",
      "filesTypeDescription": "Specifica le estensioni di file da chattare con l'AI.",
      "filesTypePlaceholder": "Seleziona una o più"
    },
    "aiScraping": {
      "title": "Scraping AI",
      "description": "Disabilita lo scraping AI per i file. Questo proibirà a qualsiasi strumento di IA per estrarre il contenuto del file.",
      "descriptionInternal": "Disabilita lo scraping AI per i file. Questo proibirà a qualsiasi strumento di IA per estrarre il contenuto del file. <DangerText>Nota: lo scraping AI è applicato solo ai file aperti in modalità Read-Only e di dimensione inferiore a 250 MB. La protezione da scraping è attiva al momento solo sui file PDF e Office.</DangerText>",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti alle restrizioni impostate dall'amministratore. Questa impostazione può definire l'ambito delle autorizzazioni, le condizioni in cui si applicano e le eventuali eccezioni consentite.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "externalUserTitle": "Utente esterno",
      "externalUserDescription": "Consenti il scraping del contenuto del file da parte degli utenti esterni.",
      "tagsTitle": "Tags",
      "tagsDescription": "Applica queste regole solo a file con tag specifici",
      "exceptionsRequiredForTags": "Le eccezioni sono richieste per impostare i tag"
    },
    "onBehalfMode": {
      "title": "Modalità on behalf",
      "description": "Controlla la modalità on behalf per la piattaforma. Questo permetterà di specificare quali collaboratori possono eseguire azioni on behalf di altri collaboratori.",
      "internalTitle": "Azioni amministratore on behalf di utenti",
      "internalDescription": "Gli amministratori autorizzati possono visualizzare la lista dei file dei collaboratori e eseguire le azioni necessarie come spostare, eliminare o condividere file on behalf degli utenti. Tuttavia, non possono aprire o visualizzare il contenuto dei file, mantenendo la privacy degli utenti. Solo l'amministratore superiore ha il potere di abilitare o disabilitare questa funzione per gli amministratori individuali. Questo garantisce che solo gli amministratori fidati abbiano la capacità di gestire i file degli utenti",
      "activeForAllTitle": "Scopo amministratori",
      "activeForAllDescription": "Controlla la possibilità di definire se gli amministratori possono eseguire azioni on behalf di tutti gli utenti o nessuno. Questa impostazione permette di specificare se gli amministratori hanno il permesso di gestire i file e di eseguire task on behalf di altri utenti all'interno della piattaforma.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Gli amministratori selezionati qui saranno eccezioni alle sopra menzionate autorizzazioni 'on behalf'."
    },
    "fileSalesPermission": {
      "title": "Permesso vendita file",
      "description": "Consenti agli utenti di vendere i loro file attraverso la piattaforma.",
      "internalTitle": "Abilita vendita file per membri",
      "activeForAllTitle": "Scopo utenti",
      "activeForAllDescription": "Consenti ai membri di vendere i loro file attraverso la piattaforma. Le opzioni includono abilitare questa funzione per tutti i membri o nessuno. I file elencati per la vendita saranno gestiti dalla piattaforma, garantendo transazioni sicure e un corretto trattamento dei pagamenti.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni alla sopra menzionata funzione.",
      "externalUserTitle": "Utente esterno",
      "externalUserDescription": "Consenti la vendita di file da parte degli utenti esterni."
    },
    "resharingPermission": {
      "title": "Permesso di ricondivisione file",
      "description": "Consenti agli utenti di ricondividere i file con altri, applicando regole basate su opzioni predefinite e sui tag associati a ciascun file. Questo garantisce una distribuzione controllata dei contenuti e aiuta a mantenere la conformità con le politiche organizzative.",
      "activeForAllTitle": "Scopo utenti",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti a restrizioni sulla condivisione di file con specifiche opzioni e tag impostati dall'amministratore. Le opzioni includono applicare questo permesso a tutti gli utenti o a nessuno. I file già condivisi rimarranno attivi e le modifiche ai tag non influiranno su questi file già condivisi.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni alla sopra menzionata regola.",
      "showUsers": "Mostra gli utenti che hanno già ricevuto accesso da altri.",
      "allowEdit": "Consenti agli utenti di modificare, sovrascrivere o eliminare le impostazioni di condivisione esistenti.",
      "readOnly": "Abilita la condivisione di file dagli utenti con accesso in sola lettura (Visualizzatore).",
      "tagsTitle": "Tags",
      "tagsDescription": "Applica queste regole solo ai file con tag specifici",
      "exceptionsRequiredForTags": "Le eccezioni sono richieste per impostare i tag"
    },
    "fileVersioningRetentionPolicies": {
      "title": "Versioning file",
      "description": "Configura come vengono conservate le versioni dei file. Il numero di versioni da mantenere è obbligatorio, mentre l’età di conservazione è facoltativa e può essere impostata a 0.",
      "retentionByCountTitle": "Conservazione per numero",
      "retentionByCountDescription": "Imposta la conservazione per numero – mantieni solo le ultime N versioni di ogni file; le versioni più vecchie vengono automaticamente eliminate una volta raggiunto questo limite",
      "retentionByAgeTitle": "Conservazione per età",
      "retentionByAgeDescription": "Imposta la conservazione per età – elimina le versioni più vecchie di N giorni; qualsiasi snapshot che eccede questa età verrà automaticamente eliminato per evitare l'aumento dello spazio di archiviazione"
    },
    "retentionPolicies": {
      "title": "Politiche di retention",
      "description": "Configura per quanto tempo i file vengono mantenuti sulla piattaforma. Gestisci la cancellazione automatica dal cestino e definisci le regole di retention per i file attivi.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "trash": {
        "title": "Conservazione cestino",
        "description": "I file spostati nel cestino vengono eliminati definitivamente dopo il numero di giorni configurato.",
        "activeForAllTitle": "Ambito retention cestino",
        "activeForAllDescription": "Scegli se la retention del cestino si applica a tutti gli utenti o a nessuno. I valori della policy sotto restano modificabili; usa la lista eccezioni per escludere utenti o gruppi specifici.",
        "retentionDaysTitle": "Giorni nel Cestino",
        "retentionDaysDescription": "Giorni di permanenza nel cestino prima della cancellazione definitiva. Deve essere maggiore di 0.",
        "exceptionHandlingDescription": "Gli utenti e i gruppi in questa lista non sono soggetti alla retention del cestino: i loro file restano nel cestino indefinitamente."
      },
      "files": {
        "title": "Conservazione file",
        "description": "Applica una regola di retention ai file attivi. Il periodo è calcolato dalla data scelta sotto (creazione o ultima modifica).",
        "activeForAllTitle": "Ambito retention file",
        "activeForAllDescription": "Scegli se la retention dei file si applica a tutti gli utenti o a nessuno. I valori della policy sotto restano modificabili; usa la lista eccezioni per escludere utenti o gruppi specifici.",
        "retentionDaysTitle": "Periodo di Retention (giorni)",
        "retentionDaysDescription": "Numero di giorni dalla data di riferimento scelta (creazione o modifica) dopo i quali si attiva l'azione. Deve essere maggiore di 0.",
        "retentionTriggerTitle": "Calcola retention da",
        "retentionTriggerDescription": "Scegli se il periodo di retention si calcola dalla creazione del file o dall'ultima modifica.",
        "retentionTrigger": {
          "created_at": "Data di creazione del file",
          "updated_at": "Data dell'ultima modifica"
        },
        "actionOnExpiryTitle": "Azione alla Scadenza",
        "actionOnExpiryDescription": "Cosa succede ai file che superano il periodo di retention.",
        "actionOnExpiry": {
          "MoveToTrash": "Sposta nel cestino",
          "DeletePermanently": "Cancella definitivamente",
          "RetainedTagWorkflow": "Applica tag *RETAINED, poi cancella"
        },
        "retainedTag": {
          "title": "Come funziona il tag *RETAINED",
          "step1": "Al salvataggio della policy il server crea un tag di sistema chiamato *RETAINED (visibile nella lista dei tag aziendali ma in sola lettura).",
          "step2": "Trascorso il periodo di retention impostato sopra, il tag *RETAINED viene applicato automaticamente a tutti i file creati da più giorni di quelli configurati.",
          "step3": "Una volta taggato il file resta accessibile, ma il tag non può essere rimosso da nessuno: la UI nasconde il controllo per staccarlo e il server rifiuta qualsiasi tentativo di rimozione di un tag di sistema.",
          "step4": "Quando passano i giorni indicati sotto dall'applicazione del tag, il file viene cancellato definitivamente (DB + storage). Aggiungi utenti o gruppi nelle eccezioni per escluderli dall'intero flusso."
        },
        "retainedTagDaysTitle": "Giorni con tag *RETAINED",
        "retainedTagDaysDescription": "Dopo l'applicazione del tag *RETAINED, i file vengono cancellati definitivamente dopo questo numero di giorni. Deve essere maggiore di 0.",
        "tagsTitle": "Applica solo ai file con questi tag",
        "tagsDescription": "Lascia vuoto per applicare la policy a tutti i file. Sono supportati solo tag pubblici.",
        "exceptionHandlingDescription": "Gli utenti e i gruppi in questa lista non sono soggetti alla retention dei file: i loro file non vengono mai spostati nel cestino, eliminati o taggati come *RETAINED."
      },
      "deletePermanentlyConfirm": {
        "title": "Conferma policy di cancellazione definitiva",
        "description": "<DangerText>Questa azione cancellerà DEFINITIVAMENTE tutti i file aziendali che superano il periodo di retention. L'operazione non è reversibile.</DangerText>"
      },
      "deletePermanentlySelectWarning": {
        "title": "Cancellazione definitiva",
        "description": "Con questa azione i file che superano il periodo di retention vengono eliminati in modo permanente. <DangerText>L'operazione è irreversibile e i file eliminati non potranno essere recuperati.</DangerText><br></br>Per procedere, inserisci <DangerText>{{confirmKeyword}}</DangerText> nel campo qui sotto."
      },
      "errors": {
        "trashRetentionDays": "I giorni nel cestino devono essere maggiori di 0.",
        "retentionDays": "Il periodo di retention deve essere maggiore di 0.",
        "retainedTagDays": "I giorni con tag *RETAINED devono essere maggiori di 0."
      }
    },
    "mandatoryExpirationSharedFile": {
      "title": "Scadenza obbligatoria file condiviso",
      "description": "Controlla la scadenza obbligatoria dei file condivisi. Questo permetterà di specificare quali file condivisi devono avere una data di scadenza.",
      "descriptionInternal": "Questa sezione impone limiti di tempo alla condivisione di file per evitare accesso indefinito. Gli amministratori possono richiedere una data di scadenza per ogni file condiviso, impostare una durata massima consentita e bloccare le condivisioni senza data di scadenza. Queste regole garantiscono che l'accesso condiviso sia temporaneo e allineato ai requisiti di sicurezza e conformità. <DangerText> I cambiamenti a queste impostazioni NON vengono applicati retroattivamente, il che significa che le condivisioni che eccedono i nuovi limiti NON verranno aggiornate.</DangerText>",
      "activeForAllTitle": "Utenti coinvolti",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti a restrizioni impostate dall'amministratore. Questa impostazione può definire l'ambito dei permessi, le condizioni sotto le quali si applicano e qualsiasi eccezione consentita. Questo garantisce che l'attività dell'utente rimanga allineata alle politiche organizzazionali mentre ancora permette la flessibilità dove opportuno.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "maxAllowedByAgeTitle": "Durata Massima Consentita",
      "maxAllowedByAgeDescription": "Imposta un limite di durata massima (ad esempio, 90 giorni) per qualsiasi condivisione di file.",
      "excludedDomainsTitle": "Domini esclusi",
      "excludedDomainsDescription": "Le condivisioni verso questi domini esatti non richiedono una data di scadenza. Inserisci solo domini (es. company.com), senza wildcard né URL. Lascia vuoto per nessuna esenzione.",
      "excludedDomainsPlaceholder": "Nessun dominio escluso, clicca per aggiungere",
      "excludedGroupsTitle": "Gruppi esclusi",
      "excludedGroupsDescription": "Le condivisioni verso gruppi possono essere esenti dalla scadenza obbligatoria. Scegli nessuno, tutti i gruppi o gruppi specifici. L'appartenenza di un utente a un gruppo esente non esenta le condivisioni utente.",
      "excludedGroupsModeNone": "Nessun gruppo esente",
      "excludedGroupsModeAll": "Tutti i gruppi esenti",
      "excludedGroupsModeSome": "Solo i gruppi selezionati esenti",
      "excludedGroupsPlaceholder": "Seleziona i gruppi esenti",
      "excludedGroupsExceptionsTitle": "Gruppi che restano soggetti",
      "excludedGroupsExceptionsPlaceholder": "Seleziona i gruppi che richiedono ancora la scadenza",
      "tagsTitle": "Tags",
      "tagsDescription": "Applica il limite di tempo di condivisione solo a file con tag specifici.",
      "tagsRequired": "Almeno un tag è richiesto quando ci sono più regole",
      "exceptionsRequiredForTags": "Le eccezioni sono richieste per impostare i tag"
    },
    "fileTagManagement": {
      "title": "Regole di rimozione tag",
      "description": "Definisci quali tag non possono essere rimossi dai file. Gli utenti soggetti a una regola non possono rimuovere i tag selezionati dai file; è possibile concedere eccezioni alla regola per utente o gruppo.",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti a restrizioni sulla rimozione dei tag come definito dall'amministratore. I tag esistenti sui file rimarranno invariati, e le modifiche ai permessi non influiranno sui tag precedentemente applicati.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni alla sopra menzionata regola.",
      "tagsTitle": "Tags",
      "tagsDescription": "Tag che non possono essere rimossi dai file. Lascia vuoto per proteggere tutti i tag.",
      "tagsRequired": "Almeno un tag è richiesto quando ci sono più regole"
    },
    "fileTagAdditionRestriction": {
      "title": "Regole di aggiunta tag",
      "description": "Definisci quali tag non possono essere aggiunti ai file. Gli utenti soggetti a una regola non possono aggiungere i tag selezionati ai file; è possibile concedere eccezioni alla regola per utente o gruppo.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni alla sopra menzionata regola.",
      "tagsTitle": "Tags",
      "tagsDescription": "Tag che non possono essere aggiunti ai file. Lascia vuoto per limitare tutti i tag.",
      "tagsRequired": "Almeno un tag è richiesto quando ci sono più regole"
    },
    "externalFileSharingRestriction": {
      "title": "Restrizioni condivisione esterna",
      "description": "Questa sezione consente agli amministratori di decidere se i collaboratori possono condividere file all’esterno dell’organizzazione e a quali condizioni. La condivisione può essere completamente abilitata, disabilitata o limitata a domini specifici considerati attendibili. Le regole possono inoltre limitare la condivisione esterna in base ai tag dei file o consentire a determinati mittenti e destinatari di ignorare le politiche di Data Loss Prevention (DLP). Questi controlli aiutano a proteggere le informazioni riservate e garantiscono che le collaborazioni esterne avvengano solo con parti approvate.",
      "descriptionInternal": "Questa sezione consente agli amministratori di decidere se i collaboratori possono condividere file all’esterno dell’organizzazione e a quali condizioni. La condivisione può essere completamente abilitata, disabilitata o limitata a domini specifici considerati attendibili. Le regole possono inoltre limitare la condivisione esterna in base ai tag dei file o consentire a determinati mittenti e destinatari di ignorare le politiche di Data Loss Prevention (DLP). Questi controlli aiutano a proteggere le informazioni riservate e garantiscono che le collaborazioni esterne avvengano solo con parti approvate.",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti a restrizioni impostate dall'amministratore. Questa impostazione può definire l'ambito dei permessi, le condizioni sotto le quali si applicano e qualsiasi eccezione consentita. Questo garantisce che l'attività dell'utente rimanga allineata alle politiche organizzazionali mentre ancora permette la flessibilità dove opportuno.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica i membri che sono eccezioni alla sopra menzionata regola.",
      "approvedDomainsTitle": "Domini Approvati",
      "approvedDomainsDescription": "Limita la condivisione a una lista di domini approvati.",
      "tagsTitle": "Tags",
      "tagsDescription": "Permette la condivisione con domini esterni solo per file che hanno tag specifici.",
      "tagsRequired": "Almeno un tag è richiesto quando ci sono più regole",
      "exceptionsRequiredForTags": "Le eccezioni sono richieste per impostare i tag",
      "approvedDomainsPlaceholder": "Nessun dominio approvato, clicca per aggiungere"
    },
    "secureFileLocalAccess": {
      "title": "Accesso sicuro file locale",
      "description": "Controlla l'accesso sicuro ai file localmente. Questo permetterà di specificare quali file possono essere acceduti localmente.",
      "descriptionInternal": "Questa impostazione definisce come i documenti possono essere aperti localmente (su Windows o macOS) attraverso l'agente in modo sicuro e cifrato. Se un utente ha i permessi richiesti, può aprire file protetti con le applicazioni autorizzate, garantendo la conformità alle politiche di Prevenzione della perdita di dati (DLP).",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti a restrizioni impostate dall'amministratore. Questa impostazione può definire l'ambito dei permessi, le condizioni sotto le quali si applicano e qualsiasi eccezione consentita. Questo garantisce che l'attività dell'utente rimanga allineata alle politiche organizzazionali mentre ancora permette la flessibilità dove opportuno.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica i membri che sono eccezioni alle sopra menzionate restrizioni.",
      "tagsTitle": "Tags",
      "tagsDescription": "Applica queste regole solo a file con tag specifici",
      "tagsRequired": "Almeno un tag è richiesto quando ci sono più regole",
      "exceptionsRequiredForTags": "Le eccezioni sono richieste per impostare i tag",
      "restrictionsTitle": "Restrizioni",
      "restrictionsDescription": "Definisci quali azioni degli utenti sono limitate quando accedono a documenti protetti:",
      "restrictCopyPaste": "Restringi le operazioni di copia-incolla",
      "restrictCopyPasteDescription": "Restringi le operazioni di copia-incolla per file con tag specifici.",
      "restrictPrint": "Restringi la stampa",
      "restrictPrintDescription": "Restringi la stampa per file con tag specifici.",
      "restrictAppInternetAccess": "Restringi l'accesso alla rete dell'app",
      "restrictAppInternetAccessDescription": "Restringi l'accesso alla rete dell'app per file con tag specifici.",
      "restrictScreenCapture": "Restringi la cattura dello schermo",
      "restrictScreenCaptureDescription": "Restringi la cattura dello schermo per file con tag specifici.",
      "localAccessSettingsTitle": "Impostazioni accesso locale",
      "localAccessSettingsDescription": "Configura come gli utenti possono aprire e lavorare con file protetti sui loro dispositivi:",
      "defaultLocalFileOpen": "Apertura file locale predefinita",
      "defaultLocalFileOpenDescription": "Scegli se aprire file protetti con l'applicazione predefinita o con l'applicazione specificata nel campo 'Applicazioni consentite'.",
      "allowedApplicationsTitle": "Applicazioni consentite",
      "allowedApplicationsDescription": "Scegli le applicazioni che sono consentite per aprire file protetti.",
      "offlineMode": "Abilita l'accesso ai file quando non è disponibile la connessione internet",
      "offlineModeDescription": "Salvare il certificato localmente consente il decifrare i file offline. I contenuti dei file possono essere esposti se l'utente locale ha accesso al certificato memorizzato"
    },
    "tagBasedAccessControl": {
      "title": "Visibilità dei file con tag",
      "description": "Gestisci l’accesso ai documenti tramite tag (es. Pubblico), garantendo visibilità a tutti gli utenti o a ospiti esterni, con permessi opzionali di sola lettura o lettura/scrittura e protezione tramite password.",
      "descriptionInternal": "Controlla l’accesso ai documenti usando tag per utenti o gruppi, semplificando ricerca e gestione delle policy. I tag (come Pubblico) possono ampliare la visibilità, sia a tutti gli utenti registrati (Pubblico Interno) sia a ospiti esterni non autenticati (Chiunque), con permessi opzionali di sola lettura o lettura/scrittura e protezione tramite password.",
      "activeForAllTitle": "Ambito utenti",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti alle restrizioni impostate dall'amministratore. Questa impostazione definisce l'ambito dei permessi, le condizioni di applicazione e le eventuali eccezioni. Garantisce che le attività degli utenti restino allineate alle policy organizzative, pur mantenendo flessibilità quando appropriato.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica i membri che costituiscono eccezioni alla regola sopra.",
      "accessPolicyTagsTitle": "Tag delle policy di accesso",
      "accessPolicyTagsDescription": "Definisci quali tag controllano la visibilità e l’accesso ai documenti.",
      "accessPolicyTagsRequired": "I tag delle policy di accesso sono obbligatori",
      "audienceTitle": "Audience",
      "audienceDescription": "Definisci chi può accedere ai documenti con tag.",
      "registeredUsers": "Utenti Registrati",
      "unregisteredUsers": "Utenti Non Registrati",
      "admin": "Amministratore",
      "contributors": "Contributor",
      "readers": "Lettori",
      "external": "Esterni",
      "readAndWrite": "Lettura & Scrittura",
      "readOnly": "Sola Lettura",
      "passwordRequired": "Richiedi password per l’accesso",
      "setLinkExpiration": "Imposta scadenza link (data/ora)",
      "tagsTitle": "Tag",
      "tagsDescription": "Consente la condivisione con domini esterni solo per i file con tag specifici.",
      "tagsRequired": "È richiesto almeno un tag quando ci sono più regole.",
      "exceptionsRequiredForTags": "Le eccezioni sono obbligatorie per impostare i tag."
    },
    "contributorStorageLimit": {
      "title": "Limiti di archiviazione",
      "allocationTitle": "Allocazione archiviazione collaboratore",
      "allocationDescription": "Definisci lo spazio di archiviazione disponibile ai collaboratori per il caricamento e la condivisione di file. Questa opzione consente di impostare limiti di archiviazione specifici per i collaboratori o"
    },
    "deviceAccessLimitation": {
      "title": "Gestione connessioni simultanee",
      "browsersTitle": "Browser",
      "browsersDescription": "Imposta il numero di connessioni simultanee che ogni membro può effettuare a Filegrant Enterprise tramite differenti browser utilizzando l'applicazione web",
      "exceedingConnectionsTitle": "Connessioni browser eccedenti",
      "exceedingConnectionsDescription": "Specifica l'azione da intraprendere quando il numero di browser connessi eccede il limite consentito.",
      "invalidateOldSessionsOption": "Invalidare automaticamente il token di sessione delle connessioni più vecchie.",
      "blockAccessOption": "Nega l'accesso fino a quando le sessioni più vecchie non vengono disconnesse manualmente o scadono."
    },
    "editorFileManagement": {
      "title": "Controllo gestione file collaboratore",
      "subtitle": "Controlla i permessi per i collaboratori per eliminare e rinominare file e cartelle all'interno dei loro account. Le opzioni includono consentire a tutti i collaboratori o nessuno, con azioni limitate ai file che hanno caricato o ricevuto con accesso all'editor.",
      "deletionPermissionsTitle": "Permessi di eliminazione",
      "deletionPermissionsDescription": "Controlla se i collaboratori possono eliminare file. Le opzioni includono consentire o negare ai collaboratori di eliminare file che hanno caricato o ricevuto con accesso all'editor.",
      "userScopeTitle": "Ambito utente",
      "userScopeDescription": "Controlla l'applicazione delle sopra menzionate autorizzazioni a tutti i collaboratori o nessuno.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica gli utenti che sono eccezioni alle sopra menzionate autorizzazioni. Questi utenti avranno accesso personalizzato per eliminare e rinominare file e cartelle indipendentemente dalle impostazioni generali."
    },
    "fileSizeLimit": {
      "title": "Limite dimensione file per membro",
      "limitTitle": "Limite dimensione file",
      "limitDescription": "Definisci la dimensione massima dei file che i membri possono caricare. Questa impostazione consente di controllare la dimensione massima dei file che possono essere aggiunti alla piattaforma da parte di qualsiasi membro, garantendo un uso efficiente dello spazio di archiviazione e mantenendo prestazioni ottimali."
    },
    "quickShareMode": {
      "title": "Quick Share",
      "description": "Gestisci le impostazioni Quick Share. Controlla attivazione, apertura predefinita dopo il login e durata massima della condivisione.",
      "isVisibleTitle": "Visibile",
      "isVisibleDescription": "Abilita o disabilita Quick Share per gli utenti",
      "activeForAllTitle": "Accesso Quick Share",
      "activeForAllDescription": "Scegli se Quick Share è disponibile per tutti gli utenti o per nessuno.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica i membri che sono eccezioni alla regola sopra.",
      "showQuickShareByDefaultTitle": "Mostra Quick Share come predefinito",
      "showQuickShareByDefaultDescription": "Imposta Quick Share come pagina di destinazione predefinita dopo il login",
      "maxSharingDaysTitle": "Durata massima condivisione (giorni)",
      "maxSharingDaysDescription": "Imposta per quanti giorni dura la condivisione. Le condivisioni scadono automaticamente dopo il numero di giorni selezionato (massimo 365).",
      "enabledTitle": "Abilita Quick Share",
      "enabledDescription": "Se abilitata, gli utenti possono condividere file tramite Quick Share. Se disabilitata, la funzione non è disponibile.",
      "daysTitle": "Durata massima della condivisione",
      "daysDescription": "Dopo questo numero di giorni il link del file condiviso scadrà e la condivisione verrà rimossa.",
      "daysOption1": "Condivisione per 1 giorno",
      "daysOption3": "Condivisione per 3 giorni",
      "daysOption7": "Condivisione per 7 giorni",
      "daysOption14": "Condivisione per 14 giorni",
      "daysOption30": "Condivisione per 30 giorni",
      "daysOption90": "Condivisione per 90 giorni"
    },
    "totpRequired": {
      "title": "Autenticazione a due fattori (TOTP)",
      "description": "Configura TOTP 2FA a livello aziendale. Rendi obbligatorio il TOTP per tutti gli utenti, imposta un periodo di tolleranza per i nuovi account e consenti agli admin di resettare il TOTP degli utenti.",
      "requiredTitle": "Richiedi TOTP per tutti gli utenti",
      "requiredDescription": "Se attivato, tutti gli utenti devono configurare il TOTP. I nuovi utenti hanno un periodo di tolleranza per attivarlo dopo la creazione dell'account.",
      "gracePeriodDaysTitle": "Periodo di tolleranza (giorni)",
      "gracePeriodDaysDescription": "Gli utenti hanno questo numero di giorni dalla creazione dell'account per attivare il TOTP prima che l'accesso venga bloccato.",
      "allowAdminResetTitle": "Permetti agli admin di resettare il TOTP degli utenti",
      "allowAdminResetDescription": "Se attivato, gli amministratori possono disabilitare il TOTP per gli utenti che hanno perso l'accesso all'app di autenticazione.",
      "maxExemptionDaysTitle": "Giorni massimi di esenzione",
      "maxExemptionDaysDescription": "Numero massimo di giorni (1–365) per un'esenzione TOTP temporanea quando un admin la concede. Predefinito 30.",
      "allowPermanentExemptionTitle": "Consenti esenzioni permanenti",
      "allowPermanentExemptionDescription": "Se attivato, gli amministratori possono concedere esenzioni TOTP permanenti (senza scadenza). Se disattivato, sono consentite solo esenzioni temporanee.",
      "gracePeriodOption0": "Nessun periodo di tolleranza (immediato)",
      "gracePeriodOption1": "1 giorno",
      "gracePeriodOption3": "3 giorni",
      "gracePeriodOption7": "7 giorni (consigliato)",
      "gracePeriodOption14": "14 giorni",
      "gracePeriodOption30": "30 giorni"
    },
    "passkeySettings": {
      "allowAdminRemoveDescription": "Se attivato, gli amministratori possono rimuovere singole passkey o azzerare tutte le credenziali di un utente dagli strumenti di amministrazione.",
      "allowAdminRemoveTitle": "Consenti agli amministratori di rimuovere le passkey degli utenti",
      "allowAs2faDescription": "Se attivato, gli utenti che completano l'OTP e-mail possono concludere l'accesso con una passkey al posto del TOTP, in base alla registrazione e ad altre policy.",
      "allowAs2faTitle": "Consenti le passkey come secondo fattore",
      "allowPasswordlessDescription": "Se attivato, gli utenti idonei possono accedere con passkey senza OTP e-mail. Richiede che le passkey come secondo fattore siano consentite.",
      "allowPasswordlessTitle": "Consenti accesso senza password con passkey",
      "attestationOptionDirect": "Diretta",
      "attestationOptionIndirect": "Indiretta",
      "attestationOptionNone": "Nessuna (tipica per la maggior parte delle organizzazioni)",
      "attestationPreferenceDescription": "Quanto il server privilegia l'attestazione durante la registrazione. Livelli più alti possono aumentare le garanzie ma ridurre la compatibilità degli autenticatori.",
      "attestationPreferenceTitle": "Preferenza di attestazione",
      "authenticatorAttachmentAny": "Qualsiasi (nessun vincolo)",
      "authenticatorAttachmentCrossPlatform": "Cross-platform (es. security key)",
      "authenticatorAttachmentDescription": "Opzionalmente limita la registrazione agli autenticatori di piattaforma su questo dispositivo, alle security key cross-platform o lascia libero per la massima compatibilità.",
      "authenticatorAttachmentPlatform": "Piattaforma (questo dispositivo)",
      "authenticatorAttachmentTitle": "Tipo di autenticatore (opzionale)",
      "description": "Configura le passkey (WebAuthn) a livello di organizzazione: abilitazione, secondo fattore vs accesso senza password, limiti per utente, rimozione da parte degli admin e preferenze sulla cerimonia di registrazione.",
      "enabledDescription": "Se disattivato, la registrazione delle passkey e l'accesso tramite passkey non sono disponibili per gli utenti coperti da questa policy.",
      "enabledTitle": "Abilita le passkey per l'organizzazione",
      "maxCredentialsPerUserDescription": "Numero massimo di passkey registrabili per utente (1–50). Limita proliferazione e onere di supporto.",
      "maxCredentialsPerUserTitle": "Passkey massime per utente",
      "title": "Passkey (WebAuthn)",
      "userVerificationDescription": "Quanto l'autenticatore deve verificare l'utente durante la registrazione della passkey. Obbligatorio è il più severo; scoraggiato il più debole.",
      "userVerificationOptionDiscouraged": "Scoraggiato",
      "userVerificationOptionPreferred": "Preferito",
      "userVerificationOptionRequired": "Obbligatorio",
      "userVerificationTitle": "Verifica utente in fase di registrazione"
    },
    "antivirusScan": {
      "title": "Scansione antivirus",
      "description": "Configura quali tipi di file caricati vengono analizzati dal motore antivirus. Il filtro estensioni controlla il costo, non la policy di sicurezza.",
      "enabledTitle": "Abilita scansione antivirus",
      "enabledDescription": "Se attivo, i caricamenti corrispondenti vengono analizzati in modo asincrono. Se disattivo, i nuovi caricamenti non vengono analizzati, ma i verdetto esistenti restano sui file.",
      "extensionsTitle": "Estensioni file da scansionare",
      "extensionsDescription": "Solo i file con estensione elencata vengono inviati allo scanner. Restringi l'elenco per ridurre volume e costo.",
      "extensionsPlaceholder": "Seleziona le estensioni da scansionare",
      "costNoticeTitle": "Il filtro estensioni controlla il costo",
      "costNoticeDescription": "Scansionare più estensioni aumenta l'utilizzo antivirus. Questa impostazione non sostituisce altri controlli di sicurezza.",
      "saveError": "Impostazioni scansione antivirus non valide. Abilita la scansione solo con almeno un'estensione selezionata.",
      "stickyInfectedNote": "Disattivare la scansione non cancella i verdetto infetti esistenti né rimuove i file dalla quarantena."
    },
    "activityLogRetention": {
      "title": "Conservazione del registro attività",
      "description": "Definisce per quanto tempo l'azienda conserva il proprio registro attività. Trascorso il periodo di conservazione dalla creazione di una voce, la voce viene eliminata definitivamente.",
      "activeTitle": "Politica di conservazione",
      "activeDescription": "Quando è disabilitata, il registro attività viene conservato a tempo indeterminato e nulla viene mai eliminato.",
      "windowTitle": "Periodo di conservazione",
      "windowDescription": "Le voci del registro più vecchie di questo periodo vengono eliminate definitivamente. Intervallo consentito: da {{min}} mesi a {{max}} anni.",
      "warningTitle": "L'eliminazione è definitiva e retroattiva",
      "warningDescription": "Abilitando la politica vengono eliminate anche le voci che superano già il periodo di conservazione. Le voci eliminate non sono recuperabili: esporta prima il registro attività se ti serve una copia."
    },
    "securityAnalysis": {
      "title": "Executive Report & Security Notification",
      "description": "Configurazione unica per l'Executive Report (domini interni, soglie degli indicatori di rischio), per le soglie di rilevamento delle anomalie di sicurezza e per le notifiche email delle anomalie rilevate.",
      "enableTitle": "Abilita notifiche email",
      "enableDescription": "Se attivo, viene inviata un'email ai destinatari selezionati per le nuove anomalie di sicurezza con severità pari o superiore a quella scelta.",
      "recipientsTitle": "Destinatari",
      "recipientsDescription": "Utenti e gruppi della piattaforma che riceveranno le notifiche. Per i gruppi vengono notificati tutti i membri.",
      "recipientsPlaceholder": "Cerca utenti o gruppi",
      "minSeverityTitle": "Severità minima",
      "minSeverityDescription": "Invia le notifiche solo da questa severità in su. Warning include Warning e Critical; Critical invia solo Critical.",
      "severityWarning": "Warning e superiori",
      "severityCritical": "Solo Critical",
      "domainsTitle": "Domini interni",
      "domainsDescription": "Lista di domini email separati da virgola considerati interni quando l'Executive Report distingue le condivisioni interne da quelle esterne. Se vuoto, viene usato il dominio email del primo amministratore.",
      "domainsPlaceholder": "azienda.com, controllata.com",
      "domainsError": "Uno o più domini non sono in un formato valido (es. azienda.com).",
      "thresholdsTitle": "Soglie indicatori di rischio",
      "thresholdsDescription": "Soglie percentuali che definiscono cosa viene considerato warning e cosa critical per ogni indicatore di rischio dell'Executive Report.",
      "warningLabel": "Warning ≥",
      "criticalLabel": "Critical ≥",
      "thresholdError": "La soglia warning deve essere inferiore alla soglia critical.",
      "detectorThresholdsTitle": "Soglie rilevamento anomalie",
      "detectorThresholdsDescription": "Conteggi di eventi che definiscono cosa viene considerato warning e cosa critical per ogni detector di anomalie di sicurezza. I detector senza soglie numeriche (IP admin bloccato, segnali di sicurezza espliciti) non sono personalizzabili.",
      "detectorThresholdError": "La soglia warning deve essere inferiore alla soglia critical.",
      "detectors": {
        "bruteForceLogin": "Login falliti sullo stesso account (finestra 15 min)",
        "folderPassword": "Tentativi falliti password cartella (per cartella e utente)",
        "publicLinkBruteForce": "Accessi falliti a link pubblici (per link e IP)",
        "massDownload": "File scaricati da un utente (finestra 60 min)",
        "passwordSpray": "Password spray: account distinti tentati da un IP",
        "unauthorizedCountry": "Accessi bloccati da paese non autorizzato (per utente e paese)"
      }
    },
    "ipRegionRestriction": {
      "title": "Restrizione IP/regione",
      "description": "Limita l'accesso alla piattaforma in base a indirizzo IP, paese o regione",
      "warningMessage": "Attenzione: Questa impostazione blocca tutti gli utenti che non corrispondono ai criteri",
      "warningDescription": "Gli utenti al di fuori degli IP, paesi o regioni consentiti verranno negati l'accesso. Configura eccezioni per utenti o gruppi specifici.",
      "confirmTitle": "Conferma configurazione",
      "confirmWarning": "Questa configurazione limiterà l'accesso. Gli utenti al di fuori degli IP, paesi o regioni consentiti verranno negati l'accesso. Sei sicuro?",
      "scopeTitle": "Ambito di applicazione",
      "scopeDescription": "Quando dovrebbe applicarsi questa restrizione?",
      "scopeLogin": "Solo Login",
      "scopeFileOps": "Solo Operazioni File",
      "scopeBoth": "Entrambi (Consigliato)",
      "allowedIpsTitle": "Indirizzi IP / range CIDR consentiti",
      "allowedIpsDescription": "Elenco separato da virgole di IP o range CIDR (IPv4/IPv6)",
      "allowedCountriesTitle": "Paesi consentiti",
      "allowedCountriesDescription": "Seleziona i paesi (codici ISO 3166-1 alpha-2)",
      "allowedRegionsTitle": "Regioni consentite",
      "allowedRegionsDescription": "Seleziona le regioni (codici ISO 3166-2 o 'EU' per Unione Europea)",
      "allowPrivateNetworksTitle": "Consenti reti private",
      "allowPrivateNetworksDescription": "Bypassa la restrizione per range IP privati (10.x, 192.168.x, 172.16-31.x)",
      "adminAccessSectionTitle": "Accesso admin",
      "restrictAdminAccessTitle": "Limita le impostazioni admin per IP",
      "restrictAdminAccessDescription": "Consenti l'accesso alle impostazioni di amministrazione solo dagli indirizzi IP o range CIDR specificati",
      "adminAllowedIpsTitle": "Indirizzi IP consentiti per l'admin",
      "adminAllowedIpsDescription": "Elenco separato da virgole di IP o range CIDR autorizzati ad aprire le impostazioni di amministrazione",
      "addAdminIp": "Aggiungi IP",
      "addAllowedIp": "Aggiungi IP o CIDR",
      "logBlockedAttemptsTitle": "Registra tentativi bloccati",
      "logBlockedAttemptsDescription": "Registra tutti i tentativi di accesso negato nel log delle attività",
      "blockedMessageTitle": "Messaggio personalizzato di blocco",
      "blockedMessageDescription": "Messaggio mostrato agli utenti bloccati (max 200 caratteri)",
      "blockedMessagePlaceholder": "Accesso negato dalla tua posizione.",
      "exceptionsTitle": "Eccezioni",
      "exceptionsDescription": "Utenti o gruppi con criteri di accesso aggiuntivi",
      "validationAtLeastOne": "Almeno un criterio (IP, paese o regione) deve essere specificato",
      "validationInvalidIp": "Formato IP/CIDR non valido: {{entries}}",
      "validationInvalidCountry": "Codici paese non validi: {{codes}}",
      "validationInvalidRegion": "Codici regione non validi: {{codes}}",
      "adminAllowedIpsHelper": "Solo IP/CIDR: nessuna geolocalizzazione, nessun bypass per le reti private e le eccezioni sopra non si applicano qui."
    },
    "fileTypeRestriction": {
      "title": "Controllo restrizione tipo file",
      "description": "Consente di definire quali tipi di file sono bloccati per il caricamento.",
      "blockedExtensionsTitle": "Estensioni file bloccate",
      "blockedExtensionsDescription": "Specifica quali estensioni di file sono bloccate. Questo consente di definire esattamente quali tipi di file sono soggetti alle restrizioni.",
      "userScopeTitle": "Ambito utente",
      "userScopeDescription": "Controlla se gli utenti saranno bloccati dal caricare o condividere file sulla piattaforma in base al tipo di file specificato sopra. Le opzioni includono bloccare tutti gli utenti o nessuno. I file già caricati o condivisi rimarranno attivi anche se il permesso viene revocato in seguito.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica gli utenti che sono eccezioni alla funzione sopra menzionata.",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti alle restrizioni impostate dall'amministratore. Questa impostazione può definire l'ambito dei permessi, le condizioni in cui si applicano e le eventuali eccezioni consentite.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni alle restrizioni sopra.",
      "showUsers": "Mostra gli utenti a cui è già stato concesso l’accesso da altri.",
      "allowEdit": "Consente agli utenti di modificare, sovrascrivere o eliminare le impostazioni di condivisione esistenti.",
      "readOnly": "Abilita la condivisione di file da parte di utenti con accesso di sola lettura (Visualizzatore).",
      "tagsTitle": "Tag",
      "tagsDescription": "Applica queste regole solo ai file con tag specifici.",
      "exceptionsRequiredForTags": "Le eccezioni sono obbligatorie per impostare i tag",
      "tagsRequired": "È richiesto almeno un tag quando sono presenti più regole.",
      "fileTypesTitle": "Tipi di file",
      "fileTypesDescription": "Specifica quali tipi di file sono bloccati per il caricamento e la condivisione.",
      "fileTypesPlaceholder": "Seleziona tipi di file o estensioni"
    },
    "folderCreationPermission": {
      "title": "Limitazioni cartelle",
      "creationTitle": "Creazione cartelle collaboratore",
      "creationDescription": "Controlla quali collaboratori possono creare cartelle sulla piattaforma. Le opzioni includono consentire a tutti i collaboratori o a nessuno. Le cartelle esistenti restano accessibili anche se il permesso viene revocato in seguito.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica gli utenti che sono eccezioni alla funzione sopra menzionata."
    },
    "groupCreationControl": {
      "title": "Limiti di creazione gruppo",
      "creationTitle": "Creazione gruppo collaboratore",
      "creationDescription": "Controlla quali collaboratori possono creare gruppi sulla piattaforma. Le opzioni includono consentire a tutti i collaboratori o nessuno. I gruppi creati sono visibili solo all'utente che li ha creati. I gruppi esistenti rimarranno accessibili anche se il permesso viene revocato in seguito.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica gli utenti che sono eccezioni alla funzione sopra menzionata."
    },
    "publicAccessLink": {
      "title": "Link di accesso pubblico",
      "description": "Controlla la capacità dei collaboratori di generare link per accedere ai file e cartelle senza autenticazione. Le opzioni includono consentire a tutti i membri o nessuno di creare questi link. I link esistenti rimarranno attivi anche se il permesso viene revocato in seguito.",
      "activeForAllTitle": "Generazione link collaboratore",
      "activeForAllDescription": "Controlla la capacità dei collaboratori di generare link per accedere ai file e cartelle senza autenticazione. Le opzioni includono consentire a tutti i membri o nessuno di creare questi link. I link esistenti rimarranno attivi anche se il permesso viene revocato in seguito.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica i collaboratori che sono eccezioni alle sopra menzionate autorizzazioni di generazione link.",
      "forcePasswordTitle": "Password obbligatoria",
      "forcePasswordDescription": "Se attivo, l'utente deve impostare una password quando crea un link pubblico.",
      "mandatoryMaxAccessCountTitle": "Numero massimo accessi obbligatorio",
      "mandatoryMaxAccessCountDescription": "Se maggiore di 0, l'utente deve specificare un numero massimo di accessi (0–10000). 0 = non obbligatorio.",
      "maxExpirationDaysTitle": "Giorni massimi di scadenza",
      "maxExpirationDaysDescription": "Se maggiore di 0, l'utente deve impostare una scadenza entro questo numero di giorni (0–365). 0 = nessun vincolo. <br /> <DangerText> Se «Scadenza obbligatoria file condiviso» è attiva, la data di scadenza definita in quell'impostazione avrà precedenza sul numero massimo di giorni configurato qui. </DangerText>",
      "tagsTitle": "Tag",
      "tagsDescription": "Sarà possibile creare link pubblici solo per i file che hanno questi tag applicati."
    },
    "sessionControl": {
      "title": "Limite sessioni concorrenti",
      "description": "Limita il numero di sessioni attive per utente. Quando un utente supera il limite, la sessione più vecchia viene terminata automaticamente.",
      "maxSessionsTitle": "Sessioni Massime",
      "maxActiveSessions": "Sessioni attive massime",
      "maxSessionsDescription": "Imposta il numero massimo di sessioni concorrenti consentite per utente. Quando il limite viene raggiunto, la sessione più vecchia viene disconnessa automaticamente.",
      "unlimited": "Illimitato",
      "exceptionsTitle": "Eccezioni",
      "exceptionsDescription": "Personalizza il limite di sessioni per utenti o gruppi specifici.",
      "pendingExceptionsTitle": "Eccezioni in attesa",
      "savedExceptionsTitle": "Eccezioni salvate",
      "selectUsersOrGroups": "Seleziona utenti o gruppi..."
    },
    "uploadWithTag": {
      "title": "Gestione automatica tag",
      "description": "Filegrant Enterprise analizzerà i metadati dei file classificati caricati per determinate parole chiave. Se una delle parole chiave specificate viene rilevata, il valore corrispondente verrà applicato al file come tag. Se un tag non esiste già sulla piattaforma, viene creato automaticamente. Questo processo garantisce che ogni file sia correttamente classificato e etichettato in base al suo contenuto.",
      "keywordsTitle": "Parole chiave",
      "keywordsDescription": "Specifica le parole chiave il cui valore verrà utilizzato come tag per il file dopo il caricamento.",
      "userScopeTitle": "Ambito utente",
      "userScopeDescription": "Controlla se i membri sono soggetti al rilevamento automatico dei tag durante il caricamento dei file sulla piattaforma. Le opzioni includono applicare questa funzione a tutti i membri o a nessuno. I file già caricati e taggati resteranno attivi e le modifiche alle parole chiave non influiranno sui file già taggati.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica gli utenti che sono eccezioni alla funzione sopra menzionata."
    },
    "watermarkProtection": {
      "title": "Abilita protezione con watermark per membri",
      "description": "Controlla la protezione con watermark per i file condivisi. Abilita per tutti i membri o nessuno, gestisci le eccezioni e configura quali dati mostrare sul watermark (es. data condivisione, proprietario, destinatario, data creazione, IP).",
      "descriptionInternal": "Controlla la protezione con watermark per i file condivisi. Abilita per tutti i membri o nessuno, gestisci le eccezioni e configura quali dati mostrare sul watermark (es. data condivisione, proprietario, destinatario, data creazione, IP). <DangerText>Al momento i watermark vengono applicati ai file PDF, immagini (jpeg, png, svg), e soltanto ai destinatari che ricevono il file Office (doc, docx, ppt, pptx, xls, xlsx) in sola lettura.</DangerText>",
      "enabledTitle": "Abilitato",
      "enabledDescription": "Attiva o disattiva questa impostazione.",
      "userScopeTitle": "Ambito utente",
      "userScopeDescription": "Consenti ai membri di proteggere i loro file con watermark. Le opzioni includono abilitare questa funzione per tutti i membri o nessuno. I watermark possono essere applicati al momento della condivisione. Quando i destinatari aprono il documento, il watermark visualizzerà il loro indirizzo email, indirizzo IP e la data di accesso al documento, garantendo la protezione del contenuto e il tracciamento.",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Applica la protezione watermark a tutti i membri o a nessuno. Se impostato su nessuno, puoi comunque destinare membri specifici tramite eccezioni e tag.",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica gli utenti che sono eccezioni alla funzione sopra menzionata.",
      "tagsTitle": "Tag",
      "tagsDescription": "Applica la protezione watermark solo ai file con questi tag.",
      "previewTitle": "Anteprima",
      "textLabel": "Testo watermark",
      "repetitionLabel": "Ripetizione",
      "repetitionSingle": "Singolo",
      "repetitionRepetitive": "Ripetuto",
      "fieldsLabel": "Campi da visualizzare",
      "fieldsSharingDate": "Data condivisione",
      "fieldsOwner": "Proprietario",
      "fieldsRecipient": "Destinatario",
      "fieldsCreationDate": "Data creazione",
      "fieldsIp": "Indirizzo IP",
      "positionXLabel": "Posizione orizzontale",
      "positionYLabel": "Posizione verticale",
      "positionLeft": "Sinistra",
      "positionCenter": "Centro",
      "positionRight": "Destra",
      "positionTop": "Alto",
      "positionMiddle": "Centro",
      "positionBottom": "Basso",
      "positionsLabel": "Posizione",
      "positionsTopLeft": "In alto a sinistra",
      "positionsTopCenter": "In alto al centro",
      "positionsTopRight": "In alto a destra",
      "positionsBottomLeft": "In basso a sinistra",
      "positionsBottomCenter": "In basso al centro",
      "positionsBottomRight": "In basso a destra",
      "positionsDiagonal": "Diagonale (ripetuto)",
      "fontSizeLabel": "Dimensione font",
      "fontSizeDescription": "1–72",
      "fontColorLabel": "Colore font",
      "opacityLabel": "Opacità",
      "opacityDescription": "0–100%",
      "textPlaceholderHelp": "I pulsanti sotto inseriscono dei placeholder nel testo. Puoi usare \\n per andare a capo e **grassetto** per il testo in grassetto. Il tooltip di ogni pulsante spiega la sua funzione.",
      "placeholderButtonOwner": "Proprietario",
      "placeholderTooltipOwner": "Nel watermark, {owner} viene sostituito con il nome del proprietario del documento.",
      "placeholderButtonAccessDate": "Data/ora visualizzazione",
      "placeholderTooltipAccessDate": "Nel watermark, {access_date} viene sostituito con data e ora di visualizzazione del documento.",
      "placeholderButtonSharingDate": "Data condivisione",
      "placeholderTooltipSharingDate": "Nel watermark, {sharing_date} viene sostituito con la data di generazione del link.",
      "placeholderButtonIp": "Indirizzo IP",
      "placeholderTooltipIp": "Nel watermark, {ip} viene sostituito con l'indirizzo IP del visualizzatore.",
      "placeholderButtonRecipient": "Destinatario",
      "placeholderTooltipRecipient": "Nel watermark, {recipient} viene sostituito con il nome del destinatario.",
      "placeholderButtonOwnerEmail": "Email proprietario",
      "placeholderTooltipOwnerEmail": "Nel watermark, {owneremail} viene sostituito con l'indirizzo email del proprietario del documento.",
      "placeholderButtonRecipientEmail": "Email destinatario",
      "placeholderTooltipRecipientEmail": "Nel watermark, {recipientemail} viene sostituito con l'indirizzo email del destinatario."
    },
    "remotegrantForceEncryption": {
      "title": "Cifratura forzata Remotegrant (licenza richiesta)",
      "description": "Cifra i file e assegna automaticamente i permessi di accesso ai nuovi membri utilizzando Remotegrant."
    },
    "sharingApprovalRequirement": {
      "title": "Requisiti di approvazione condivisione",
      "description": "Controlla se la condivisione di file e cartelle richiede un'approvazione preventiva, garantendo che i file sensibili siano revisionati prima della distribuzione e sia mantenuta la conformità.",
      "descriptionInternal": "Questa sezione consente agli amministratori di controllare se la condivisione di file e cartelle necessita un'approvazione preventiva. Le regole possono essere applicate universalmente, a specifiche tipologie di proprietà dei file o in base a tag di classificazione. Gli amministratori possono assicurarsi che i file sensibili vengano revisionati prima della condivisione, aiutando a mantenere la conformità, prevenire fughe di dati e applicare le policy organizzative. Le richieste di approvazione possono essere indirizzate a un supervisore designato o a un team di revisione predefinito.",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti a restrizioni impostate dall'amministratore. Questa impostazione consente di definire l'ambito dei permessi, le condizioni in cui si applicano e le eventuali eccezioni. Garantisce che l'attività degli utenti sia conforme alle policy organizzative, pur lasciando flessibilità dove necessario.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni a questa funzionalità.",
      "reviewTeamTitle": "Team di revisione",
      "reviewTeamDescription": "Specifica il team che revisionerà le richieste di approvazione.",
      "tagsTitle": "Tag",
      "tagsDescription": "Applica queste regole solo ai file con specifici tag",
      "tagsRequired": "È richiesto almeno un tag quando sono presenti più regole",
      "exceptionsRequiredForTags": "Sono necessarie eccezioni per impostare i tag",
      "exceptionHandlingTitle": "Gestione eccezioni",
      "exceptionHandlingDescription": "Specifica gli utenti che sono eccezioni a questa funzionalità.",
      "generalApprovalTitle": "Approvazione generale richiesta",
      "generalApprovalDescription": "La condivisione è consentita solo dopo approvazione preventiva da parte di un supervisore o del team definito nella policy.",
      "resharingApprovalTitle": "Approvazione solo per ri-condivisioni",
      "resharingApprovalDescription": "Applica il requisito di approvazione solo ai file precedentemente ricevuti e che vengono ri-condivisi.",
      "manageReviewTeam": "Gestisci Team di revisione"
    },
    "mandatoryFileClassification": {
      "title": "Classificazione obbligatoria dei file",
      "description": "Richiedi che i file siano classificati prima della condivisione, garantendo che i file sensibili siano correttamente taggati e protetti.",
      "descriptionInternal": "Questa sezione garantisce che i file siano adeguatamente classificati prima che possano essere condivisi. Richiedendo la classificazione, si aiuta a prevenire la condivisione accidentale o non autorizzata di contenuti sensibili e si supporta una governance coerente dei dati.",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti a restrizioni impostate dall'amministratore. Questa impostazione consente di definire l'ambito dei permessi, le condizioni in cui si applicano e le eventuali eccezioni. Garantisce che l'attività degli utenti sia conforme alle policy organizzative, pur lasciando flessibilità dove necessario.",
      "exceptionsTitle": "Gestione eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni a questa funzionalità.",
      "tagsTitle": "Tag",
      "tagsDescription": "Applica queste regole solo ai file con specifici tag",
      "tagsRequired": "È richiesto almeno un tag quando sono presenti più regole",
      "exceptionsRequiredForTags": "Sono necessarie eccezioni per impostare i tag"
    },
    "forcedFileInvisibility": {
      "title": "Invisibilità forzata dei file",
      "description": "Questa funzione consente agli amministratori di rendere invisibili determinati tipi di file ai destinatari, pur completando l'azione di condivisione. Ad esempio, i documenti Office utilizzati come file master modificabili possono essere condivisi ma resteranno nascosti al destinatario, riducendo il rischio di esporre file sorgente modificabili e permettendo comunque la condivisione di formati approvati come i PDF.",
      "descriptionInternal": "Questa funzione consente agli amministratori di rendere invisibili determinati tipi di file ai destinatari, pur completando l'azione di condivisione. Ad esempio, i documenti Office utilizzati come file master modificabili possono essere condivisi ma resteranno nascosti al destinatario, riducendo il rischio di esporre file sorgente modificabili e permettendo comunque la condivisione di formati approvati come i PDF.",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti alle restrizioni impostate dall'amministratore. Questa impostazione consente di definire l'ambito dei permessi, le condizioni in cui si applicano e le eventuali eccezioni. Garantisce che l’attività degli utenti sia conforme alle policy organizzative, pur lasciando flessibilità dove necessario.",
      "exceptionsTitle": "Gestione delle eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni rispetto a questa funzionalità.",
      "fileTypesTitle": "Invisibili dopo la condivisione",
      "fileTypesDescription": "Rende invisibili ai destinatari alcuni tipi di file (es: documenti Office) pur completando il processo di condivisione.",
      "fileTypesPlaceholder": "Inserisci tipi di file o estensioni (es: .docx, .xls, .pptx)",
      "tagsTitle": "Tag",
      "tagsDescription": "Applica queste regole solo ai file con specifici tag",
      "tagsRequired": "È richiesto almeno un tag quando sono presenti più regole",
      "exceptionsRequiredForTags": "Sono necessarie eccezioni per impostare i tag"
    },
    "shortcutLink": {
      "title": "Restrizione collegamento rapido",
      "description": "Limita la creazione di collegamenti rapidi per i file che contengono specifici tag.",
      "descriptionInternal": "Limita la creazione di collegamenti rapidi per i file che contengono specifici tag.",
      "activeForAllTitle": "Ambito utente",
      "activeForAllDescription": "Controlla se gli utenti sono soggetti alle restrizioni impostate dall'amministratore.",
      "exceptionsTitle": "Gestione delle eccezioni",
      "exceptionsDescription": "Specifica gli utenti che sono eccezioni rispetto a questa funzionalità.",
      "tagsTitle": "Tag",
      "tagsDescription": "Applica queste regole solo ai file con specifici tag",
      "tagsRequired": "È richiesto almeno un tag quando sono presenti più regole",
      "exceptionsRequiredForTags": "Sono necessarie eccezioni per impostare i tag"
    },
    "adminSettingsPermissions": {
      "title": "Permessi impostazioni amministratore",
      "description": "Limita l’accesso degli Admin alle impostazioni della piattaforma.",
      "deniedSettingsUserTitle": "Ambito Amministratore",
      "deniedSettingsUserDescription": "Seleziona l'amministratore a cui verrà negato l'accesso alle impostazioni.",
      "deniedSettingsTitle": "Impostazioni Negate",
      "deniedSettingsDescription": "Specifica le impostazioni a cui gli amministratori non sono autorizzati ad accedere.",
      "selectUserFirst": "Seleziona prima un utente"
    },
    "sharePointIntegration": {
      "title": "Integrazione SharePoint",
      "description": "Cifra sul posto i file di un perimetro SharePoint scelto.",
      "steps": {
        "connection": "Connessione",
        "key": "Chiave di cifratura",
        "perimeter": "Perimetro"
      },
      "connectionDescription": "Credenziali app-only della registrazione app in Entra ID.",
      "tenantIdLabel": "ID tenant",
      "clientIdLabel": "ID client",
      "spaClientIdLabel": "Client ID SPA (viewer/editor)",
      "spaClientIdHint": "Seconda registrazione app, di tipo SPA (pubblica): è quella con cui il browser esegue l’accesso per leggere e modificare i file cifrati. Senza di essa nessuno può aprire un file dall’app web. Non inserire qui la registrazione app-only: quella ha un secret.",
      "guidHint": "Inserisci un GUID valido.",
      "clientSecretLabel": "Client secret",
      "clientSecretPlaceholder": "Incolla il client secret",
      "clientSecretHint": "A sola scrittura: una volta salvato può solo essere sostituito.",
      "clientSecretStored": "Un client secret è memorizzato",
      "replaceSecret": "Sostituisci",
      "editConnection": "Modifica",
      "hideConnection": "Chiudi",
      "testAction": "Verifica",
      "testOk": "Connessione verificata",
      "testKo": "Connessione rifiutata",
      "saveCredentialsFirst": "Salva prima le credenziali.",
      "lastVerifyOk": "Verificata",
      "lastVerifyKo": "Verifica fallita",
      "lastVerifiedAt": "Ultimo controllo: {{date}}",
      "perimeterDescription": "I siti e le cartelle ispezionati dalla scansione.",
      "perimeter": {
        "sitesTitle": "Siti",
        "searchSites": "Cerca siti",
        "reloadSites": "Ricarica l'elenco dei siti",
        "foldersTitle": "{{siteName}}",
        "foldersTitleEmpty": "Cartelle",
        "pickSiteFirst": "Scegli un sito a sinistra.",
        "noLibraries": "Nessuna raccolta documenti visibile qui.",
        "wholeSiteTag": "Tutto il sito",
        "selectedTitle": "Nel perimetro:",
        "scopeNone": "nessuno",
        "folderCount": "{{count}} cartella/e",
        "librariesCrumb": "Raccolte documenti",
        "noSubfolders": "Nessuna sottocartella.",
        "levelTruncatedTitle": "Troppe cartelle per elencarle qui",
        "levelTruncatedBody": "Oltre il limite di 2000 cartelle alcune non compaiono in nessuna pagina: aggiungile per percorso qui sotto.",
        "manualPathLabel": "Aggiungi una cartella per percorso",
        "manualPathPlaceholder": "Aggiungi una cartella per percorso, es. Contratti/2026",
        "manualPathInvalid": "Percorso relativo alla radice della raccolta, senza segmenti \".\" o \"..\" (max 400 caratteri).",
        "browse": "Sfoglia",
        "openFolder": "Apri {{name}}",
        "scopeLabel": "Cosa monitorare in questo sito",
        "scopeOff": "Niente",
        "scopeWhole": "Tutto il sito",
        "scopeFolders": "Solo le cartelle qui sotto",
        "selectedFoldersTitle": "Cartelle monitorate",
        "librariesNotSelectable": "Apri una raccolta. Una cartella scelta vale per ogni raccolta del sito.",
        "addFolder": "Aggiungi {{name}} alle cartelle monitorate",
        "folderAdded": "Aggiunta",
        "folderAlreadyAdded": "Questa cartella è già monitorata",
        "noFoldersSelected": "Ancora nessuna.",
        "parentFolderWatched": "La cartella superiore \"{{folder}}\" è già monitorata, quindi le sue sottocartelle sono già nel perimetro.",
        "emptyWarning": "Nessun sito selezionato: non verrà ispezionato né cifrato nulla.",
        "siteCount": "{{count}} sito/i"
      },
      "certificateDescription": "Il certificato RemoteGrant a cui i file vengono cifrati.",
      "encryption": {
        "thumbprintLabel": "Impronta",
        "unnamedCertificate": "Certificato n. {{id}}",
        "reloadAction": "Ricarica i certificati",
        "selectPlaceholder": "Scegli un certificato",
        "optionLabel": "{{name}} — creato il {{date}}",
        "rotationTitle": "Cambiare certificato non ri-cifra nulla",
        "rotationBody": "I file già cifrati restano legati al certificato precedente: mantienilo in RemoteGrant o diventeranno illeggibili.",
        "dryRunBlockedReason": "Scegli un certificato di cifratura per disattivare la modalità discovery.",
        "errors": {
          "listFailed": "Non è stato possibile caricare la lista dei certificati.",
          "certificateNotFound": "Il certificato selezionato non è più nella tua lista RemoteGrant. Ricarica la lista e selezionane uno di nuovo.",
          "remoteGrantNotConfigured": "RemoteGrant non è configurato per la tua azienda. Le sue chiavi vengono impostate da CyberGrant: contatta il supporto.",
          "remoteGrantUnavailable": "RemoteGrant è temporaneamente non raggiungibile. Riprova tra un momento.",
          "remoteGrantDenied": "RemoteGrant ha rifiutato le credenziali della tua azienda. Contatta il supporto."
        },
        "empty": "RemoteGrant non ha restituito alcun certificato per la tua azienda."
      },
      "fileExtensionsTitle": "Filtro sui tipi di file",
      "fileExtensionsDescription": "Solo i file con queste estensioni sono nel perimetro. Lascia l'elenco vuoto per includere ogni tipo di file.",
      "addFileExtension": "Aggiungi un'estensione",
      "invalidFileExtension": "Inserisci una singola estensione, per esempio .docx",
      "allFileTypesWarning": "Nessun filtro impostato: ogni tipo di file nel perimetro è incluso.",
      "dryRunTitle": "Modalità discovery",
      "dryRunDescription": "Ispeziona il perimetro senza cifrare nulla. Impostazione predefinita e sicura.",
      "dryRunOnTag": "Discovery",
      "dryRunOffTag": "Cifratura attiva",
      "confirmEncryption": {
        "confirmAction": "Cifra",
        "irreversible": "Vengono riscritti sul posto e da qui non possono essere decifrati.",
        "title": "Cifrare i file di questa selezione?"
      },
      "errors": {
        "notAvailableTitle": "Non inclusa nella tua licenza",
        "notAvailable": "L'integrazione SharePoint non è inclusa nella tua licenza. Contatta il supporto per abilitarla.",
        "notConfigured": "Nessuna credenziale è ancora memorizzata. Inserisci e salva prima i parametri di connessione.",
        "configInvalid": "La configurazione salvata è stata rifiutata. Correggi i problemi elencati qui sotto e salva di nuovo.",
        "testFailed": "Non è stato possibile verificare la connessione.",
        "sitesFailed": "Non è stato possibile caricare i siti del tenant.",
        "foldersFailed": "Non è stato possibile caricare questo livello di cartelle.",
        "siteNotFound": "Questo sito non è più disponibile con queste credenziali. Ricarica l'elenco dei siti e selezionalo di nuovo.",
        "graphUnauthorizedShort": "Microsoft Graph ha rifiutato le credenziali.",
        "graphUnavailable": "Microsoft Graph è temporaneamente non raggiungibile. Riprova tra un momento.",
        "notAllowed": "Non hai i permessi per gestire questa impostazione. Chiedi a un SuperAdmin di abilitarti all'integrazione SharePoint.",
        "invalidParams": "La richiesta è stata rifiutata per un parametro non valido.",
        "remedyPermissions": "La registrazione app richiede i permessi applicativi Sites.Read.All e Files.ReadWrite.All con consenso amministratore.",
        "remedySecret": "Il client secret può essere errato o scaduto: inseriscine uno nuovo qui sopra."
      }
    },
    "activeDirectoryLdap": {
      "title": "Active Directory (LDAP)",
      "description": "Collega Filegrant al tuo Active Directory on-premises per sincronizzare utenti e gruppi.",
      "connectionTitle": "Connessione",
      "connectionDescription": "Domain controller, account di servizio e radice di ricerca.",
      "hostLabel": "Host",
      "portLabel": "Porta",
      "securityLabel": "Sicurezza",
      "securityNone": "Nessuna (chiaro)",
      "allowInsecureLabel": "Capisco che la password viaggia in chiaro — consenti LDAP non sicuro",
      "allowInsecureWarning": "Con security impostato a none, la password dell'account di servizio viaggia in chiaro sulla rete.",
      "bindDnLabel": "Bind DN",
      "bindPasswordLabel": "Password di bind",
      "bindPasswordStored": "È memorizzata una password di bind",
      "bindPasswordRequired": "Inserisci la password di bind prima di salvare.",
      "replacePassword": "Sostituisci",
      "baseDnLabel": "Base DN",
      "loginAliasLabel": "Attributo alias di login",
      "loginAliasNone": "Nessuno",
      "suggestRetypePassword": "Host o bind DN modificati — valuta di reinserire la password di bind.",
      "testAction": "Test connessione",
      "testOk": "Connessione verificata",
      "saveCredentialsFirst": "Salva prima la configurazione, senza modifiche non salvate.",
      "lastVerifiedAt": "Ultima verifica: {{date}}",
      "neverVerified": "Mai verificato",
      "caTitle": "Certificato CA",
      "caDescription": "PEM della CA interna che ha firmato il certificato del domain controller. Lascia vuoto per usare lo store di sistema.",
      "uploadCa": "Carica .cer / .pem",
      "removeCa": "Rimuovi CA",
      "caThumbprint": "Impronta",
      "caExpiresAt": "La CA scade il {{date}}",
      "caExpiringSoon": "La CA scade a breve ({{date}})",
      "caExpired": "La CA è scaduta il {{date}}",
      "advancedTitle": "Avanzate",
      "advancedDescription": "Search base e filtri LDAP opzionali.",
      "advancedToggle": "Search base e filtri",
      "userSearchBaseLabel": "Search base utenti",
      "groupSearchBaseLabel": "Search base gruppi",
      "userFilterLabel": "Filtro utenti",
      "groupFilterLabel": "Filtro gruppi",
      "errors": {
        "notAvailableTitle": "Non disponibile"
      },
      "passwordRequiredOnTargetChange": "Reinserisci la password: il target di connessione è cambiato.",
      "filterHelp": "Condizione opzionale che restringe la ricerca predefinita (AND), es. (department=Sales).",
      "neverVerifiedInvite": "Connessione mai verificata — premi Test connection."
    },
    "outboundEmail": {
      "title": "Mittente e-mail personalizzato",
      "description": "Invia le notifiche della piattaforma dal tuo dominio tramite SMTP o Mailgun.",
      "statusTitle": "Stato del mittente",
      "statusDescription": "Se le notifiche partono attualmente dal dominio personalizzato.",
      "refreshStatus": "Aggiorna stato",
      "badgeActive": "Attivo: le notifiche partono da {{domain}}",
      "badgeInactive": "Non attivo: le notifiche usano ancora il mittente della piattaforma",
      "reasonDisabled": "Il mittente personalizzato è disattivato.",
      "reasonNotVerified": "La proprietà del dominio non è ancora verificata.",
      "reasonMailgunNotActive": "Il dominio Mailgun non è ancora attivo.",
      "reasonNotActive": "Il mittente personalizzato non è in uso.",
      "formTitle": "Configurazione",
      "formDescription": "Dominio, identità From e modalità di consegna.",
      "enabledLabel": "Abilita mittente personalizzato",
      "modeLabel": "Modalità di consegna",
      "modeSmtp": "SMTP (server proprio)",
      "modeMailgun": "Mailgun (account piattaforma)",
      "mailgunUnavailable": "La modalità Mailgun non è disponibile su questa piattaforma.",
      "domainLabel": "Dominio",
      "fromAddressLabel": "Indirizzo From",
      "fromNameLabel": "Nome From",
      "sendFromUserLabel": "Invia dall'utente",
      "sendFromUserOn": "Usa l'e-mail dell'utente agente come From",
      "sendFromUserOff": "Usa l'indirizzo From aziendale / dominio personalizzato",
      "smtpHostLabel": "Host SMTP",
      "smtpPortLabel": "Porta SMTP",
      "smtpUsernameLabel": "Username SMTP",
      "smtpPasswordLabel": "Password SMTP",
      "smtpPasswordStored": "Una password SMTP è memorizzata",
      "smtpPasswordRequired": "Inserisci la password SMTP prima di salvare.",
      "replacePassword": "Sostituisci",
      "smtpSecurityLabel": "Sicurezza SMTP",
      "suggestRetypePassword": "Host o username modificati — reinserisci la password SMTP.",
      "domainChangeTitle": "Cambiare dominio?",
      "domainChangeWarning": "Cambiare il dominio riavvia la verifica. Il mittente personalizzato non sarà usato finché il nuovo dominio non è verificato.",
      "dnsTitle": "DNS e verifica",
      "dnsDescription": "Pubblica il record TXT di proprietà, poi verifica. In modalità Mailgun, pubblica anche i record Mailgun.",
      "verifyNow": "Verifica ora",
      "verifyOk": "Proprietà del dominio verificata",
      "verifyPending": "TXT di proprietà non ancora trovato",
      "verifyMailgun": "Verifica record Mailgun",
      "verifyMailgunOk": "Record Mailgun verificati: il dominio è attivo",
      "verifyMailgunPending": "Mailgun non ha ancora verificato tutti i record",
      "autoCheckHint": "Verifica automatica ogni minuto finché il dominio non è verificato.",
      "autoCheckVerified": "Dominio verificato: il mittente personalizzato ora può essere usato.",
      "saveBeforeVerify": "Salva prima un dominio, poi verifica.",
      "ownershipName": "Nome",
      "ownershipValue": "Valore",
      "recordType": "Tipo",
      "recordValid": "Valido",
      "recordInvalid": "Non valido",
      "verifiedAt": "Verificato: {{date}}",
      "lastCheckedAt": "Ultimo controllo: {{date}}",
      "dnsEmpty": "Salva un dominio per ricevere il record TXT di proprietà.",
      "mailgunRecordsTitle": "Record DNS Mailgun",
      "testTitle": "E-mail di test",
      "testDescription": "Accoda un messaggio di test al tuo indirizzo SuperAdmin tramite il mittente personalizzato.",
      "testDescriptionPlatform": "Accoda un messaggio di test al tuo indirizzo SuperAdmin. Il mittente personalizzato non è ancora in uso, quindi viene usato il mittente attuale.",
      "sendTest": "Invia e-mail di test",
      "testQueued": "Accodata a {{recipient}}",
      "testQueuedPlatform": "Accodato a {{recipient}} tramite il mittente attuale (mittente personalizzato non in uso)",
      "errors": {
        "notAvailableTitle": "Non disponibile"
      }
    }
  },
  "auth": {
    "loginPageTitle": "Benvenuto su Filegrant Enterprise",
    "loginPageSubtitle": "Inserisci il tuo indirizzo email per accedere in modo sicuro al documento.",
    "resendOtpCode": "Invia di nuovo il codice OTP",
    "loginTermsAndConditions": "Accetto i [**Termini di servizio**](https://www.cybergrant.net/terms-of-service) di Cyber Grant Inc.",
    "loginPageEmailLabel": "Email/nome utente",
    "loginPageEmailPlaceholder": "Inserisci qui la tua email/nome utente...",
    "loginPageOtpLabel": "Abbiamo inviato un codice alla tua email registrata. Inserisci qui il codice a 6 cifre. Se non lo hai ricevuto, clicca 'Richiedi un nuovo codice'",
    "loginButtonLabel": "Accedi",
    "loginPageResendOtp": "Richiedi un nuovo codice",
    "orContinueWith": "Oppure continua con",
    "loginPageTooManyAttempts": "Troppe tentativi, riprova tra",
    "totpStepTitle": "Autenticazione a due fattori",
    "enterTotpCode": "Inserisci il codice a 6 cifre dall'app authenticator",
    "configure2FA": "Devo configurare la 2FA",
    "useBackupCode": "Usa un codice di recupero",
    "useOtpCode": "Usa codice OTP",
    "enterBackupCode": "Inserisci il tuo codice di recupero",
    "backupCodePlaceholder": "Inserisci il tuo codice di recupero",
    "totpTimeRemaining": "Tempo rimanente per completare l'autenticazione: {{time}}",
    "twoFactorChooseMethod": "Scegli come verificare",
    "usePasskey": "Usa passkey",
    "useTotp": "Usa app di autenticazione",
    "passkeyWaiting": "In attesa del passkey…",
    "orDivider": "oppure",
    "signInWithPasskey": "Accedi con passkey",
    "passkeyCancelled": "Accesso con passkey annullato.",
    "passkeyNotSupported": "Il browser non supporta i passkey.",
    "passwordlessNotEnabled": "L'accesso con passkey non è abilitato per la tua organizzazione.",
    "totpForcedSetupIntro": "La tua organizzazione richiede l'autenticazione a due fattori. Configurala ora per completare l'accesso come {{email}}.",
    "totpForcedSetupTitle": "Configura l'autenticazione a due fattori",
    "totpForcedSetupDescription": "Scansiona il codice QR con la tua app di autenticazione, poi inserisci il codice a 6 cifre per completare l'accesso."
  },
  "secret": {
    "createTitle": "Crea file segreto",
    "createSecret": "Password o segreto",
    "newSecret": "Nuovo segreto",
    "fileName": "Nome file",
    "fileNameRequired": "Il nome del file è obbligatorio",
    "protectWithPassword": "Proteggi con password",
    "protectWithSecretKey": "Proteggi con chiave segreta",
    "secretKeyWarning": "Se perdi questa chiave non sarà più possibile accedere all'informazione",
    "changeSecretKey": "Cambia chiave segreta",
    "currentSecretKey": "Chiave segreta attuale",
    "wrongCurrentKey": "La chiave segreta attuale non è corretta",
    "hint": "Suggerimento",
    "hintPlaceholder": "Suggerimento facoltativo per ricordare la chiave",
    "newSecretKey": "Nuova chiave segreta",
    "confirmSecretKey": "Conferma chiave segreta",
    "secretKeyMismatch": "Le chiavi segrete non corrispondono",
    "enterPassword": "Inserisci password",
    "confirmPassword": "Conferma password",
    "passwordRequired": "La password è obbligatoria",
    "passwordMinLength": "La password deve avere almeno 4 caratteri",
    "confirmPasswordRequired": "Conferma la password",
    "passwordMismatch": "Le password non corrispondono",
    "wrongPassword": "Password errata",
    "addField": "Aggiungi campo",
    "addFieldForGroup": "Aggiungi campo al gruppo",
    "addWebsite": "Aggiungi sito",
    "addGroup": "Aggiungi gruppo",
    "newGroup": "Nuovo gruppo",
    "renameGroup": "Rinomina gruppo",
    "deleteGroup": "Elimina gruppo",
    "moveUp": "Sposta su",
    "moveDown": "Sposta giù",
    "dragToReorderField": "Trascina per riordinare {{label}}",
    "dragToReorderGroup": "Trascina per riordinare il gruppo {{label}}",
    "removeField": "Rimuovi campo",
    "editLabel": "Modifica etichetta",
    "fieldType": "Tipo",
    "fieldLabel": "Nuovo campo",
    "fieldValue": "Valore",
    "fields": {
      "heading": "Campi",
      "username": "Username",
      "password": "Password",
      "website": "Sito web",
      "cardholder": "Intestatario",
      "number": "Numero carta",
      "brand": "Circuito",
      "exp_month": "Mese scadenza",
      "exp_year": "Anno scadenza",
      "cvv": "CVV",
      "title": "Titolo",
      "first_name": "Nome",
      "last_name": "Cognome",
      "fiscal_code": "Codice fiscale",
      "passport": "Passaporto",
      "driving_license": "Patente",
      "email": "Email",
      "phone": "Telefono",
      "address1": "Indirizzo riga 1",
      "address2": "Indirizzo riga 2",
      "address3": "Indirizzo riga 3",
      "city": "Città",
      "state": "Provincia",
      "zip": "CAP",
      "country": "Nazione",
      "private_key": "Chiave privata",
      "public_key": "Chiave pubblica",
      "fingerprint": "Fingerprint",
      "notes": "Note"
    },
    "searchFields": "Cerca campi",
    "noFieldsYet": "Nessun campo ancora",
    "untitled": "Senza titolo",
    "presets": {
      "credentials": "Credenziali di accesso",
      "card": "Carta di pagamento",
      "identity": "Identità",
      "ssh_key": "Chiave SSH",
      "custom": "Segreto personalizzato"
    },
    "groups": {
      "credentials_main": "Credenziali di accesso",
      "credentials_autofill": "Opzioni di riempimento automatico",
      "card_main": "Carta",
      "identity_personal": "Personale",
      "identity_ids": "Documenti",
      "identity_contact": "Contatti",
      "identity_address": "Indirizzo",
      "ssh_main": "Chiave SSH",
      "custom_fields": "Campi personalizzati",
      "additional_options": "Opzioni aggiuntive"
    },
    "card": {
      "brands": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "American Express",
        "other": "Altro"
      }
    },
    "identity": {
      "titles": {
        "mr": "Sig.",
        "ms": "Sig.ra",
        "mx": "Mx",
        "dr": "Dr.",
        "prof": "Prof.",
        "other": "Altro"
      }
    },
    "ssh": {
      "upload": "Carica file chiave",
      "uploadError": "Impossibile leggere il file chiave"
    },
    "types": {
      "text": "Testo",
      "password": "Password",
      "url": "URL",
      "username": "Username",
      "email": "Email",
      "phone": "Telefono",
      "textarea": "Area di testo",
      "number": "Numero",
      "month": "Mese",
      "year": "Anno"
    },
    "validation": {
      "email": "Non sembra un'email valida",
      "url": "Non sembra un URL valido",
      "phone": "Non sembra un numero di telefono valido",
      "number": "Non sembra un numero valido"
    },
    "password": {
      "show": "Mostra",
      "hide": "Nascondi",
      "generate": "Genera password",
      "copy": "Copia",
      "copied": "Copiato!",
      "length": "Lunghezza",
      "includeSymbols": "Includi caratteri speciali",
      "strength": {
        "veryWeak": "Molto debole",
        "weak": "Debole",
        "fair": "Discreta",
        "strong": "Forte",
        "veryStrong": "Molto forte"
      }
    },
    "edit": "Modifica",
    "save": "Salva",
    "saved": "Salvato con successo",
    "cancel": "Annulla",
    "protectedFile": "File protetto",
    "enterPasswordToView": "Inserisci la password per visualizzare il contenuto",
    "unlock": "Sblocca",
    "noData": "Nessun dato disponibile",
    "loadError": "Errore nel caricamento del file",
    "saveError": "Errore nel salvataggio del file"
  },
  "publicShare": {
    "createLink": "Crea link pubblico",
    "revokeLink": "Revoca link",
    "revokeLinkConfirmDescription": "Revocare il link pubblico per {{fileName}}?",
    "badgeSection": "Link pubblico",
    "badgeActive": "Link pubblico attivo",
    "revoked": "Link pubblico revocato con successo",
    "createModal": {
      "title": "Crea link pubblico",
      "fileLabel": "File",
      "allowDownload": "Permetti download",
      "expirationLabel": "Scadenza (opzionale)",
      "expirationPlaceholder": "Mai",
      "maxAccessCountLabel": "Limite accessi (opzionale)",
      "maxAccessCountPlaceholder": "Illimitato",
      "protectWithPassword": "Proteggi con password",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Inserisci password",
      "passwordRequired": "La password è obbligatoria quando la protezione è attiva",
      "createLink": "Crea link"
    },
    "successModal": {
      "title": "Link creato!",
      "message": "Il link pubblico è stato creato.",
      "copyLink": "Copia link",
      "warning": "Chiunque abbia questo link può accedere al file.",
      "expiresAt": "Scade",
      "remainingAccesses": "Accessi rimanenti",
      "password": "Password"
    },
    "errors": {
      "linkAlreadyExists": "Esiste già un link pubblico per questo file. Revocalo prima di crearne uno nuovo.",
      "linkNotFound": "Nessun link attivo trovato per questo file.",
      "featureDisabled": "I link pubblici sono disabilitati per la tua organizzazione.",
      "notOwner": "Devi essere il proprietario per creare o revocare link pubblici."
    },
    "passwordTitle": "Contenuto protetto",
    "passwordMessage": "Questo file è protetto da password. Inserisci la password per accedervi.",
    "passwordRequired": "La password è obbligatoria.",
    "errorInvalidPassword": "La password inserita non è corretta. Riprova.",
    "passwordSubmit": "Accedi",
    "errorExpiredTitle": "Link scaduto",
    "errorExpiredMessage": "Questo link di condivisione non è più valido. La data di scadenza è stata superata. Contatta chi ti ha inviato il link per richiederne uno nuovo.",
    "errorMaxAccessTitle": "Accessi esauriti",
    "errorMaxAccessMessage": "Questo link ha raggiunto il numero massimo di accessi consentiti. Contatta chi ti ha inviato il link per richiederne uno nuovo.",
    "errorNotFoundTitle": "Link non valido",
    "errorNotFoundMessage": "Il link che stai cercando di aprire non esiste o è stato revocato dal proprietario. Verifica di aver copiato correttamente l'URL.",
    "folderContents": "Contenuto della cartella",
    "items": "elementi",
    "fileSize": "Dimensione",
    "fileType": "Tipo",
    "sharedAt": "Condiviso il",
    "list": {
      "title": "I miei link pubblici",
      "description": "Gestisci i tuoi link di condivisione pubblica. Revoca un link per disattivarlo.",
      "fileName": "Nome",
      "type": "Tipo",
      "status": "Stato",
      "statusActive": "Attivo",
      "statusExpired": "Scaduto",
      "statusExhausted": "Limite raggiunto",
      "expiresAt": "Scade",
      "accessCount": "Accessi",
      "hasPassword": "Password",
      "empty": "Nessun link pubblico."
    }
  },
  "common": {
    "buttons": "Pulsanti",
    "change": "Cambia",
    "setting": "Impostazione",
    "background": "Sfondo",
    "foreground": "Primo piano",
    "edit": "Modifica",
    "remove": "Rimuovi",
    "settings": "Impostazioni",
    "twoFactorAuthentication": "2FA",
    "debug": "Debug",
    "integrations": "Integrazioni",
    "customizations": "Personalizzazioni",
    "enable": "Abilita",
    "logout": "Esci",
    "features": "Funzionalità",
    "day_one": "{{count}} giorno",
    "day_other": "{{count}} giorni",
    "files": "File",
    "received": "Ricevuti",
    "rename": "Rinomina",
    "cancel": "Annulla",
    "cancelUpload": "Annulla upload",
    "canceled": "Annullato",
    "close": "Chiudi",
    "open": "Apri",
    "createFolder": "Crea cartella",
    "openFolder": "Apri cartella",
    "uploadFolder": "Carica cartella",
    "uploadFile": "Carica file",
    "downloadEncrypted": "Scarica cifrato",
    "createdBy": "Creato da",
    "login": "Accedi",
    "otpCode": "Codice OTP",
    "passkeys": "Passkey",
    "email": "Email",
    "username": "Nome utente",
    "emails": "Email",
    "emailLabel": "Etichetta email",
    "emailPlaceholder": "Segnaposto email",
    "labels": "Etichette",
    "inputs": "Campi di input",
    "loginLabel": "Etichetta accesso",
    "resendOtpLabel": "Etichetta reinvio OTP",
    "otpCodeLabel": "Etichetta codice OTP",
    "allUsers": "Tutti gli utenti",
    "allGroups": "Tutti i gruppi",
    "globalSearchPlaceholder": "Cerca file e cartelle",
    "folderPickerSearchInFolder": "Cerca in questa cartella",
    "globalSearchDescription": "Inizia a digitare per cercare file e cartelle",
    "filterExactMatch": "Corrispondenza esatta (parola intera)",
    "filterWholeWord": "Ricerca tipo like (wildcard)",
    "loading": "Caricamento...",
    "loadingDescription": "Attendere mentre carichiamo i dati",
    "thinking": "Elaborazione...",
    "thinkingDescription": "L'IA sta elaborando la richiesta",
    "noResults": "Nessun risultato trovato",
    "noFilesFound": "Nessun file trovato",
    "hidden": "Nascosti",
    "hide": "Nascondi",
    "lock": "Blocca",
    "file": "File",
    "fileSize": "Dimensione file",
    "tags": "Tag",
    "tag": "Tag",
    "title": "Titolo",
    "users": "Utenti",
    "user": "Utente",
    "systemUser": "Sistema",
    "groups": "Gruppi",
    "createdAt": "Creato il",
    "group": "Gruppo",
    "reviewTeam": "Team di revisione",
    "folder": "Cartella",
    "publicLink": "Link pubblico",
    "publicLinkTitle": "Filegrant Link pubblico",
    "logs": "Log",
    "addUsersOrGroups": "Aggiungi utenti o gruppi",
    "addUsers": "Aggiungi utenti",
    "userTagInputEmptyPlaceholder": "Inizia a digitare per cercare utenti o gruppi",
    "member": "Membro",
    "member_zero": "Nessun membro",
    "member_other": "Membri",
    "uploaded": "Caricati",
    "failed": "Falliti",
    "retries": "Tentativi",
    "preparingFilesForUpload": "Preparazione file per il caricamento",
    "uploadingFilesCounter": "Caricamento file {{amount}} di {{total}}",
    "uploadedFilesCounter": "Caricati {{amount}} di {{total}}",
    "copyLink": "Copia link",
    "unhide": "Mostra",
    "licenseLimitation": "Limitazione licenza",
    "deletionDate": "Data eliminazione",
    "creationDate": "Data creazione",
    "newUser": "Nuovo utente",
    "newGroup": "Nuovo gruppo",
    "noActionsAvailable": "Nessuna azione disponibile",
    "author": "Autore",
    "openProtectedFile": "Apri file protetto",
    "showFilesSharedWith": "Mostra file condivisi con",
    "showFilesSharedBy": "Mostra file condivisi da",
    "upload": "Carica",
    "youCanRequestANewOtpIn": "Puoi richiedere un nuovo OTP tra",
    "otpExpired": "OTP scaduto",
    "otpValidFiveMinutesOnce": "Questo codice è valido per 5 minuti e funziona una sola volta.",
    "generateNewOtp": "Genera nuovo OTP",
    "clickHereToGenerateNewOtp": "Clicca qui per generare un nuovo OTP",
    "preparingFileForDownload": "Preparazione file per il download",
    "preparingForDownload": "Preparazione download",
    "uploadErrors": "Errori di caricamento",
    "uploadErrorsDescription": "Alcuni file non sono stati caricati",
    "size": "Dimensione",
    "status": "Stato",
    "percentage": "Percentuale",
    "viewer": "Sola Lettura",
    "editor": "Editor",
    "shareWith": "Condividi con",
    "retry": "Riprova",
    "regenerate": "Rigenera",
    "permissions": "Permessi",
    "expiration": "Scadenza",
    "message": "Messaggio",
    "uploadingFiles": "Caricamento file",
    "addFiles": "Aggiungi file",
    "addFolders": "Aggiungi cartelle",
    "max": "Max",
    "preview": "Anteprima",
    "quickShare": "Quick share",
    "maxFilesAmountAndSizeEach": "Max {{amount}} file, {{size}}MB ciascuno",
    "startUploadAndShare": "Avvia caricamento e condividi",
    "processing": "Elaborazione",
    "startNewUploadAndShare": "Avvia nuovo caricamento e condividi",
    "continue": "Continua",
    "goToFileManager": "Vai al File Manager",
    "goToQuickShare": "Vai a Quick share",
    "viewAll": "Vedi tutte",
    "emptyUsersList": "Qui puoi trovare gli utenti che hai aggiunto",
    "emptyGroupsList": "Qui puoi trovare i gruppi che hai aggiunto",
    "confirmationMessage": "Messaggio di conferma",
    "lastModified": "Ultima modifica",
    "opened": "Aperto",
    "lastAccess": "Ultimo accesso",
    "accessExpiration": "Scadenza accesso",
    "description": "Descrizione",
    "descriptionNotEditable": "La descrizione non è modificabile",
    "sharedItems": "Elementi condivisi",
    "sharedItemsCount": "{{count}} elemento condiviso",
    "sharedItemsCount_other": "{{count}} elementi condivisi",
    "itemsSharedWith": "Elementi condivisi con <strong>{{resource}}</strong>",
    "manageItems": "Gestisci elementi",
    "items": "Elementi",
    "visibleToAdminsOnly": "Visibile solo agli admin",
    "loginAlias": "Alias di accesso / Numero dipendente",
    "loginAliasManagedBy": "Gestito da {{source}}",
    "loginAliasManagedWarning": "Modificare questo alias interrompe gli aggiornamenti automatici dalla directory.",
    "loginAliasSourceEntraId": "Entra ID",
    "loginAliasSourceActiveDirectory": "Active Directory",
    "employeeId": "ID dipendente",
    "searchUsersIncludingAlias": "Cerca utenti (nome, email o alias)...",
    "pleaseEnterName": "Inserisci un nome",
    "pleaseEnterFirstName": "Inserisci un nome",
    "pleaseEnterLastName": "Inserisci un cognome",
    "pleaseEnterEmail": "Inserisci un'email",
    "invalidEmail": "L'indirizzo email non è valido",
    "nameCannotBeEmail": "Il nome non può essere un'email",
    "publicLinkSearchHint": "La ricerca filtra la cartella dopo il caricamento di tutte le pagine",
    "companyTag": "Tag aziendale",
    "replace": "Sostituisci",
    "fileName": "Nome file",
    "enterFileName": "Inserisci il nome del file",
    "new": "Nuovo",
    "organize": "Organizza",
    "downloadFile": "Scarica file",
    "expiry": "Scadenza",
    "downloadPdf": "Scarica PDF",
    "downloadEncryptedFile": "Scarica file cifrato",
    "save": "Salva",
    "createShortcut": "Crea collegamento",
    "create": "Crea",
    "createShortcutFor": "Crea collegamento per {{resource}}",
    "selectFolderToCreateFileShortcut": "Seleziona una posizione per mostrare il percorso della cartella in cui verrà creato il file",
    "editUser": "Modifica utente",
    "unblockUser": "Sblocca utente",
    "blockUser": "Blocca utente",
    "deleteUser": "Elimina utente",
    "excludeFromSso": "Escludi dall'SSO",
    "includeInSso": "Riabilita SSO",
    "confirm": "Conferma",
    "search": "Cerca",
    "noUsersFound": "Nessun utente trovato",
    "noSettingsFound": "Nessuna impostazione trovata",
    "block": "Blocca",
    "unblock": "Sblocca",
    "role": "Ruolo",
    "addedOn": "Aggiunto il",
    "memberOfNGroups": "Membro di N° gruppi",
    "noExpirationDate": "Nessuna data di scadenza",
    "groupsMember": "Membro dei gruppi",
    "onBehalfOf": "Per conto di",
    "exitFromBehalfOfMode": "Esci dalla modalità per conto di",
    "expiryDate": "Data di scadenza",
    "select": "Seleziona",
    "nothingHasBeenSharedYet": "Non è ancora stato condiviso nulla",
    "manageGroups": "Gestisci gruppi",
    "noGroupsYet": "Nessun gruppo",
    "addExpirationDate": "Aggiungi data di scadenza",
    "editExpirationDate": "Modifica data di scadenza",
    "edited": "Modificato",
    "removed": "Rimosso",
    "removeExpirationDate": "Rimuovi data di scadenza",
    "usersWithSharedFiles": "Utenti con file condivisi",
    "usersWithoutSharedFiles": "Utenti senza file condivisi",
    "changeRole": "Cambia ruolo",
    "yes": "Sì",
    "no": "No",
    "selected": "Selezionati",
    "editGroup": "Modifica gruppo",
    "viewGroup": "Visualizza gruppo",
    "numberOfMembers": "N° membri",
    "groupMembers": "Membri del gruppo",
    "editGroups": "Modifica gruppi",
    "noUsers": "Nessun utente",
    "deleteGroup": "Elimina gruppo",
    "documents": "Documenti",
    "images": "Immagini",
    "audio": "Audio",
    "video": "Video",
    "other": "Altro",
    "fileExtensionType": {
      "Text": "Testo",
      "SourceCode": "Codice sorgente",
      "Markup": "Markup",
      "Data": "Dati",
      "Image": "Immagine",
      "Video": "Video",
      "Audio": "Audio",
      "Document": "Documento",
      "Spreadsheet": "Foglio di calcolo",
      "Presentation": "Presentazione",
      "Archive": "Archivio",
      "Database": "Database",
      "Font": "Font",
      "System": "Sistema",
      "Executable": "Eseguibile",
      "Configuration": "Configurazione",
      "Log": "Log",
      "Backup": "Backup",
      "Certificate": "Certificato",
      "Model3D": "Modello 3D",
      "CAD": "CAD",
      "GIS": "GIS",
      "Scientific": "Scientifico",
      "EBook": "E-Book",
      "Vector": "Vettoriale",
      "Raw": "Raw"
    },
    "fileTypes": "Tipi di file",
    "download": "Scarica",
    "share": "Condividi",
    "createCopy": "Crea copia",
    "markAsRead": "Segna come letto",
    "markAsUnread": "Segna come non letto",
    "move": "Sposta",
    "convertToPdf": "Converti in PDF",
    "convert": "Converti",
    "wordDocument": "Documento Word",
    "excelDocument": "Documento Excel",
    "pptDocument": "Documento PowerPoint",
    "hideFromList": "Nascondi dalla lista",
    "showInList": "Mostra nella lista",
    "editAccessAndProtections": "Modifica accesso e protezioni",
    "tagColor": "Colore tag",
    "tagName": "Nome tag",
    "addToFavorites": "Aggiungi ai preferiti",
    "removeFromFavorites": "Rimuovi dai preferiti",
    "deletePermanently": "Elimina definitivamente",
    "delete": "Elimina",
    "selectedItems": "Elementi selezionati",
    "deselectAll": "Deseleziona tutto",
    "signOut": "Esci",
    "tagTitle": "Titolo tag",
    "noTagsYet": "Nessun tag",
    "untitledDocument": "Documento senza titolo",
    "copyOf": "Copia di",
    "restoreFromTrash": "Ripristina dal cestino",
    "shared": "Condivisi",
    "expiresOn": "Scade il {{date}}",
    "shareExpiredOn": "Condivisione scaduta il {{date}}",
    "favourite": "Preferito",
    "favouriteAddedTo": "aggiunto ai",
    "favouriteRemovedFrom": "rimosso dai",
    "publicLinkLabel": "Link pubblico",
    "classificationInProgress": "Classificazione in corso",
    "forSale": "In vendita",
    "favorites": "Preferiti",
    "recent": "Recenti",
    "transferOwnership": "Trasferisci proprietà",
    "trash": "Cestino",
    "expirationDate": "Data di scadenza",
    "details": "Dettagli",
    "unlock": "Sblocca",
    "activities": "Attività",
    "copyToClipboard": "Copia negli appunti",
    "fileType": "Tipo di file",
    "noTagsApplied": "Non sono stati applicati tag a questo file",
    "notSharedYet": "Non ancora condiviso",
    "manageAccess": "Gestisci accesso",
    "selectItemToViewDetails": "Seleziona un elemento per visualizzare i dettagli",
    "unlockFolderToViewDetails": "Sblocca la cartella per visualizzare i dettagli",
    "unlockFolderToViewSize": "Sblocca la cartella per visualizzare la dimensione",
    "folderContent": "Contenuto della cartella",
    "calculateFolderSize": "Calcola dimensione",
    "recalculate": "Ricalcola",
    "recalculateCooldown": "Attendi un momento prima di ricalcolare",
    "subfolders": "Sottocartelle",
    "totalSize": "Dimensione totale",
    "filters": "Filtri",
    "owner": "Proprietario",
    "linkCopied": "Link copiato negli appunti!",
    "account": "Account",
    "customization": "Personalizzazione",
    "adminRegisteredUserVisibility": "Visibilità utenti registrati dagli admin",
    "adminRegisteredUserVisibilityDescription": "Rendi visibili gli utenti registrati dagli admin se non disattivato; visibilità principalmente via condivisione file.",
    "autoFileDeletion": "Eliminazione automatica file",
    "autoFileDeletionDescription": "Elimina automaticamente i file dopo una data e un periodo di conservazione.",
    "cannotOpenFileOnBehalf": "Non puoi aprire file in modalità Per Conto Di.",
    "certifiedTimestamping": "Marca temporale certificata",
    "certifiedTimestampingDescription": "Consenti di applicare una data certificata ai file con certificato digitale.",
    "compressionCompleted": "Compressione completata",
    "compressionFailed": "Compressione non riuscita",
    "compressionOfFilesInProgress": "Compressione file in corso",
    "verifyingFileIntegrity": "Verifica integrità file in corso...",
    "fileIntegrityVerified": "Integrità file verificata",
    "downloadCompletedWithExclusions": "Download completato, ma alcuni file sono stati esclusi",
    "moveCompletedWithExclusions": "Spostamento completato, ma alcuni file non sono stati spostati",
    "filesExcludedForMove": "I seguenti file non sono stati spostati:",
    "excludedFilesTitle": "File esclusi",
    "viewExcludedFiles": "Visualizza i file esclusi",
    "filesExcludedForRestrictions": "Alcuni file sono stati esclusi a causa di restrizioni:",
    "contributorStorageLimit": "Limite spazio contributor",
    "contributorStorageLimitDescription": "Imposta limiti di spazio per il caricamento di nuovi file.",
    "contents": "Contenuti",
    "deviceAccessLimitation": "Limitazione accesso dai dispositivi",
    "deviceAccessLimitationDescription": "Limita l'accesso a un numero di dispositivi e disconnetti quelli più vecchi.",
    "downloadPreparation": "Preparazione download",
    "downloadReady": "Download pronto",
    "editorFileManagement": "Gestione file per Editor",
    "editorFileManagementDescription": "Consenti di eliminare e rinominare file secondo i permessi.",
    "fileSizeLimit": "Limite dimensione file",
    "fileSizeLimitDescription": "Limita la dimensione massima dei file caricabili.",
    "fileTypeRestriction": "Restrizione tipi di file",
    "fileTypeRestrictionDescription": "Consenti agli utenti di condividere tutti o solo selezionati tipi di file.",
    "folderCreationPermission": "Permesso creazione cartelle",
    "folderCreationPermissionDescription": "Definisci se i contributor possono creare nuove cartelle.",
    "groupCreationControl": "Controllo creazione gruppi",
    "groupCreationControlDescription": "Controlla quali contributor possono creare gruppi.",
    "members": "Membri",
    "msOfficeEditing": "Modifica Word, Excel, PowerPoint",
    "msOfficeEditingDescription": "Permetti di modificare i documenti con l'editor online di Microsoft Office.",
    "newButton": "Nuovo",
    "security": "Sicurezza",
    "sessionControl": "Controllo sessione",
    "sessionControlDescription": "Limita il numero di sessioni concorrenti per utente.",
    "sessions": "Sessioni",
    "superAdmins": "Super admin",
    "uploadWithTag": "Upload con tag",
    "uploadWithTagDescription": "Rileva e imposta automaticamente i tag dai file sorgente.",
    "watermarkProtection": "Protezione watermark",
    "watermarkProtectionDescription": "Consenti ai membri di proteggere i file con watermark.",
    "withExpiration": "Con scadenza",
    "withoutExpiration": "Senza scadenza",
    "addTag": "Aggiungi tag",
    "openFileLocation": "Apri percorso file",
    "loadingTags": "Caricamento tag...",
    "unlimited": "Illimitato",
    "dropHereYourFirstFile": "Trascina qui il tuo primo file",
    "noFilesReceived": "Nessun file ricevuto",
    "hereYouCanFindFavoritesFiles": "Qui trovi i tuoi file preferiti",
    "noRecentlyOpenedFiles": "Nessun file aperto di recente",
    "hereYouCanFindSharedFiles": "Qui trovi i file condivisi",
    "hereYouCanFindDeletedFiles": "Qui trovi i file eliminati",
    "noFiles": "Nessun file",
    "loadingFiles": "Caricamento file...",
    "filesFetchFailed": "Impossibile caricare i file. Controlla la connessione e riprova.",
    "shareDisabledNoRecipients": "Aggiungi almeno un utente o un gruppo per condividere",
    "shareDisabledNoChanges": "Nessuna modifica da salvare",
    "editorDisabledByPolicy": "Il permesso Editor non è consentito per questi file",
    "editorDisabledCannotElevate": "Non puoi elevare questa condivisione a Editor",
    "hereYouCanFindHiddenFiles": "Qui trovi i file nascosti",
    "noFilesInThisFolder": "Nessun file in questa cartella",
    "noGroupsFound": "Nessun gruppo trovato",
    "sell": "Vendi",
    "loadingPermissions": "Caricamento permessi...",
    "me": "Io",
    "applyTags": "Applica tag",
    "emptyTrash": "Svuota cestino",
    "classify": "Classificazione IA",
    "active": "Attivo",
    "activeDescription": "Abilita o disabilita questa impostazione",
    "add": "Aggiungi",
    "rule": "Regola",
    "selectTags": "Seleziona tag",
    "manageExceptions": "Gestisci eccezioni",
    "selectFolders": "Seleziona cartelle",
    "selectUsers": "Seleziona utenti",
    "selectGroups": "Seleziona gruppi",
    "selectDate": "Seleziona data",
    "none": "Nessuno",
    "addRule": "Aggiungi regola",
    "addConfiguration": "Aggiungi configurazione",
    "aiAgents": "Agenti IA",
    "daysLeft": "giorni restanti",
    "disabled": "Disabilitato",
    "enabled": "Abilitato",
    "months": "Mesi",
    "years": "Anni",
    "totpStatus": {
      "enabled": "2FA attiva",
      "enabledExempt": "2FA attiva (esente)",
      "exempt": "Esente da 2FA",
      "exemptExpires": "Esente fino al {{date}}"
    },
    "clientId": "Client ID",
    "clientSecret": "Client Secret",
    "tenantId": "Tenant ID",
    "domains": "Domini",
    "addDomain": "Aggiungi dominio",
    "addItem": "Aggiungi elemento",
    "artificialIntelligence": "Intelligenza Artificiale",
    "artificialIntelligenceSummary": "Riepilogo IA",
    "artificialIntelligenceDocumentChat": "Chat con documento",
    "generatingSummary": "Generazione riepilogo",
    "startNewConversation": "Avvia una nuova conversazione",
    "groupMembership": "Appartenenza al gruppo",
    "expired": "Scaduto",
    "onlyExpired": "Scadenza",
    "expiredOnly": "Solo scadute",
    "expiringWithinDays": "In scadenza entro",
    "expiringWithinDaysOption": "{{count}} giorni",
    "expiringWithinDaysOption_one": "{{count}} giorno",
    "sharedBy": "Condiviso da",
    "shareRequests": "Richieste di condivisione",
    "fileShareRequests": "Richieste di condivisione file",
    "noShareRequests": "Nessuna richiesta di condivisione",
    "activityLog": "Registro attività",
    "targetType": "Tipo di target",
    "operationType": "Tipo di operazione",
    "fromDate": "Dalla data",
    "toDate": "Alla data",
    "classificationStatus": "Classificazione IA",
    "invite": "Invita",
    "send": "Invia",
    "target": "Target",
    "operation": "Operazione",
    "timestamp": "Timestamp",
    "export": "Esporta",
    "exportActivityLogsDescription": "Esporta i log attività visibili in un file CSV",
    "clickForDetailAiClassification": "Clicca per i dettagli della classificazione IA",
    "aiClassificationStatus": "Stato classificazione IA",
    "noActivityLogsFound": "Nessun log attività trovato",
    "activityLogQuickFilters": {
      "clearDatesAndOperation": "Azzera filtri data e tipo",
      "downloads24h": "Download file nelle ultime 24 ore",
      "failedLogins7d": "Accessi falliti negli ultimi 7 giorni",
      "last24hAllActivity": "Tutta l'attività nelle ultime 24 ore",
      "last24hLogins": "Accessi nelle ultime 24 ore",
      "last7DaysAllActivity": "Tutta l'attività negli ultimi 7 giorni",
      "sharing7d": "Condivisioni file negli ultimi 7 giorni",
      "title": "Predefiniti filtri"
    },
    "waitingForUpload": "In attesa di caricamento",
    "waitingForNetwork": "In attesa di rete",
    "uploadsPausedWaitingForNetwork": "Caricamenti in pausa — in attesa della connessione di rete",
    "offline": "Offline",
    "noPermissions": "Nessun permesso",
    "additionalData": "Dati aggiuntivi",
    "noActivities": "Nessuna attività",
    "multipleOwners": "Più proprietari",
    "mixed": "Misti",
    "firstName": "Nome",
    "lastName": "Cognome",
    "multipleExpiryDates": "Più date di scadenza",
    "copied": "Copiato!",
    "copy": "Copia",
    "editFile": "Modifica file",
    "untitled": "Senza titolo",
    "editModeEnabled": "Modalità modifica abilitata",
    "exitEditMode": "Esci dalla modalità modifica",
    "editModeDisabled": "Modalità modifica disabilitata",
    "reload": "Ricarica",
    "forward10Seconds": "Avanti di 10 secondi",
    "backward10Seconds": "Indietro di 10 secondi",
    "goToStart": "Vai all'inizio",
    "goToEnd": "Vai alla fine",
    "playbackSpeed": "Velocità di riproduzione",
    "error": "Errore",
    "shareAgain": "Condividi di nuovo",
    "expiringSoon": "In scadenza",
    "filterByTargetOrOperation": "Filtra per target o operazione",
    "searchByFileName": "Cerca per nome file",
    "versions": "Versioni",
    "version": "Versione",
    "restore": "Ripristina",
    "showMoreVersions": "Mostra più versioni",
    "showLessVersions": "Mostra meno versioni",
    "currentVersion": "Versione corrente",
    "bold": "Grassetto",
    "italic": "Corsivo",
    "link": "Link",
    "unorderedList": "Elenco puntato",
    "orderedList": "Elenco numerato",
    "header1": "Intestazione 1",
    "header2": "Intestazione 2",
    "header3": "Intestazione 3",
    "paragraph": "Paragrafo",
    "secondsAgo": "secondi fa",
    "all": "Tutti",
    "dataLossPrevention": "Prevenzione perdita dati",
    "uploadSuccess": "Caricamento riuscito",
    "uploading": "Caricamento in corso",
    "readOnly": "Sola lettura",
    "aiScrapingProtectionOn": "Protezione scraping AI attiva",
    "openFileLocally": "Apri file localmente",
    "reloadPage": "Ricarica pagina",
    "reloadingPageIn": "La pagina verrà ricaricata in <strong>{{count}}</strong>",
    "keepOffline": "Sincronizza in locale",
    "openFileOnline": "Apri file online",
    "saveAndContinue": "Salva e continua",
    "cancelAndContinue": "Annulla e continua",
    "language": "Lingua",
    "colorScheme": {
      "title": "Aspetto",
      "light": "Chiaro",
      "dark": "Scuro",
      "system": "Segui sistema"
    },
    "accessibility": {
      "title": "Accessibilità",
      "highContrast": "Alto contrasto",
      "reduceMotion": "Riduci movimento",
      "none": "Disattivato",
      "activeCount": "{{count}} attive"
    },
    "impersonateUser": "Impersona utente",
    "protect": "Proteggi",
    "setPassword": "Imposta password",
    "password": "Password",
    "stopImpersonation": "Interrompi impersonazione",
    "loggedInAs": "Connesso come",
    "enterReason": "Inserisci il motivo dell'impersonation...",
    "timeRemaining": "Tempo rimanente",
    "notifications": "Notifiche",
    "clear": "Cancella",
    "markAllRead": "Segna tutte come lette",
    "clearAll": "Cancella tutto",
    "noNotifications": "Nessuna notifica",
    "batches": "Batch",
    "noActiveBatches": "Nessun batch attivo",
    "refresh": "Aggiorna",
    "refreshCooldown": "Attendi {{seconds}}s prima di aggiornare di nuovo",
    "minutes": "minuti",
    "justNow": "Ora",
    "minutesAgo": "{{count}} minuto fa",
    "minutesAgo_other": "{{count}} minuti fa",
    "hoursAgo": "{{count}} ora fa",
    "hoursAgo_other": "{{count}} ore fa",
    "daysAgo": "{{count}} giorno fa",
    "daysAgo_other": "{{count}} giorni fa",
    "monthsAgo": "{{count}} mese fa",
    "monthsAgo_other": "{{count}} mesi fa",
    "yearsAgo": "{{count}} anno fa",
    "yearsAgo_other": "{{count}} anni fa",
    "inMinutes": "tra {{count}} minuto",
    "inMinutes_other": "tra {{count}} minuti",
    "inHours": "tra {{count}} ora",
    "inHours_other": "tra {{count}} ore",
    "inDays": "tra {{count}} giorno",
    "inDays_other": "tra {{count}} giorni",
    "inMonths": "tra {{count}} mese",
    "inMonths_other": "tra {{count}} mesi",
    "inYears": "tra {{count}} anno",
    "inYears_other": "tra {{count}} anni",
    "fileNotFound": "File non trovato",
    "selectAll": "Seleziona tutto",
    "clearSelection": "Deseleziona",
    "import": "Importa",
    "noFilesMatchingFilters": "Nessun file trovato, prova a rimuovere alcuni filtri o cambiare i criteri di ricerca",
    "noUsersMatchingFilters": "Nessun utente trovato, prova a rimuovere alcuni filtri o cambiare i criteri di ricerca",
    "noGroupsMatchingFilters": "Nessun gruppo trovato, prova a rimuovere alcuni filtri o cambiare i criteri di ricerca",
    "AIGrant": "AIGrant",
    "manageUsersAndGroups": "Gestisci utenti e gruppi",
    "public": "Pubblico",
    "private": "Privato",
    "searchTags": "Cerca tag",
    "expand": "Espandi",
    "showMore": "Mostra di più",
    "collapse": "Comprimi",
    "approved": "Approvato",
    "rejected": "Rifiutato",
    "pending": "In attesa",
    "pendingApprovalTooltip": "In attesa di approvazione, richiesta {{date}}",
    "approvedByTeamTooltip": "Condivisione approvata dal team {{date}}",
    "rejectedByTeamTooltip": "Condivisione rifiutata dal team {{date}}",
    "reject": "Rifiuta",
    "rejectFileShareRequest": "Rifiuta richiesta di condivisione",
    "rejectionReason": "Motivo del rifiuto",
    "rejectionReasonPlaceholder": "Inserisci il motivo del rifiuto",
    "moreOwners": "Altri proprietari",
    "permissionLevel": "Livello di permesso",
    "name": "Nome",
    "approve": "Approva",
    "from": "Da",
    "to": "a",
    "requester": "Richiedente",
    "shareTo": "Condivisione Verso",
    "limitation": "Limitazione",
    "selectRequestToViewDetails": "Seleziona una richiesta per visualizzare i dettagli",
    "shareRequestApprovalTitle": "Richiesta di approvazione condivisione di {{fileName}}",
    "noFilesAvailable": "Nessun file disponibile",
    "accessDenied": "Accesso Negato",
    "fileShareRequestsList": "Elenco richieste di condivisione file",
    "fileShareRequestsDescription": "Approva o rifiuta le richieste di condivisione file. Clicca su una richiesta sul lato sinistro per visualizzarne i dettagli.",
    "waiting": "In attesa",
    "tagIsUsedForFileVisibility": "I file con questo tag sono condivisi con altri utenti come impostato nelle impostazioni di visibilità dei file con tag",
    "systemTagLocked": "Tag di sistema gestito dal server: non può essere rimosso.",
    "tagRemovalRestricted": "L'amministratore non consente di rimuovere questo tag dai file.",
    "tagAdditionRestricted": "L'amministratore non consente di aggiungere questo tag ai file.",
    "completingLogin": "Completamento accesso...",
    "redirectingToLogin": "Reindirizzamento alla pagina di accesso...",
    "redirecting": "Reindirizzamento...",
    "sessionExpiresIn": "Questa cartella verrà bloccata di nuovo tra {{time}}",
    "protectedFolder": "Cartella protetta",
    "sessionsTitle": "Sessioni di sblocco per {{fileName}}",
    "folderSessions": "Sessioni cartelle",
    "publicLinks": "Link pubblici",
    "revoke": "Revoca",
    "revokeLink": "Revoca link pubblico",
    "revokeLinkConfirmDescription": "Revocare il link pubblico per {{fileName}}?",
    "protectedContentTitle": "Contenuto protetto",
    "protectedContentMessage": "Questo contenuto è protetto da password. Inserisci la password per accedere.",
    "accessCodeRequired": "La password è obbligatoria.",
    "accessCodeLabel": "Password",
    "accessCodePlaceholder": "Inserisci password",
    "access": "Accedi",
    "folderContents": "Contenuto cartella",
    "sharedAt": "Condiviso il",
    "alerts": {
      "moreCount": "{{count}} altri avvisi",
      "manageTwoFactor": "Gestisci 2FA",
      "dismissMenu": "Posticipa o nascondi",
      "snoozePreset": {
        "h24": "1 giorno",
        "h72": "3 giorni",
        "h168": "1 settimana"
      },
      "snoozeHoursGeneric": "{{count}} ore"
    },
    "usersFetchFailed": "Impossibile caricare gli utenti. Controlla la connessione e riprova.",
    "groupsFetchFailed": "Impossibile caricare i gruppi. Controlla la connessione e riprova.",
    "emailsFetchFailed": "Impossibile caricare le email. Controlla la connessione e riprova.",
    "pleaseSelectRole": "Seleziona un ruolo",
    "selectColor": "Seleziona colore",
    "color": "Colore",
    "loadingActivities": "Caricamento attività...",
    "quickShareMessagePlaceholder": "Scrivi un messaggio agli utenti selezionati...",
    "signFile": "Firma file"
  },
  "totp": {
    "title": "Autenticazione a due fattori",
    "menuItem": "Autenticazione a due fattori",
    "statusActive": "Attivo",
    "statusInactive": "Inattivo",
    "activatedOn": "Attivato il {{date}}",
    "backupCodesRemaining": "{{count}} / {{total}} codici di backup rimanenti",
    "requiredByPolicy": "La tua azienda richiede l'autenticazione a due fattori.",
    "gracePeriodEnds": "Hai tempo fino al {{date}} per attivarla.",
    "activate": "Attiva 2FA",
    "setupTitle": "Configura autenticazione a due fattori",
    "scanQR": "Scansiona questo codice QR con la tua app authenticator (Google Authenticator, Microsoft Authenticator, Authy, ecc.).",
    "manualEntry": "Non riesci a scansionare? Inserisci manualmente",
    "hideManual": "Nascondi inserimento manuale",
    "enterSecretManually": "Inserisci questo codice manualmente nell'app:",
    "copySecret": "Copia",
    "copied": "Copiato negli appunti",
    "verifyCodeLabel": "Inserisci il codice a 6 cifre dall'app",
    "verifyAndActivate": "Verifica e attiva",
    "backupCodesTitle": "Autenticazione a due fattori attivata!",
    "regenerateSuccess": "Codici di backup rigenerati",
    "backupCodesWarning": "Salva questi codici di backup in un posto sicuro. Possono essere usati per accedere al tuo account se perdi l'accesso all'app authenticator. Ogni codice può essere usato una sola volta.",
    "copyAll": "Copia tutti",
    "download": "Scarica",
    "print": "Stampa",
    "savedConfirm": "Ho salvato i codici in un posto sicuro",
    "continue": "Continua",
    "regenerateBackupCodes": "Rigenera codici di backup",
    "disableTotp": "Disabilita 2FA",
    "disableConfirm": "Disabilitare l'autenticazione a due fattori?",
    "disableConfirmDescription": "Rimuovere la 2FA renderà il tuo account meno sicuro. Dovrai riconfigurare l'app authenticator se vorrai riattivare la 2FA in futuro.",
    "enterCodeToConfirm": "Inserisci il codice TOTP per confermare",
    "cancel": "Annulla",
    "disable": "Disabilita",
    "disabledSuccess": "L'autenticazione a due fattori è stata disattivata.",
    "invalidCode": "Codice non valido. Riprova.",
    "errorGeneric": "Si è verificato un errore. Riprova.",
    "retry": "Riprova",
    "admin": {
      "modalTitle": "2FA – {{userName}}",
      "statusTitle": "Stato 2FA",
      "totpEnabled": "TOTP abilitato",
      "enabledAt": "Data abilitazione",
      "backupCodesRemaining": "Codici di backup rimanenti",
      "requiredByPolicy": "Richiesto da policy",
      "lockoutStatus": "Stato lockout",
      "failedAttempts": "Tentativi falliti",
      "exemptionTitle": "Esenzione TOTP",
      "grantExemption": "Concedi esenzione",
      "revokeExemption": "Revoca esenzione",
      "exemptionTypeTemporary": "Temporanea",
      "exemptionTypePermanent": "Permanente",
      "exemptionTypeLabel": "Tipo",
      "exemptionExpires": "Scade il",
      "exemptionReason": "Motivo",
      "grantedBy": "Concessa da",
      "grantedAt": "Data concessione",
      "grantDialogTitle": "Concedi esenzione",
      "grantDialogTemporary": "Temporanea",
      "grantDialogPermanent": "Permanente",
      "grantDialogDays": "Giorni",
      "grantDialogReason": "Motivo (min 5 caratteri)",
      "grantSubmit": "Concedi",
      "revokeConfirmTitle": "Revoca esenzione",
      "revokeConfirmDescription": "L'utente dovrà nuovamente rispettare la policy 2FA.",
      "disableConfirmTitle": "Disabilitare la 2FA per questo utente?",
      "disableConfirmDescription": "Verrà rimossa l'autenticazione a due fattori per l'utente. Dovrà riconfigurarla se richiesta dalla policy.",
      "statusLoading": "Caricamento…",
      "statusError": "Impossibile caricare lo stato 2FA.",
      "grantSuccess": "Esenzione concessa.",
      "revokeSuccess": "Esenzione revocata.",
      "disableSuccess": "2FA disabilitata."
    }
  },
  "roles": {
    "1000": "Super Admin",
    "1001": "Admin",
    "2001": "Contributor",
    "3002": "Reader",
    "4001": "Esterno"
  },
  "accessMap": {
    "tagAccessTabLabel": "Accesso e protezioni",
    "entityAccessTabLabel": "Tag e protezioni",
    "visibility": "Visibilità",
    "appliedProtections": "Protezioni applicate",
    "appliedTo": "Applicato a",
    "appliedToNobody": "Nessuno riceve attualmente questa protezione tramite questo tag.",
    "configuration": "Configurazione",
    "exceptions": "Eccezioni",
    "exceptionsCount": "{{count}} eccezione",
    "exceptionsCount_one": "{{count}} eccezione",
    "exceptionsCount_other": "{{count}} eccezioni",
    "hasExceptionsTooltip": "Alcuni destinatari sono esclusi da questa protezione.",
    "openInSettings": "Apri nelle impostazioni",
    "noProtectionsForTag": "Nessuna protezione applicata a questo tag.",
    "noProtectionsForThisTag": "Nessuna protezione ereditata da questo tag.",
    "configureProtection": "Configura una protezione",
    "publicTagShort": "Pubblico",
    "privateTagShort": "Privato",
    "allUsersInCompany": "Tutti gli utenti dell'azienda",
    "tagNotShared": "Questo tag non è ancora stato condiviso con nessuno.",
    "protectionsCount": "{{count}} protezione",
    "protectionsCount_one": "{{count}} protezione",
    "protectionsCount_other": "{{count}} protezioni",
    "inheritedFromGroups": "Visibile tramite i gruppi: {{groups}}",
    "tagsVisibleToGroup": "Tag visibili a questo gruppo ({{count}})",
    "tagsVisibleToUser": "Tag visibili a questo utente ({{count}})",
    "rulesAppliedToGroup": "Regole di protezione applicate a questo gruppo ({{count}})",
    "rulesAppliedToUser": "Regole di protezione applicate a questo utente ({{count}})",
    "userSeesNoTags": "Questo utente non vede alcun tag.",
    "groupSeesNoTags": "Questo gruppo non vede alcun tag.",
    "tagNoRulesLead": "I file con questo tag non attivano alcuna regola specifica per questo gruppo.",
    "tagRulesLead": "I file con questo tag attivano la seguente regola:",
    "tagRulesLead_one": "I file con questo tag attivano la seguente regola:",
    "tagRulesLead_other": "I file con questo tag attivano le seguenti {{count}} regole:",
    "summary": {
      "action": "Azione",
      "behaviour": "Comportamento",
      "readOnlyRoles": "Ruoli in sola lettura",
      "showRecipients": "Mostra destinatari originali",
      "allowEdit": "Consenti modifica",
      "readOnlyMode": "Modalità sola lettura",
      "watermarkText": "Testo watermark",
      "placement": "Posizione",
      "appliesToExternal": "Enforcement per utenti esterni",
      "approvedDomains": "Domini approvati",
      "maxExpirationDays": "Durata massima consentita",
      "excludedDomains": "Domini esclusi",
      "excludedGroups": "Gruppi esclusi",
      "requireApprovalOnShare": "Approvazione generale richiesta",
      "requireApprovalOnReshare": "Approvazione solo per ri-condivisioni",
      "reviewTeamSize": "Team di revisione",
      "hiddenFileTypes": "Invisibile dopo la condivisione",
      "allowedApplications": "Applicazioni consentite",
      "rolesAllowed": "Audience"
    }
  },
  "alerts": {
    "codes": {
      "TOTP_NOT_ENABLED": {
        "message": "È richiesta l'autenticazione a due fattori. Attivala per proteggere il tuo account."
      },
      "LICENSE_EXPIRING": {
        "message": "La licenza scade il {{expirationDate}} (mancano {{daysRemaining}} giorni)."
      },
      "LOW_BACKUP_CODES": {
        "message": "Hai pochi codici di backup ({{remaining}}). Rigenerali nelle impostazioni 2FA."
      },
      "_generic": {
        "message": "Hai un avviso attivo ({{code}}). Contatta l'amministratore se serve assistenza."
      }
    }
  },
  "errors": {
    "required": "Questo campo è obbligatorio",
    "minLength": "Deve essere di almeno {{min}} caratteri",
    "authenticatorCodeInvalid": "Il codice dell'autenticatore non è valido.",
    "authenticatorNotRemoved": "Si è verificato un errore durante la rimozione dell'autenticatore.",
    "authenticationUserBlocked": "L'utente è bloccato. Contatta l'amministratore.",
    "authenticationUserExpired": "L'utente è scaduto. Contatta l'amministratore.",
    "codeIncorrect": "Il codice inserito non è corretto. Riprova.",
    "genericDeleteError": "Si è verificato un errore durante l'eliminazione di {{resource}}. Riprova o contatta il supporto se il problema persiste.",
    "genericError": "Si è verificato un errore. Riprova o contatta il supporto se il problema persiste.",
    "genericFetchError": "Si è verificato un errore durante il recupero di {{resource}}. Riprova o contatta il supporto se il problema persiste.",
    "userProfileUnavailable": "Non siamo riusciti a caricare il profilo. Rimani connesso con permessi limitati finché non sarà risolto.",
    "userProfileStale": "Non siamo riusciti ad aggiornare il profilo. Sei ancora connesso con gli ultimi permessi noti.",
    "userProfileRetry": "Riprova",
    "alerts": {
      "dismissFailed": "Impossibile aggiornare l'avviso. Riprova.",
      "invalidSnooze": "Scegli una durata di posticipo valida.",
      "fetchFailed": "Impossibile caricare gli avvisi. Verranno riprovati automaticamente."
    },
    "sessionsFetchError": "Errore nel recupero delle sessioni.",
    "sessionsRevokeError": "Errore nella revoca della sessione.",
    "sessionsRevokeForbiddenError": "Non hai i permessi per revocare le sessioni di questo utente.",
    "sessionsRevokeOthersError": "Errore nella revoca delle altre sessioni.",
    "sessionsRevokeAllError": "Errore nella revoca di tutte le sessioni.",
    "genericUpdateError": "Si è verificato un errore durante l'aggiornamento di {{resource}}. Riprova o contatta il supporto se il problema persiste.",
    "genericCreateError": "Si è verificato un errore durante la creazione di {{resource}}. Riprova o contatta il supporto se il problema persiste.",
    "invalidCredentials": "Email o password non corretti. Verifica le credenziali e riprova.",
    "invalidUsername": "Il nome utente inserito non è valido.",
    "tokenInvalid": "Il token fornito non è valido o è scaduto.",
    "tokenExpired": "Token di accesso scaduto",
    "unsavedChangesMessage": "Hai modifiche non salvate. Sei sicuro di voler uscire e perdere queste modifiche?",
    "unsavedChangesTitle": "Rilevate modifiche non salvate.",
    "licenseExpired": "La licenza è scaduta. Rinnova la licenza.",
    "licenseMaxUsersReached": "È stato raggiunto il numero massimo di utenti consentito dalla licenza. Non è possibile aggiungere nuovi utenti né assegnare ruoli non esterni agli utenti esistenti.",
    "mandatoryClassificationCannotRemove": "Non è possibile rimuovere tutti i tag di classificazione. Deve restarne almeno uno perché la classificazione obbligatoria dei file è attiva nelle impostazioni dell'organizzazione.",
    "tagRemovalDenied": "Non sei autorizzato a rimuovere uno o più dei tag selezionati da questo file.",
    "tagAdditionDenied": "Non sei autorizzato ad aggiungere uno o più dei tag selezionati a questo file.",
    "emailNotFound": "L'indirizzo email {{email}} non è registrato. Verifica l'indirizzo email e riprova.",
    "invalidEmailOrUsername": "Inserisci un'email o un nome utente valido",
    "loginAliasNotValid": "Questo alias di accesso non è valido. Usa solo lettere, cifre e . _ - @ + ' (max 256 caratteri).",
    "loginAliasAlreadyUsed": "Questo alias di accesso è già usato da un altro utente.",
    "loginAliasAlreadyUsedAsEmail": "Questa email è già usata come alias di accesso di un altro utente.",
    "otpExpired": "L'OTP è scaduto. Richiedi un nuovo OTP.",
    "totpWrong": "Codice 2FA non valido. Riprova.",
    "temporaryTotpExpired": "Il tempo per completare il login è scaduto.",
    "errorAdminTotpResetNotAllowed": "Impossibile disattivare la 2FA: la tua organizzazione non consente agli amministratori di reimpostare il TOTP degli utenti. Un super amministratore può abilitarlo nelle impostazioni di autenticazione a due fattori (TOTP).",
    "transferOwnershipFailed": "Impossibile trasferire la proprietà. Riprova o contatta l'assistenza.",
    "otpRequestLimitExceeded": "Hai superato il limite di richieste OTP. Riprova più tardi.",
    "requestFilePermissions": "Prova a contattare il proprietario del file per rinnovare i permessi",
    "noUploadPermission": "Non hai i permessi per caricare file in questa posizione.",
    "publicLinkClassificationRequired": "Il file deve essere classificato prima di creare un link pubblico.",
    "publicLinkPasswordRequired": "È richiesta una password per i link pubblici.",
    "publicLinkMaxAccessCountRequired": "È richiesto un numero massimo di accessi.",
    "publicLinkExpirationRequired": "È richiesta una data di scadenza.",
    "publicLinkExpirationExceeded": "La scadenza supera il numero massimo di giorni consentiti.",
    "publicLinkExpirationInPast": "La data di scadenza deve essere una data futura.",
    "publicLinkFolderPasswordProtected": "Non è possibile creare un link pubblico per cartelle protette da password o per file al loro interno. Per condividere tramite link pubblico, rimuovi la protezione con password dalla cartella.",
    "publicLinkDownloadRestricted": "Non è possibile creare un link pubblico perché l'applicazione della crittografia in download è attiva per questo file o per i suoi tag. Per condividere tramite link pubblico, rimuovi la restrizione dall'impostazione Applicazione crittografia download.",
    "publicLinkAnticaptureActive": "Non è possibile creare un link pubblico perché la modalità anti-cattura è attiva per questo file o per i suoi tag. Per condividere tramite link pubblico, rimuovi l'anti-cattura dal file o dalle impostazioni tag applicabili.",
    "publicLinkExternalSharingRestricted": "Non è possibile creare un link pubblico perché le restrizioni alla condivisione esterna sono attive per questo file o per i suoi tag. Per condividere tramite link pubblico, rimuovi i limiti applicabili nell'impostazione Restrizioni condivisione esterna.",
    "publicLinkResharingDenied": "Non è possibile creare un link pubblico perché la ricondivisione non è consentita per questo file o per i suoi tag. Per condividere tramite link pubblico, rivedi e aggiorna l'impostazione Permessi di ricondivisione file.",
    "publicLinkDownloadTagsRestricted": "Non è possibile creare un link pubblico perché le restrizioni al download sono attive per questo file o per i suoi tag. Per condividere tramite link pubblico, rivedi l'impostazione Tag consentiti per il download.",
    "publicLinkApprovalRequired": "Non è possibile creare un link pubblico perché è richiesta l'approvazione per la condivisione di questo file o dei suoi tag. Per condividere tramite link pubblico, rivedi l'impostazione Requisiti di approvazione per la condivisione.",
    "publicLinkMandatoryExpiration": "Non è possibile creare un link pubblico perché la politica di scadenza obbligatoria è attiva per questo file o per i suoi tag. Per condividere tramite link pubblico, imposta la data di scadenza entro il limite definito nell'impostazione Scadenza obbligatoria file condivisi.",
    "tagsAmountLimitReached": "Non puoi creare più di {{limit}} tag.",
    "hitASnag": "Ops! Qualcosa è andato storto. Riprova...",
    "noPermission": "Non hai i permessi per eseguire questa azione.",
    "errorDownloadFile": "Si è verificato un problema durante il download del file. Riprova.",
    "errorDuplicateFile": "Si è verificato un problema durante la duplicazione del file. Riprova.",
    "errorMoveFile": "Si è verificato un problema durante lo spostamento del file. Riprova.",
    "denyFileMove": "Lo spostamento non è consentito per questo file.",
    "pdfConversionUnsupportedFormat": "Questo formato file non è supportato per la conversione PDF.",
    "pdfConversionFileTooLarge": "File troppo grande per la conversione. Dimensione massima {{maxSizeMb}} MB.",
    "pdfConversionFailed": "Conversione PDF non riuscita. Riprova.",
    "pdfConversionAntivirusBlocked": "Conversione PDF bloccata: il file contiene una minaccia.",
    "fileNotFound": "File non trovato.",
    "errorDeleteFiles": "Si è verificato un problema durante l'eliminazione dei file. Riprova.",
    "errorHideFiles": "Si è verificato un problema durante il nascondimento dei file. Riprova.",
    "errorUploadFile": "Si è verificato un problema durante il caricamento del file. Riprova.",
    "cannotAddArchivedFilesToFavorites": "I file archiviati non possono essere aggiunti ai preferiti.",
    "cannotDeleteMultiplePasswordProtected": "Impossibile eliminare gli elementi selezionati perché sono presenti più cartelle protette da password non sbloccate. Sblocca ogni cartella singolarmente e riprova.",
    "cannotUnlockMultiplePasswordProtected": "Non è possibile sbloccare più cartelle protette da password in un'unica operazione. Sblocca ogni cartella singolarmente.",
    "groupNameCannotBeEmail": "Il nome del gruppo non può essere un indirizzo email.",
    "invalidFolder": "Questa cartella non è valida.",
    "invalidFolderUpload": "La cartella che stai tentando di caricare non esiste o non è supportata.",
    "zeroByteFileNotUploaded": "I file di 0 byte non vengono caricati. Seleziona file con contenuto.",
    "loginFailed": "Accesso non riuscito",
    "unauthorized": "Autenticazione fallita. Riprova.",
    "forbidden": "Accesso negato",
    "serverError": "Errore del server. Riprova più tardi.",
    "tooManyRequests": "Troppe richieste. Riprova più tardi.",
    "oauthAccessDenied": "Accesso negato dall'utente",
    "oauthInvalidCallback": "Callback OAuth non valido",
    "oauthStateMismatch": "Verifica di sicurezza fallita",
    "oauthContextMissing": "Contesto OAuth mancante",
    "oauthProviderNotEnabled": "Provider OAuth non abilitato",
    "oauthNotEnabled": "OAuth diretto non abilitato per questo tenant",
    "oauthDomainNotAllowed": "Dominio email non consentito",
    "oauthEmailMismatch": "Hai effettuato l'accesso con un account diverso dall'email inserita. Accedi con l'account corretto.",
    "oauthCodeExchangeFailed": "Scambio del codice di autorizzazione fallito",
    "oauthTokenValidationFailed": "Validazione del token fallita",
    "oauthInvalidTenant": "Tenant non valido",
    "oauthSessionExpired": "Sessione scaduta. Riprova.",
    "sessionExpired": "La tua sessione è scaduta. Effettua di nuovo l'accesso.",
    "filePasswordLockout": "Questa cartella è bloccata per troppi tentativi falliti. Riprova tra {{minutes}} minuti.",
    "getViewerData": "Si è verificato un problema nel recuperare i dati del viewer. Riprova.",
    "protectedLinkAlreadyUsed": "Link già usato, genera un nuovo codice",
    "protectedLinkAlreadyUsedOrExpired": "Link già usato o scaduto, genera un nuovo codice",
    "fileAccessSessionExpired": "Sessione scaduta, genera un nuovo codice",
    "protectedFileDownloadOnlyForWindows": "Il download del file protetto è disponibile solo per Windows.",
    "antiCaptureActivated": "Questo elemento è protetto da impostazioni anti-capture.",
    "downloadRestrictionActivated": "Questo elemento è protetto da impostazioni di restrizione download.",
    "watermarkProtectionDownloadDenied": "Questo file è protetto e non può essere scaricato. Puoi comunque visualizzarlo.",
    "antivirusFileInfected": "Questo file non può essere aperto o condiviso perché l'antivirus ha rilevato una minaccia.",
    "antivirusFileInfectedNamed": "L'antivirus ha rilevato {{threatName}} in {{fileName}}.",
    "antivirusRescanNotAllowed": "Non sei autorizzato a richiedere una nuova scansione antivirus per questo file.",
    "antivirusNotAvailable": "La scansione antivirus non è disponibile al momento. Riprova più tardi.",
    "fileSizeTooBigForDownload": "Il file non può essere scaricato in modalità criptata perché supera i 250 MB.",
    "fileNotAvailable": {
      "title": "Il file non è più disponibile",
      "description": "Il file a cui stai tentando di accedere non è più disponibile. Potrebbe essere stato eliminato o spostato."
    },
    "publicLinkNotFoundTitle": "Questo link non è disponibile",
    "publicLinkNotFoundMessage": "Questo link non esiste, è stato rimosso o non è più accessibile.",
    "publicLinkItemNotAvailable": "Questo elemento non è disponibile",
    "publicLinkExpiredTitle": "Link scaduto",
    "publicLinkExpiredMessage": "Questo link è scaduto e non è più valido.",
    "publicLinkMaxAccessTitle": "Limite di accessi raggiunto",
    "publicLinkMaxAccessMessage": "È stato raggiunto il numero massimo di accessi per questo link.",
    "invalidAccessCode": "La password inserita non è corretta. Riprova.",
    "fileSizeUploadLimit": "La dimensione del file supera il limite di caricamento di {{value}} mb",
    "fileSizeExceedsAdminLimit": "Impossibile caricare il file: la dimensione supera il limite massimo impostato dall'amministratore.",
    "fileSizeExceedsLicenseLimit": "Impossibile caricare il file: la dimensione supera il limite massimo stabilito nella licenza.",
    "uploadingFileError": "Si è verificato un problema durante il caricamento del file.",
    "uploadInterrupted": "Upload interrotto dall'utente.",
    "fileTypeRestrictionError": "Questo tipo di file non può essere caricato per via delle impostazioni applicate.",
    "quickShareError": "Si è verificato un problema durante la condivisione dei file. Riprova.",
    "quickShareFilesNotUploaded": "{{ count }} file non sono stati caricati correttamente. Clicca Continua per condividere comunque i file caricati con successo.",
    "quickShareFilesNotUploaded_other": "{{ count }} file non sono stati caricati correttamente. Clicca Continua per condividere comunque i file caricati con successo.",
    "quickShareFilesNotShared": "I file non sono stati condivisi correttamente. Clicca Continua per condividere comunque i file caricati con successo.",
    "filesNotShared": "I file non sono stati condivisi.",
    "enterOnBehalfOfUserFailed": "Impossibile entrare per conto dell'utente. Riprova.",
    "exitOnBehalfOfUserFailed": "Impossibile uscire dalla modalità per conto dell'utente. Riprova.",
    "reasonRequired": "Inserisci un motivo per entrare per conto dell'utente",
    "reasonMinLength": "Il motivo deve essere di almeno 3 caratteri",
    "impersonatedUserNotNotified": "L'utente non ha potuto essere avvisato via email (nessun indirizzo email sull'account)",
    "fileSizeExceedsLimit": "La dimensione del file supera il limite di {{value}}.",
    "otpWrong": "Il codice OTP è errato. Riprova.",
    "groupNameAlreadyUsed": "Il nome del gruppo è già in uso.",
    "updateFileAccessError": "Si è verificato un problema nell'aggiornare l'accesso al file. Riprova.",
    "deleteFileAccessError": "Si è verificato un problema nell'eliminare l'accesso al file. Riprova.",
    "errorCreateFileShortcut": "Si è verificato un problema nella creazione del collegamento al file. Riprova.",
    "openShortcutFileError": "Ops, sembra che il file collegato non sia più disponibile. Potrebbe essere stato rimosso o l'accesso revocato.",
    "confirmationMessageMatch": "Il messaggio di conferma non corrisponde.",
    "emailExist": "L'email esiste già.",
    "shareFiles": "Si è verificato un problema nella condivisione dei file. Riprova.",
    "genericSellError": "Si è verificato un errore durante la messa in vendita del file.",
    "someItemsCannotBeSelected": "Alcuni elementi non possono essere selezionati",
    "invalidMicrosoftEntraIdToken": "Il token Microsoft Entra ID non è valido o è scaduto.",
    "atLeastOneOption": "Devi selezionare almeno un'opzione",
    "groupNameAlreadyExists": "Il nome del gruppo è già in uso.",
    "cannotAddSuperAdminToGroup": "Non puoi aggiungere un Super Admin a un gruppo.",
    "editSharingDenied": "Non hai i permessi per modificare i diritti di accesso di documenti già condivisi. Se un utente non compare in elenco, significa che ha già una condivisione attiva.",
    "errorRemoveShareFiles": "Si è verificato un problema durante la rimozione della condivisione dei file. Riprova.",
    "noFileClassificationAvailable": "Nessuna classificazione di file disponibile al momento",
    "errorPermanentlyDeleteFiles": "Si è verificato un problema durante l'eliminazione permanente dei file. Riprova.",
    "aiDocumentChatError": "Si è verificato un errore durante la conversazione con il documento. Riprova.",
    "filesAlreadyClassified": "I file sono già classificati",
    "filesBeingClassified": "I file sono attualmente in fase di classificazione",
    "filesBeingClassifiedDescription": "Attendi il completamento del processo di classificazione corrente prima di avviarne uno nuovo.",
    "filesTooBig": "I file superano il limite di dimensione per la classificazione",
    "filesTooBigDescription": "La dimensione massima consentita per la classificazione AI è di 250 MB. Seleziona file più piccoli.",
    "tooManyFiles": "Troppi file selezionati",
    "tooManyFilesDescription": "{{files}} file selezionati; il massimo è {{limit}}. Riduci la selezione e riprova.",
    "rejectionReasonRequired": "Il motivo del rifiuto è obbligatorio",
    "rejectionReasonMinLength": "Il motivo del rifiuto deve essere di almeno 3 caratteri",
    "fileAlreadyInUseError": "Il file è già in uso da un altro utente.",
    "contentHashMismatchError": "File corrotto durante l'upload (hash non corrispondente)",
    "fileIntegrityCheckFailed": "Verifica integrità file fallita",
    "fileIntegrityCheckFailedDescription": "Il file scaricato potrebbe essere corrotto. Si prega di provare a scaricare nuovamente.",
    "fileIntegrityCheckError": "Errore verifica integrità file",
    "fileIntegrityCheckErrorDescription": "Impossibile verificare l'integrità del file, ma il download procederà comunque.",
    "storageUrlFetchFailed": "Tenant non trovato o temporaneamente non disponibile",
    "storageUrlFetchFailedDescription": "Controlla l'indirizzo e riprova: <strong>{{tenantAddress}}</strong>.",
    "folderPasswordRequired": "Questa cartella richiede la verifica della password",
    "folderPassword": {
      "passwordRequired": "La password è obbligatoria.",
      "tooShort": "La password deve contenere almeno 4 caratteri.",
      "ownerOnly": "Solo il proprietario della cartella può eseguire questa azione.",
      "alreadyExists": "Questa cartella ha già la protezione con password.",
      "ancestorProtected": "Impossibile eseguire questa azione perché una cartella superiore è protetta da password.",
      "descendantProtected": "Impossibile eseguire questa azione perché una sottocartella è protetta da password.",
      "notSet": "Questa cartella non ha la protezione con password configurata.",
      "notProtected": "Questa cartella non è protetta da password.",
      "currentRequired": "La password attuale è obbligatoria.",
      "expired": "La protezione con password della cartella è scaduta. Contatta il proprietario della cartella.",
      "incorrect": "La password attuale della cartella non è corretta. Riprova.",
      "sessionNotFound": "Sessione non trovata o già revocata.",
      "sessionForbidden": "Non hai il permesso di gestire questa sessione.",
      "otpNotRequested": "OTP non richiesto. Richiedi un nuovo codice."
    },
    "notAFolder": "L'elemento selezionato non è una cartella",
    "ipRegionBlocked": {
      "message": "Accesso negato dalla tua posizione.",
      "loginTitle": "Accesso negato",
      "loginMessage": "Accesso negato dalla tua posizione.",
      "loginGeneric": "Accesso negato dalla tua posizione.",
      "fileOperationTitle": "Operazione non consentita",
      "fileOperationMessage": "Accesso negato dalla tua posizione."
    },
    "ipRegionAdminLockout": {
      "title": "Impossibile attivare la restrizione IP admin",
      "message": "Il tuo indirizzo IP attuale deve essere incluso tra gli indirizzi IP admin consentiti, altrimenti perderesti l'accesso alle impostazioni di amministrazione."
    },
    "dateMustBeFuture": "La data deve essere nel futuro",
    "externalSharingNotAllowed": "I seguenti destinatari non sono autorizzati a ricevere condivisioni esterne: {{recipients}}",
    "sharingNotAllowedMandatoryTag": "Gli allegati devono avere un tag di classificazione prima dell'invio",
    "fileSharingDenied": "La condivisione dei file non è consentita per questa operazione.",
    "cannotAccessFiles": "Non hai accesso a uno o più file richiesti.",
    "partialSharingDenied": "Alcuni file non possono essere condivisi con i destinatari selezionati.",
    "partialSharingDeniedDisabledRecipients": "Alcuni utenti o gruppi selezionati hanno già una condivisione per questi file, ma è attualmente disabilitata. Puoi riabilitarla con il pulsante {{shareAgainLabel}} accanto a ciascun destinatario.",
    "passKeyDataRequired": "Dati passkey mancanti o non validi. Riprova.",
    "passKeyForbidden": "Non hai l'autorizzazione per eseguire questa operazione.",
    "passKeyLimitReached": "Hai raggiunto il numero massimo di passkey. Elimiane una prima di aggiungerne un'altra.",
    "passKeyLockedOut": "Troppi tentativi falliti con la passkey. Riprova più tardi o usa un altro metodo di accesso.",
    "passKeyNotAllowed": "Questa operazione con la passkey non è consentita.",
    "passKeyNotEnabled": "Le passkey non sono abilitate per il tuo account o per la tua organizzazione.",
    "passKeyNotFound": "Passkey non trovata. Potrebbe essere stata rimossa o non è più valida.",
    "passKeySessionExpired": "La sessione della passkey è scaduta. Riprova dall'inizio.",
    "passKeyVerificationFailed": "Credenziale non trovata o non abilitata per l'accesso senza password.",
    "batchNotFound": "Batch non trovato o non hai accesso.",
    "batchNotCancellable": "Questo batch non può essere annullato (non di classificazione).",
    "batchAlreadyFinished": "Operazione già conclusa.",
    "batchRetryNotSupported": "Il ripristino è supportato solo per i batch di classificazione.",
    "noFileJobsFound": "Nessuno dei file selezionati può essere annullato o ritentato nello stato attuale.",
    "queueUnavailable": "La coda di elaborazione non è momentaneamente disponibile. Riprova più tardi.",
    "ldap": {
      "ACTIVE_DIRECTORY_NOT_AVAILABLE": "La sincronizzazione Active Directory non è disponibile per questa installazione o licenza.",
      "LDAP_NOT_CONFIGURED": "Active Directory non è ancora configurato. Apri prima la pagina impostazioni LDAP.",
      "LDAP_CONFIGURATION_INVALID": "La configurazione LDAP non è valida. Correggi i campi evidenziati e salva di nuovo.",
      "LDAP_CREDENTIAL_REQUIRED": "È richiesta la password di bind. Inserisci la password dell'account di servizio.",
      "LDAP_UNREACHABLE": "Domain controller non raggiungibile — controlla host, porta e firewall.",
      "LDAP_TLS_FAILED": "Certificato non attendibile — carica la CA interna nelle impostazioni, o verifica security/porta.",
      "LDAP_BIND_FAILED": "Account di servizio rifiutato — controlla bind DN e password.",
      "LDAP_BASE_DN_NOT_FOUND": "Bind riuscito ma il base DN non è stato trovato — controlla il base DN.",
      "LDAP_SEARCH_FAILED": "La directory ha rifiutato la ricerca — controlla i filtri.",
      "LDAP_CREDENTIAL_ENCRYPTION_FAILED": "Errore del server, contatta il supporto.",
      "rateLimited": "Troppe richieste, riprova tra un minuto."
    },
    "outboundEmail": {
      "OUTBOUND_EMAIL_NOT_AVAILABLE": "Il dominio e-mail personalizzato non è disponibile per questo account o licenza.",
      "OUTBOUND_EMAIL_CONFIG_INVALID": "La configurazione e-mail in uscita non è valida. Correggi i campi evidenziati e salva di nuovo.",
      "OUTBOUND_EMAIL_NOT_CONFIGURED": "Salva una configurazione di dominio prima di verificare.",
      "OUTBOUND_EMAIL_NOT_READY": "Il mittente personalizzato non è ancora pronto (disattivato, non verificato o Mailgun non attivo).",
      "OUTBOUND_EMAIL_CONCURRENT_CHANGE": "La configurazione è cambiata durante il controllo. Aggiorna lo stato e riprova.",
      "OUTBOUND_EMAIL_DNS_LOOKUP_FAILED": "Controllo DNS non disponibile, riprova più tardi.",
      "OUTBOUND_EMAIL_MAILGUN_FAILED": "Richiesta Mailgun non riuscita. La proprietà potrebbe essere stata salvata — aggiorna lo stato.",
      "OUTBOUND_EMAIL_TEST_FAILED": "Impossibile inviare l'e-mail di test, riprova più tardi.",
      "rateLimited": "Troppe richieste, riprova a breve."
    },
    "DIRECTORY_SYNC_ALREADY_RUNNING": "Un’altra sincronizzazione directory è in corso per questa azienda. Riprova quando termina."
  },
  "notifications": {
    "genericUpdateSuccess": "{{resource}} aggiornato con successo.",
    "genericCreateSuccess": "{{resource}} creato con successo.",
    "linkCopiedToClipboard": "Link copiato negli appunti!",
    "codeCopiedToClipboard": "Codice copiato negli appunti!",
    "fileProtectedWithAntiCapture": "Questo file è protetto con l'anti-capture. Per visualizzare il contenuto, inserisci questo codice quando richiesto nel Filegrant Viewer, e il gioco è fatto!",
    "otpCopiedToClipboard": "OTP copiato negli appunti!",
    "fileProtectedDownloadInProgress": "Download in corso, al termine esegui l'applicazione scaricata e inserisci il codice indicato per visualizzare il file.",
    "quickShareSuccess": "File condivisi con successo.",
    "fileLocatedInThisLocation": "Questo file si trova già in questa posizione.",
    "fileAccessRevoked": "Diritti di accesso revocati con successo.",
    "fileAccessUpdated": "Diritti di accesso aggiornati con successo.",
    "fileVersionRestored": "Versione del file ripristinata con successo.",
    "folderCreated": "Cartella {{resource}} creata con successo.",
    "fileCreated": "File {{resource}} creato con successo.",
    "fileRenamed": "File {{resource}} rinominato in {{newName}} con successo.",
    "fileDuplicated": "File {{resource}} duplicato con successo.",
    "fileDuplicated_other": "File duplicati con successo.",
    "fileFavouriteChanged": "File {{resource}} {{isFavourite}} ai preferiti con successo.",
    "fileFavouriteChanged_other": "File {{isFavourite}} ai preferiti con successo.",
    "fileShortcutCreated": "Collegamento al file {{resource}} creato con successo.",
    "fileMoved": "File {{resource}} spostato con successo.",
    "fileMoved_other": "File spostati con successo.",
    "pdfConversionStarted": "Conversione di {{resource}} in PDF avviata.",
    "pdfConversionSuccess": "Conversione PDF completata con successo.",
    "pdfConversionFailed": "Conversione PDF non riuscita.",
    "pdfConversionStillRunning": "La conversione PDF è ancora in corso. Riceverai una notifica al termine.",
    "emptyTrash": "Cestino svuotato con successo.",
    "operationMayTakeTime": "Questa operazione potrebbe richiedere un po' di tempo.",
    "fileRestored": "File {{resource}} ripristinato con successo.",
    "fileRestored_other": "File ripristinati con successo.",
    "fileHidden": "File {{resource}} nascosto con successo.",
    "fileHidden_other": "File nascosti con successo.",
    "fileUnhidden": "File {{resource}} reso visibile con successo.",
    "fileUnhidden_other": "File resi visibili con successo.",
    "filesMarkedAsRead_one": "Segnato come letto.",
    "filesMarkedAsRead_other": "{{count}} file segnati come letti.",
    "filesMarkedAsUnread_one": "Segnato come non letto.",
    "filesMarkedAsUnread_other": "{{count}} file segnati come non letti.",
    "folderLocked": "{{count}} cartella bloccata.",
    "folderLocked_other": "{{count}} cartelle bloccate.",
    "fileClassifying": "Il file è in fase di classificazione",
    "filesClassifying": "{{count}} file è in fase di classificazione",
    "filesClassifying_other": "{{count}} file sono in fase di classificazione",
    "filesClassifyingBatch": "{{count}} file sono in fase di classificazione come batch",
    "filesClassifyingBatchWithSkipped": "{{count}} file accodati per classificazione. {{skipped}} saltati.",
    "folderClassifyingBatch": "Il contenuto della cartella è in fase di classificazione come batch",
    "foldersClassifyingBatch": "{{count}} cartelle sono in fase di classificazione come batch",
    "fileTagsUpdated": "Tag del file {{resource}} aggiornati con successo.",
    "fileDeleted": "File {{resource}} eliminato con successo.",
    "fileDeleted_other": "File eliminati con successo.",
    "checkingFilesExistsCounter": "Verifica file: {{done}} / {{total}}",
    "checkingFoldersExistsCounter": "Verifica cartelle: {{done}} / {{total}}",
    "checkingFilesInFolderCounter": "{{folder}} · Verifica file: {{done}} / {{total}}",
    "checkingSubfoldersInFolderCounter": "{{folder}} · Verifica sottocartelle: {{done}} / {{total}}",
    "tags": {
      "title": "File Etichettato",
      "description": "Il file {{fileId}} è stato etichettato",
      "descriptionWithFileName": "{{fileName}} è stato etichettato",
      "descriptionGeneric": "File etichettato",
      "errorTitle": "Impossibile etichettare il file",
      "error": "Classificazione IA non riuscita.",
      "batchSuccessTitle": "Batch di classificazione completato",
      "batchSuccessDescription": "Classificati {{processed}} di {{total}} file.",
      "batchFailedTitle": "Batch di classificazione fallito",
      "batchFailedDescription": "Batch terminato con errori ({{processed}}/{{total}})."
    },
    "summary": {
      "title": "Riassunto File",
      "description": "Riassunto generato per il file {{fileId}}",
      "ready": "Il riassunto del file è pronto.",
      "open": "Apri riassunto"
    },
    "fileUnavailable": "File non disponibile",
    "suggestGridMode": {
      "title": "Solo immagini in questa cartella",
      "description": "Passa alla visualizzazione a griglia per un'anteprima migliore.",
      "action": "Passa alla griglia"
    },
    "documentClassification": {
      "title": "Documento Classificato",
      "description": "Classificazione documento completata per il file {{fileId}}"
    },
    "default": {
      "title": "Notifica",
      "description": "Nuova notifica ricevuta"
    },
    "sharing": {
      "title": "File condiviso",
      "sharing_operation_download": "{{actorName}} ha scaricato {{fileName}}",
      "sharing_operation_open": "{{actorName}} ha aperto {{fileName}}",
      "sharing_operation_edit": "{{actorName}} ha modificato {{fileName}}",
      "sharing_operation_delete": "{{actorName}} ha eliminato {{fileName}}",
      "sharing_operation_rename": "{{actorName}} ha rinominato {{fileName}}",
      "sharing_operation_add": "{{actorName}} ha aggiunto {{fileName}}",
      "sharing_operation_move": "{{actorName}} ha spostato {{fileName}}",
      "sharing_operation_copy": "{{actorName}} ha copiato {{fileName}}",
      "sharing_operation_unknown": "{{actorName}} ha eseguito un'operazione su {{fileName}}"
    },
    "folderPasswordSet": "Protezione password abilitata",
    "folderPasswordUpdated": "Protezione password aggiornata",
    "folderPasswordRemoved": "Protezione password rimossa",
    "unlockingFolder": "Sblocco cartella…",
    "folderUnlocked": "Cartella sbloccata correttamente"
  },
  "files": {
    "downloadPreparation": "Preparazione download",
    "downloadReady": "Download pronto",
    "compressionOfFilesInProgress": "Compressione file in corso",
    "compressionCompleted": "Compressione completata",
    "compressionFailed": "Compressione non riuscita",
    "exportFolderFileList": {
      "button": "Esporta",
      "formatCsv": "CSV",
      "formatJson": "JSON",
      "formatExcelXml": "Excel (XML)",
      "modalTitle": "Esporta elenco file di \"{{folder}}\"",
      "rootLabel": "Radice",
      "modalDescription": "Esporta solo gli elementi di questa cartella — non i file dentro le sottocartelle. Si applicano i filtri attivi. Scegli colonne e opzioni. Dimensione cartella lasciata vuota (nessuna API batch leggera).",
      "confirm": "Esporta",
      "empty": "Questa cartella non ha file da esportare.",
      "failed": "Impossibile esportare l'elenco file.",
      "extension": "Estensione",
      "id": "ID",
      "isShared": "Condiviso",
      "columnsLabel": "Colonne",
      "delimiterLabel": "Separatore colonne",
      "delimiterComma": "Virgola (,)",
      "delimiterSemicolon": "Punto e virgola (;)",
      "delimiterTab": "Tabulazione (\\t)",
      "delimiterPipe": "Pipe (|)",
      "tagsJoinLabel": "Separatore tag",
      "tagsJoinSemicolon": "Punto e virgola (;)",
      "tagsJoinPipe": "Pipe (|)",
      "tagsJoinComma": "Virgola (,)",
      "tagsJoinConflictWarning": "Il separatore tag coincide con il separatore colonne. I parser CSV a valle potrebbero spezzare i tag in modo errato.",
      "dateFormatLabel": "Formato data",
      "dateFormat": {
        "localeShort": "Data breve (locale) — es. {{sample}}",
        "iso": "ISO (YYYY-MM-DD) — es. {{sample}}",
        "localeDateTime": "Data e ora (locale) — es. {{sample}}",
        "dmy": "DD/MM/YYYY — es. {{sample}}",
        "mdy": "MM/DD/YYYY — es. {{sample}}",
        "isoDateTime": "YYYY-MM-DD HH:mm — es. {{sample}}",
        "europeanDateTime": "DD/MM/YYYY HH:mm — es. {{sample}}"
      },
      "dragToReorder": "Trascina per riordinare {{column}}"
    }
  },
  "fileAccessNotification": {
    "enableActivityNotifications": "Abilita notifiche di attività",
    "includeSubfolders": "Includi sottocartelle",
    "notifyOwner": "Notifica proprietario",
    "notifyRecipients": "Notifica i destinatari",
    "whoCanTrigger": "Chi può scatenare le notifiche?",
    "trigger": {
      "ownerOnly": "Solo il proprietario",
      "anyone": "Chiunque"
    },
    "operation": {
      "download": "Scaricamento",
      "open": "Apertura",
      "edit": "Modifica",
      "delete": "Eliminazione",
      "rename": "Rinomina",
      "add": "Aggiunta",
      "move": "Spostamento",
      "copy": "Copia"
    },
    "configureNotifications": "Configura notifiche",
    "customizeFor": "Personalizzazione per",
    "discardChangesTitle": "Annullare le modifiche?",
    "discardChangesDescription": "Ci sono modifiche non salvate. Annullare e chiudere?",
    "discardConfirm": "Annulla modifiche",
    "notificationsDisabled": "Notifiche disabilitate",
    "notificationsEnabled": "Notifiche abilitate",
    "modalTitle": "Notifiche di attività"
  },
  "modal": {
    "saveTagsConfirm": {
      "title": "Salvare le modifiche ai tag?",
      "description": "Hai modifiche ai tag non salvate. Salvare prima di chiudere?"
    },
    "userGroupSelectorForm": {
      "title": "Gestisci Team di Revisione",
      "description": "Seleziona utenti e gruppi per il team di revisione",
      "currentMembers": "Membri Attuali",
      "unsavedReviewTeam": "Team di Revisione non Salvato"
    },
    "tagUserGroupMultiSelectForm": {
      "title": "Gestisci Utenti e Gruppi",
      "description": "Seleziona utenti e gruppi che possono accedere a questo tag",
      "usersAndGroups": "Utenti e gruppi",
      "unsavedUsersAndGroups": "Utenti e Gruppi non Salvati"
    },
    "changeUserRole": {
      "title": "Cambia ruolo utente",
      "description": "Sei sicuro di voler cambiare il ruolo di {{name}} da {{initialRole}} a {{newRole}}?"
    },
    "deleteUsersForm": {
      "title": "Elimina utente",
      "title_other": "Elimina utenti",
      "roleAdminOrContributor": "L'utente che stai per eliminare è un Contributor o Admin e potrebbe aver caricato file nel sistema. Eliminando l'utente verranno eliminati anche tutti i file caricati e le condivisioni associate, e non potrà più accedere alla piattaforma. Vuoi procedere? <i>(Digita \"{{keyword}}\" per confermare.)</i>",
      "roleReader": "L'utente che stai per eliminare è un Reader e potrebbe avere file condivisi da altri utenti. Eliminandolo non potrà più accedere al sistema e ai file condivisi con lui. Vuoi procedere? <i>(Digita \"{{keyword}}\" per confermare.)</i>",
      "roleExternal": "L'utente che stai per eliminare è referenziato da altri utenti in piattaforma, che hanno condiviso file o cartelle direttamente con lui. Rimuovendolo verrà revocato l'accesso a qualsiasi contenuto condiviso e gli altri utenti non lo vedranno più nelle proprie liste. Vuoi procedere? <i>(Digita \"{{keyword}}\" per confermare.)</i>",
      "multiple": "Stai per eliminare più utenti. Alcuni potrebbero aver caricato file nel sistema. Eliminandoli verranno rimossi tutti i file caricati e le condivisioni associate, e non potranno più accedere alla piattaforma. Vuoi procedere? <i>(Digita \"{{keyword}}\" per confermare.)</i>",
      "transferDestinationLabel": "Trasferisci i file personali a un altro utente (opzionale)",
      "transferDestinationPlaceholder": "Cerca un utente…",
      "transferOptionalHint": "Se scegli un destinatario, i file personali degli account che stai eliminando verranno trasferiti lì prima della rimozione. Lascia vuoto per rimuovere i file secondo le regole descritte sopra.",
      "userReferencedInSettings": {
        "title": "Impossibile eliminare l'utente",
        "title_other": "Impossibile eliminare gli utenti",
        "description": "L'utente selezionato non può essere eliminato. È referenziato nei seguenti settings: <settingsList/>. Rimuoverlo dai settings prima di riprovare.",
        "description_other": "Gli utenti selezionati non possono essere eliminati. Sono referenziati nei seguenti settings: <settingsList/>. Rimuoverli dai settings prima di riprovare.",
        "unknownSettings": "Uno o più settings"
      }
    },
    "changeUsersStatus": {
      "title": "Cambia stato utente",
      "description": "Sei sicuro di voler {{status}} <strong>{{resource}}</strong>?",
      "description_other": "Sei sicuro di voler {{status}} <strong>questi utenti</strong>?"
    },
    "excludeFromSso": {
      "titleExclude": "Escludi utente dall'SSO",
      "titleInclude": "Riabilita SSO per l'utente",
      "descriptionExclude": "Sei sicuro di voler escludere <strong>{{resource}}</strong> dall'SSO? Non potrà più accedere tramite il provider di identità configurato e dovrà autenticarsi con OTP.",
      "descriptionInclude": "Sei sicuro di voler riabilitare l'SSO per <strong>{{resource}}</strong>? Potrà nuovamente accedere tramite il provider di identità configurato."
    },
    "enterOnBehalfOf": {
      "title": "Entra in modalità Per Conto Di",
      "description": "Stai avviando una sessione in cui vedrai dati ed eseguirai operazioni per conto di <strong>{{resource}}</strong>.<br /><br />Confermi?"
    },
    "impersonateUser": {
      "title": "Impersona utente",
      "description": "Sei sicuro di voler accedere come {{userName}}? Potrai vedere ed eseguire operazioni come questo utente.",
      "emailNotice": "L'utente riceverà un'email che lo avvisa di questa impersonazione, con il tuo nome, la data e l'ora e il motivo inserito sotto.",
      "reasonLabel": "Motivo — mostrato all'utente nell'email di notifica",
      "reasonTruncateHint": "I motivi oltre 500 caratteri vengono troncati con \"…\" nell'email (il testo completo viene comunque salvato).",
      "reasonEmptyHint": "Se lasciato vuoto, l'email mostra \"Not specified\"."
    },
    "userForm": {
      "editTitle": "Modifica utente",
      "newTitle": "Nuovo utente",
      "editDescription": "Modifica i dettagli dell'utente",
      "newDescription": "Aggiungi un nuovo utente"
    },
    "userGroups": {
      "title": "Appartenenza al gruppo",
      "description": "Elenco dei gruppi di cui <strong>{{resource}}</strong> è membro"
    },
    "userFiles": {
      "title": "Elementi condivisi",
      "description": "Elementi condivisi con <strong>{{resource}}</strong>"
    },
    "groupFiles": {
      "title": "Elementi condivisi",
      "description": "Elementi condivisi con <strong>{{resource}}</strong>"
    },
    "fileSizeTooBigForOpen": {
      "title": "File troppo grande",
      "description": "La dimensione del file supera il limite di {{value}}. Se vuoi aprire il file, puoi scaricarlo e aprirlo in locale."
    },
    "deleteGroups": {
      "title": "Elimina gruppo",
      "title_other": "Elimina gruppi",
      "description": "Sei sicuro di voler eliminare <strong>{{resource}}</strong>? Vuoi procedere? <i>(Digita \"{{keyword}}\" per confermare.)</i>",
      "description_other": "Sei sicuro di voler eliminare <strong>questi gruppi</strong>? Vuoi procedere? <i>(Digita \"{{keyword}}\" per confermare.)</i>"
    },
    "groupForm": {
      "editTitle": "Modifica gruppo",
      "newTitle": "Nuovo gruppo",
      "viewTitle": "Visualizza gruppo",
      "editDescription": "Modifica i dettagli del gruppo",
      "viewDescription": "Visualizza i dettagli del gruppo",
      "newDescription": "Aggiungi un nuovo gruppo",
      "allUsers": "Tutti gli utenti",
      "selectedUsersOrGroups": "Utenti o gruppi selezionati"
    },
    "entraIdGroupsImportForm": {
      "importFromEntraId": "Importa da Entra ID",
      "title": "Importa gruppi da Microsoft Entra ID",
      "searchGroups": "Cerca gruppi...",
      "selectNew": "Seleziona solo nuovi",
      "existing": "Esistente",
      "new": "Nuovo",
      "importMembers": "Importa anche i membri del gruppo",
      "importSelected": "Importa ({{count}})",
      "importSuccess": "Importazione completata: {{created}} creati, {{updated}} aggiornati",
      "importError": "Errore durante l'importazione",
      "errorLoadingGroups": "Errore nel caricamento dei gruppi da Entra ID",
      "noGroupsFound": "Nessun gruppo trovato",
      "resultSummary": "Creati: {{created}}, Aggiornati: {{updated}}, Saltati: {{skipped}}, Falliti: {{failed}}",
      "usersImported": "{{count}} membro/i importato/i",
      "permissionDeniedFallback": "Permesso negato",
      "permissionErrorTitle": "Permessi Azure AD insufficienti",
      "permissionErrorDescription": "L'applicazione Azure AD non ha i permessi necessari per accedere a Microsoft Graph API.",
      "permissionErrorSteps": "Per risolvere il problema:",
      "permissionErrorStep1": "Vai su Azure Portal > Registrazioni app > La tua app",
      "permissionErrorStep2": "Naviga su Autorizzazioni API",
      "permissionErrorStep3": "Aggiungi i permessi Applicazione richiesti (non Delegati)",
      "permissionErrorStep4": "Clicca su \"Concedi consenso amministratore\" per autorizzare i permessi",
      "requiredPermissions": "Permessi richiesti",
      "defaultRole": "Ruolo predefinito",
      "linked": "Collegato"
    },
    "csvUsersImportForm": {
      "importFromCsv": "Importa da CSV",
      "title": "Importa utenti da CSV",
      "description": "Crea solo nuovi utenti. Le righe con email già presente vengono saltate (non contano come errori). Ruoli: SuperAdmin, Admin, Contributor, Reader (o codici numerici).",
      "browserStayOpenWarning": "Non chiudere né aggiornare la scheda del browser finché l'import non è completo. Il progresso vive solo in questa sessione.",
      "confirmSkipErrors": "Ci sono {{count}} elementi con errori e non verranno importati.",
      "downloadTemplate": "Scarica template CSV",
      "sendInvites": "Invia email di invito agli utenti creati",
      "dropzone": "Trascina qui un file CSV oppure clicca per selezionarlo",
      "fileSelected": "Selezionato: {{name}}",
      "invalidFileType": "Seleziona un file .csv",
      "readError": "Impossibile leggere il file CSV",
      "noValidRows": "Nessuna riga valida in questo file",
      "colLine": "Riga",
      "confirmImport": "Importa {{count}} utenti",
      "emptyFile": "Il file CSV è vuoto",
      "invalidHeader": "Intestazione non valida. Attesa: {{expected}}",
      "tooManyColumns": "Troppe colonne in questa riga",
      "missingFirstName": "Nome obbligatorio",
      "missingLastName": "Cognome obbligatorio",
      "missingEmail": "Email obbligatoria",
      "invalidEmail": "Indirizzo email non valido",
      "missingRole": "Ruolo obbligatorio",
      "invalidRole": "Ruolo non valido: {{value}}",
      "superAdminRoleNotAllowed": "Solo un SuperAdmin può assegnare il ruolo SuperAdmin",
      "invalidExpirationDate": "Data di scadenza non valida: {{value}}",
      "invalidBoolean": "Valore booleano non valido per {{field}}: {{value}}",
      "duplicateInFile": "Email duplicata nel file (prima occorrenza alla riga {{firstLine}})",
      "genericCreateError": "Impossibile creare l'utente",
      "drawerAria": "Progresso import utenti",
      "drawerRunning": "Import utenti in corso…",
      "drawerCompleted": "Import utenti completato",
      "drawerCancelled": "Import utenti annullato",
      "importingUsersCounter": "Import utenti {{amount}} di {{total}}",
      "importedUsersCounter": "Importati {{amount}} di {{total}}",
      "waitingForImport": "In attesa",
      "importingRow": "Import in corso…",
      "alreadyExists": "Già esistente",
      "summary": "Creati: {{created}} · Già esistenti: {{skipped}} · Falliti: {{failed}}",
      "progressCount": "{{done}} / {{total}}",
      "failedList": "Falliti",
      "alreadyExistList": "Già esistenti ({{count}})",
      "cancelImport": "Annulla import",
      "cancelConfirmTitle": "Annullare l'import?",
      "cancelConfirmContent": "Le create già avviate termineranno; le righe rimanenti non partiranno.",
      "continueImport": "Continua import",
      "minimizeDrawer": "Riduci",
      "expandDrawer": "Espandi",
      "previewHeading": "{{total}} utenti · {{errors}} errori",
      "searchPlaceholder": "Cerca utenti…",
      "colStatus": "Stato",
      "filterWithErrors": "Con errori",
      "filterValid": "Validi",
      "statusError": "Errore",
      "statusOk": "OK"
    },
    "entraIdUsersImportForm": {
      "importFromEntraId": "Importa da Entra ID",
      "title": "Importa utenti da Microsoft Entra ID",
      "searchUsers": "Cerca utenti...",
      "selectNew": "Seleziona solo nuovi",
      "existing": "Esistente",
      "new": "Nuovo",
      "importSelected": "Importa ({{count}})",
      "importSuccess": "Importazione completata: {{created}} creati, {{updated}} aggiornati",
      "importError": "Errore durante l'importazione",
      "errorLoadingUsers": "Errore nel caricamento degli utenti da Entra ID",
      "noUsersFound": "Nessun utente trovato",
      "resultSummary": "Creati: {{created}}, Aggiornati: {{updated}}, Saltati: {{skipped}}, Falliti: {{failed}}",
      "permissionDeniedFallback": "Permesso negato",
      "permissionErrorTitle": "Permessi Azure AD insufficienti",
      "permissionErrorDescription": "L'applicazione Azure AD non ha i permessi necessari per accedere a Microsoft Graph API.",
      "permissionErrorSteps": "Per risolvere il problema:",
      "permissionErrorStep1": "Vai su Azure Portal > Registrazioni app > La tua app",
      "permissionErrorStep2": "Naviga su Autorizzazioni API",
      "permissionErrorStep3": "Aggiungi i permessi Applicazione richiesti (non Delegati)",
      "permissionErrorStep4": "Clicca su \"Concedi consenso amministratore\" per autorizzare i permessi",
      "requiredPermissions": "Permessi richiesti",
      "defaultRole": "Ruolo predefinito"
    },
    "batchDetailForm": {
      "title": "Dettaglio batch",
      "noFailedFiles": "Nessun file fallito",
      "noFiles": "Nessun file in questo stato",
      "fileCancelled": "Annullamento richiesto per questo file.",
      "fileCancelError": "Errore nella richiesta di annullamento del file.",
      "fileRetried": "File messo in coda per il ripristino",
      "fileRetryError": "Errore nel riprovare il file",
      "truncatedHint": "L'anteprima dei file falliti è stata troncata. Usa la scheda Falliti per l'elenco completo.",
      "attempt": "Tentativo {{count}}",
      "tabs": {
        "pending": "In coda",
        "processing": "In lavorazione",
        "success": "Completati",
        "failed": "Falliti",
        "canceled": "Annullati"
      },
      "status": {
        "pending": "In coda",
        "processing": "In lavorazione",
        "success": "Completato",
        "failed": "Fallito",
        "canceled": "Annullato"
      }
    },
    "batchesList": {
      "panelTitle": "Batch",
      "noActiveBatches": "Nessun batch attivo",
      "cancelAllFailed": "Annulla tutti i batch falliti (non in elaborazione)",
      "cancelAllFailedConfirmTitle": "Annullare tutti i batch falliti?",
      "cancelAllFailedConfirmContent": "Verranno cancellati solo i batch con stato Fallito. I batch in elaborazione o in coda continuano e non vengono interessati. L'operazione non può essere annullata.",
      "cancelBatch": "Annulla batch",
      "cancelBatchConfirmTitle": "Annullare questo batch?",
      "cancelBatchConfirmContent": "Questa azione annullerà la richiesta. L'elaborazione potrà interrompersi al prossimo checkpoint. L'operazione non può essere annullata.",
      "failedFiles": "{{count}} file fallito",
      "failedFiles_other": "{{count}} file falliti",
      "progress": "{{processed}} / {{total}}",
      "status": {
        "all": "Tutti",
        "queued": "In coda",
        "processing": "In elaborazione",
        "completed": "Completato",
        "failed": "Fallito",
        "partiallycompleted": "Parzialmente completato",
        "cancelled": "Annullato"
      },
      "operation": {
        "all": "Tutte le operazioni",
        "classification": "Classificazione IA",
        "folderexpansion": "Espansione cartella",
        "delete": "Eliminazione",
        "zip": "Creazione ZIP non riuscita"
      },
      "pendingFiles": "{{count}} in coda",
      "pendingFiles_other": "{{count}} in coda",
      "processingFiles": "{{count}} in lavorazione",
      "processingFiles_other": "{{count}} in lavorazione",
      "processedFiles": "{{count}} completato",
      "processedFiles_other": "{{count}} completati",
      "canceledFiles": "{{count}} annullato",
      "canceledFiles_other": "{{count}} annullati",
      "viewDetail": "Vedi dettagli"
    },
    "tagForm": {
      "editTitle": "Modifica tag",
      "newTitle": "Nuovo tag",
      "editDescription": "Modifica i dettagli del tag",
      "newDescription": "Aggiungi un nuovo tag",
      "visibility": "Visibilità",
      "visibilityDescription": "Rendi questo tag visibile ai seguenti ruoli e specifica se il tag sarà visibile a tutti o solo a gruppi o utenti specifici.",
      "usedInSettings": "Utilizzato in:",
      "usedInSettingsNone": "Questo tag non è utilizzato in nessuna impostazione.",
      "selectUserRoles": "Seleziona ruoli utente"
    },
    "deleteTag": {
      "title": "Elimina tag",
      "description": "Sei sicuro di voler eliminare <strong>{{resource}}</strong>? Vuoi procedere?",
      "descriptionWithPublicTag": "Sei sicuro di voler eliminare <strong>{{resource}}</strong>? L'eliminazione di questo tag rimuoverà tutte le condivisioni associate ad esso nelle impostazioni di visibilità dei file con tag.",
      "errorInUse": "Impossibile eliminare il tag",
      "errorInUseDescription": "Questo tag è attualmente in uso nelle seguenti aree:",
      "errorInUseAction": "Rimuovi il tag da queste sezioni prima di procedere con l'eliminazione.",
      "usedInSettings": "Impostazioni",
      "usedInClassificationAgent": "Classification Agent"
    },
    "fileTitleForm": {
      "newFolderTitle": "Nuova cartella",
      "editFolderTitle": "Rinomina cartella",
      "editFileTitle": "Rinomina file"
    },
    "fileFromTemplateForm": {
      "newWordDocumentTitle": "Nuovo documento Word",
      "newExcelDocumentTitle": "Nuovo documento Excel",
      "newPowerpointDocumentTitle": "Nuova presentazione PowerPoint",
      "newGenericDocumentTitle": "Nuovo documento"
    },
    "enterFolderPasswordForm": {
      "passwordPlaceholder": "Password",
      "required": "La password è obbligatoria",
      "cancel": "Annulla",
      "confirm": "Sblocca",
      "error": "Password errata",
      "lockout": "Troppi tentativi falliti. Riprova tra {{minutes}} minuti.",
      "genericError": "Si è verificato un errore",
      "resetPassword": "Reimposta password",
      "forgotPassword": "Password dimenticata?",
      "title": "Cartella Protetta",
      "description": "La cartella \"{{folderName}}\" richiede una password."
    },
    "filePasswordForm": {
      "title": "Protezione Password Cartella",
      "createTitle": "Imposta Protezione Password",
      "editTitle": "Modifica Protezione Password",
      "password": "Password",
      "currentPassword": "Password attuale",
      "newPassword": "Nuova Password",
      "newPasswordHelp": "Lascia vuoto per mantenere la password corrente",
      "ownerBypass": "Bypass Proprietario",
      "ownerBypassDescription": "Il proprietario può accedere alla cartella senza password",
      "adminBypass": "Bypass Admin",
      "adminBypassDescription": "L'admin può accedere alla cartella senza password",
      "maxFailedAttempts": "Tentativi Falliti Massimi",
      "lockoutDuration": "Durata Blocco (minuti)",
      "sessionDuration": "Durata Sessione (minuti)",
      "expirationDate": "Data di Scadenza",
      "expirationDatePlaceholder": "Seleziona data (opzionale)",
      "remove": "Rimuovi Password",
      "removeConfirm": "Sei sicuro di voler rimuovere la password?",
      "validation": {
        "required": "Questo campo è obbligatorio",
        "minLength": "Deve essere di almeno {{min}} caratteri",
        "expirationDateExpired": "La data di scadenza non può essere nel passato"
      }
    },
    "fileSessionsForm": {
      "title": "Sessioni cartelle",
      "revokeAllSessionsDescription": "Tutte le sessioni di sblocco per \"{{fileName}}\" saranno revocate. Gli utenti dovranno inserire nuovamente la password per accedere a questa cartella.",
      "revokeAllFolderSessionsDescription": "Tutte le sessioni di sblocco delle cartelle saranno revocate. Gli utenti dovranno inserire nuovamente la password per accedere alle cartelle protette.",
      "noSessions": "Nessuna sessione attiva",
      "unknownDevice": "Dispositivo sconosciuto",
      "createdAt": "Creata il",
      "expiresAt": "Scade il",
      "revokeSession": "Revoca",
      "sessionRevoked": "Sessione revocata con successo",
      "sessionRevoked_other": "{{count}} sessioni revocate con successo",
      "allSessionsRevoked": "Tutte le sessioni sono state revocate",
      "fetchError": "Errore nel recupero delle sessioni",
      "revokeError": "Errore nella revoca della sessione",
      "revokeAllError": "Errore nella revoca di tutte le sessioni",
      "revokeSessionConfirmTitle": "Revocare questa sessione?",
      "revokeSessionConfirmDescription": "La sessione di sblocco di questa cartella verrà revocata immediatamente. L'utente dovrà inserire nuovamente la password per accedere a questa cartella.",
      "revokeAllConfirmTitle": "Revocare tutte le sessioni delle cartelle?",
      "revokeAllConfirmDescription": "Tutte le sessioni di sblocco delle cartelle saranno revocate. Gli utenti dovranno inserire nuovamente la password per accedere alle cartelle protette.",
      "logoutAll": "Revoca tutte"
    },
    "userSessionsForm": {
      "activeSessions": "Sessioni attive",
      "manageSessions": "Gestisci sessioni",
      "manageUserSessions": "Sessioni di {{userName}}",
      "noSessions": "Nessuna sessione attiva",
      "unknownBrowser": "Browser sconosciuto",
      "unknownDevice": "Dispositivo sconosciuto",
      "lastActivity": "Ultima attività",
      "expiresAt": "Scade il",
      "currentSession": "Sessione corrente",
      "revokeSession": "Revoca",
      "sessionRevoked": "Sessione revocata con successo",
      "sessionRevoked_other": "{{count}} sessioni revocate con successo",
      "otherSessionsRevoked": "{{count}} sessione revocata con successo",
      "otherSessionsRevoked_other": "{{count}} sessioni revocate con successo",
      "allSessionsRevoked": "Tutte le sessioni sono state revocate",
      "revokeSessionConfirmTitle": "Revocare questa sessione?",
      "revokeSessionConfirmDescription": "Il dispositivo verrà disconnesso immediatamente.",
      "revokeGroupedSessionConfirmDescription": "Verranno revocate {{count}} sessioni da questo dispositivo.",
      "revokeOthersConfirmTitle": "Disconnettere tutti gli altri dispositivi?",
      "revokeOthersConfirmDescription": "Tutti i dispositivi tranne quello corrente verranno disconnessi.",
      "revokeAllConfirmTitle": "Disconnettere tutti i dispositivi?",
      "revokeAllConfirmDescription": "Tutti i dispositivi verranno disconnessi, incluso quello corrente. Dovrai effettuare nuovamente l'accesso.",
      "adminRevokeAllConfirmTitle": "Disconnettere tutte le sessioni dell'utente?",
      "adminRevokeAllConfirmDescription": "Tutte le sessioni di {{userName}} verranno revocate. L'utente dovrà effettuare nuovamente l'accesso.",
      "logoutOthers": "Disconnetti altri dispositivi",
      "logoutAll": "Disconnetti tutti",
      "revokeAllUserSessions": "Disconnetti tutte"
    },
    "resetFilePasswordForm": {
      "forgotPassword": "Password dimenticata?",
      "otpSentToEmail": "OTP inviato al tuo indirizzo email.",
      "resetPassword": "Reimposta password",
      "otpCodeLabel": "Codice OTP",
      "newPasswordLabel": "Nuova password",
      "wrongOtpCode": "Codice OTP errato.",
      "tooManyAttemptsRequestNewOtp": "Troppi tentativi. Richiedi un nuovo OTP.",
      "codeExpiredRequestNewOtp": "Codice scaduto. Richiedi un nuovo OTP.",
      "otpRequired": "Il codice OTP è obbligatorio",
      "otpMustBe6": "Il codice OTP deve essere di 6 cifre",
      "newPasswordRequired": "La nuova password è obbligatoria",
      "newPasswordMin": "La password deve essere di almeno 4 caratteri",
      "passwordResetSuccess": "Password reimpostata con successo.",
      "tooManyOtpRequests": "Troppe richieste OTP. Riprova più tardi."
    },
    "fileMoveForm": {
      "title": "Sposta {{resource}}",
      "title_other": "Sposta {{count}} file",
      "currentPosition": "Posizione attuale",
      "folderIsEmpty": "La cartella è vuota",
      "selectFolderToMoveInto": "Seleziona una posizione per mostrare il percorso della cartella in cui spostare il file"
    },
    "convertToPdf": {
      "title": "Converti in PDF",
      "selectDestination": "Seleziona cartella di destinazione"
    },
    "fileShortcutForm": {
      "title": "Crea un collegamento per {{resource}}",
      "currentPosition": "Posizione attuale",
      "folderIsEmpty": "La cartella è vuota",
      "selectFolderToCreateShortcutInto": "Seleziona una posizione per mostrare il percorso della cartella in cui creare il collegamento",
      "goBack": "Torna indietro"
    },
    "fileChooseDestinationForm": {
      "currentPosition": "Posizione attuale",
      "folderIsEmpty": "La cartella è vuota",
      "selectFolderHint": "Seleziona la cartella in cui salvare il file",
      "goBack": "Torna indietro"
    },
    "fileShareForm": {
      "title": "Condividi {{resource}}",
      "title_other": "Condividi {{count}} file",
      "message": "Condividi questo file con uno o più utenti o gruppi.",
      "message_other": "Condividi {{count}} file con uno o più utenti o gruppi.",
      "currentPosition": "Posizione attuale",
      "folderIsEmpty": "La cartella è vuota",
      "selectFolderToShareInto": "Seleziona una posizione per mostrare il percorso della cartella in cui vuoi condividere il file",
      "peopleWithAccess": "Persone con accesso",
      "sendMessage": "Notifica i destinatari via email",
      "sendMessagePlaceholder": "Aggiungi un messaggio personalizzato (opzionale)",
      "existingAccessesChanged": "Accessi esistenti modificati",
      "existingAccessesChangedDescription": "Salva applica le modifiche agli accessi esistenti e poi aggiunge i nuovi utenti o gruppi. Annulla lascia il form com'è e non li aggiunge.",
      "existingAccessesExpirationRequired": "Per aggiornare questi accessi già esistenti è necessario impostare una data di scadenza consentita dalle policy aziendali.",
      "applyAllExpirationDates": "Applica a tutti",
      "ariaLabel": "Modulo di condivisione file",
      "selectUsersOrGroups": "Seleziona utenti o gruppi",
      "userMultiSelectAria": "Selezione utenti e gruppi",
      "actions": "Azioni"
    },
    "filePublicLinkForm": {
      "title": "Link pubblico",
      "createTitle": "Crea link pubblico",
      "expirationLabel": "Scadenza (opzionale)",
      "expirationLabelRequired": "Scadenza",
      "expirationPlaceholder": "Mai",
      "maxAccessCountLabel": "Numero massimo di accessi (opzionale)",
      "maxAccessCountLabelRequired": "Numero massimo di accessi",
      "maxAccessCountPlaceholder": "Illimitato",
      "allowDownload": "Consenti download",
      "protectWithPassword": "Proteggi con password",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Inserisci password",
      "passwordRequired": "La password è obbligatoria quando la protezione è attiva.",
      "createLink": "Crea link",
      "linkCreatedTitle": "Link creato!",
      "linkCreatedMessage": "Il link pubblico è stato creato.",
      "copyLink": "Copia link",
      "warning": "Creare un link pubblico bypassa le protezioni standard del file. Chiunque abbia il link può accedere al contenuto del documento: utilizzare con cautela.",
      "expiresAt": "Scade",
      "remainingAccesses": "Accessi rimanenti",
      "password": "Password",
      "revoke": "Revoca link",
      "revoked": "Link pubblico revocato con successo.",
      "publicUrl": "URL pubblico",
      "status": "Stato",
      "statusActive": "Attivo",
      "statusExpired": "Scaduto",
      "statusExhausted": "Limite raggiunto",
      "accessCount": "Accessi",
      "hasPassword": "Protetto da password",
      "createdAt": "Creato",
      "errors": {
        "linkAlreadyExists": "Esiste già un link pubblico per questo file. Revocalo prima di crearne uno nuovo.",
        "linkNotFound": "Nessun link attivo trovato per questo file.",
        "featureDisabled": "I link pubblici sono disabilitati per la tua organizzazione.",
        "notOwner": "Devi essere il proprietario per creare o revocare link pubblici."
      }
    },
    "filePublicLinksForm": {
      "statusExpired": "Scaduto",
      "statusExhausted": "Limite raggiunto",
      "statusActive": "Attivo",
      "expiresAt": "Scade",
      "accessCount": "Accessi",
      "hasPassword": "Password",
      "empty": "Nessun link pubblico."
    },
    "userTransferOwnershipForm": {
      "title": "Trasferisci proprietà – {{sourceName}}",
      "destinationLabel": "Utente di destinazione",
      "destinationPlaceholder": "Cerca e seleziona un utente",
      "destinationRequired": "Seleziona un utente di destinazione.",
      "infoMessage": "I file verranno spostati in una cartella \"Transferred from {{email}}\" nella root del destinatario. I file in vendita sul marketplace non verranno trasferiti.",
      "submit": "Trasferisci proprietà",
      "cancel": "Annulla",
      "close": "Chiudi",
      "successTitle": "Trasferimento completato",
      "resultFilesTransferred": "File trasferiti",
      "resultFoldersTransferred": "Cartelle trasferite",
      "resultSharesUpdated": "Condivisioni aggiornate",
      "resultSelfSharesRemoved": "Condivisioni proprie rimosse",
      "resultTagAssignmentsRemoved": "Assegnazioni tag rimosse",
      "resultTagAssignmentsTransferred": "Assegnazioni tag trasferite",
      "resultFilesForSaleExcluded": "File in vendita esclusi",
      "resultWrapperFolderName": "Nome cartella contenitore"
    },
    "userTotpForm": {
      "title": "2FA – {{userName}}",
      "statusTitle": "Stato 2FA",
      "totpEnabled": "TOTP abilitato",
      "enabledAt": "Data abilitazione",
      "backupCodesRemaining": "Codici di backup rimanenti",
      "requiredByPolicy": "Richiesto da policy",
      "lockoutStatus": "Stato lockout",
      "failedAttempts": "Tentativi falliti",
      "exemptionTitle": "Esenzione TOTP",
      "grantExemption": "Concedi esenzione",
      "revokeExemption": "Revoca esenzione",
      "revoke": "Revoca",
      "exemptionTypeTemporary": "Temporanea",
      "exemptionTypePermanent": "Permanente",
      "exemptionTypeLabel": "Tipo",
      "exemptionExpires": "Scade il",
      "exemptionReason": "Motivo",
      "grantedBy": "Concessa da",
      "grantedAt": "Data concessione",
      "grantDialogTitle": "Concedi esenzione",
      "grantDialogTemporary": "Temporanea",
      "grantDialogPermanent": "Permanente",
      "grantDialogDays": "Giorni",
      "grantDialogReason": "Motivo (min 5 caratteri)",
      "grantSubmit": "Concedi",
      "revokeConfirmTitle": "Revoca esenzione",
      "revokeConfirmDescription": "L'utente dovrà nuovamente rispettare la policy 2FA.",
      "disableConfirmTitle": "Disabilitare la 2FA per questo utente?",
      "disableConfirmDescription": "Verrà rimossa l'autenticazione a due fattori per l'utente. Dovrà riconfigurarla se richiesta dalla policy.",
      "statusLoading": "Caricamento…",
      "statusError": "Impossibile caricare lo stato 2FA.",
      "grantSuccess": "Esenzione concessa.",
      "revokeSuccess": "Esenzione revocata.",
      "disableSuccess": "2FA disabilitata.",
      "cancel": "Annulla",
      "disableTotp": "Disabilita 2FA",
      "retry": "Riprova",
      "errorGeneric": "Si è verificato un errore. Riprova."
    },
    "userPasskeyForm": {
      "cancel": "Annulla",
      "retry": "Riprova",
      "errorGeneric": "Si è verificato un errore. Riprova.",
      "passkeyRemove": "Rimuovi",
      "passkeyRemoveAll": "Rimuovi tutti i passkey",
      "passkeyRemoveAllConfirm": "Verranno rimossi tutti i {{count}} passkey per questo utente. Dovrà registrarne di nuovi.",
      "passkeyRemoveAllSuccess": "Tutti i passkey sono stati rimossi.",
      "passkeyRemoveAllTitle": "Rimuovere tutti i passkey?",
      "passkeyRemoveConfirm": "Rimuovere il passkey \"{{name}}\"? L'utente non potrà più usarlo per accedere.",
      "passkeyRemoveSuccess": "Passkey rimosso.",
      "passkeyRemoveTitle": "Rimuovere passkey?",
      "passkeysBlocked": "Blocco passkey",
      "passkeysCount": "Passkey registrati",
      "passkeysEnabled": "Passkey abilitati",
      "passkeysFailedAttempts": "Tentativi falliti (passkey)",
      "passkeysLoadError": "Impossibile caricare lo stato amministrativo dei passkey.",
      "passkeysTitle": "Passkey"
    },
    "loginTokensForm": {
      "title": "Token di accesso – {{userName}}",
      "manageTokens": "Gestisci token di accesso",
      "noTokens": "Nessun token di accesso configurato per questo utente.",
      "createToken": "Crea nuovo token",
      "label": "Etichetta",
      "labelRequired": "L'etichetta è obbligatoria",
      "labelPlaceholder": "es. Integrazione CRM, Pipeline CI/CD",
      "expirationDays": "Scadenza (giorni)",
      "create": "Crea",
      "cancel": "Annulla",
      "close": "Chiudi",
      "delete": "Elimina",
      "retry": "Riprova",
      "enabled": "Abilitato",
      "disabled": "Disabilitato",
      "expired": "Scaduto",
      "enable": "Abilita",
      "disable": "Disabilita",
      "createdAt": "Creato",
      "expiresAt": "Scadenza",
      "lastUsed": "Ultimo utilizzo",
      "lastUsedIp": "Ultimo IP",
      "neverUsed": "Mai utilizzato",
      "maxTokensReached": "Numero massimo di token raggiunto (2). Elimina un token esistente per crearne uno nuovo.",
      "tokenCreatedTitle": "Token creato con successo",
      "tokenCreatedWarning": "Copia questo token adesso. Non sarà più visualizzabile.",
      "copyToken": "Copia token",
      "copied": "Copiato!",
      "deleteConfirmTitle": "Eliminare il token di accesso?",
      "deleteConfirmDescription": "Il token \"{{label}}\" verrà eliminato permanentemente e non potrà più essere utilizzato per l'autenticazione.",
      "deleteSuccess": "Token eliminato con successo.",
      "errorCannotCreateTokenForSuperAdmin": "Non è possibile creare token di accesso per i super amministratori.",
      "errorGeneric": "Si è verificato un errore. Riprova.",
      "errorLoad": "Errore nel caricamento dei token di accesso.",
      "errorMaxReached": "Questo utente ha già il numero massimo di token.",
      "errorTokenAlreadyUsed": "Questo token è già stato utilizzato e non può essere riabilitato."
    },
    "alertDismiss": {
      "title": "Posticipa o nascondi avviso",
      "chooseAction": "Come vuoi procedere?",
      "permanent": "Non mostrare più",
      "snooze": "Ricordamelo più tardi",
      "snoozeDuration": "Ricordamelo tra",
      "confirm": "Applica",
      "success": "Preferenza salvata."
    },
    "alertsList": {
      "title": "Tutti gli avvisi attivi",
      "dismiss": "Posticipa o nascondi"
    },
    "totpForm": {
      "title": "Autenticazione a due fattori",
      "statusActive": "Attivo",
      "statusInactive": "Inattivo",
      "activatedOn": "Attivato il {{date}}",
      "backupCodesRemaining": "{{count}} / {{total}} codici di backup rimanenti",
      "requiredByPolicy": "La tua azienda richiede l'autenticazione a due fattori.",
      "gracePeriodEnds": "Hai tempo fino al {{date}} per attivarla.",
      "activate": "Attiva 2FA",
      "setupTitle": "Configura autenticazione a due fattori",
      "scanQR": "Scansiona questo codice QR con la tua app authenticator (Google Authenticator, Microsoft Authenticator, Authy, ecc.).",
      "manualEntry": "Non riesci a scansionare? Inserisci manualmente",
      "hideManual": "Nascondi inserimento manuale",
      "enterSecretManually": "Inserisci questo codice manualmente nell'app:",
      "copySecret": "Copia",
      "copied": "Copiato negli appunti",
      "verifyCodeLabel": "Inserisci il codice a 6 cifre dall'app",
      "verifyAndActivate": "Verifica e attiva",
      "backupCodesTitle": "Autenticazione a due fattori attivata!",
      "regenerateSuccess": "Codici di backup rigenerati",
      "backupCodesWarning": "Salva questi codici di backup in un posto sicuro. Possono essere usati per accedere al tuo account se perdi l'accesso all'app authenticator. Ogni codice può essere usato una sola volta.",
      "copyAll": "Copia tutti",
      "download": "Scarica",
      "print": "Stampa",
      "savedConfirm": "Ho salvato i codici in un posto sicuro",
      "continue": "Continua",
      "regenerateBackupCodes": "Rigenera codici di backup",
      "disableTotp": "Disabilita 2FA",
      "disableConfirm": "Disabilitare l'autenticazione a due fattori?",
      "disableConfirmDescription": "Rimuovere la 2FA renderà il tuo account meno sicuro. Dovrai riconfigurare l'app authenticator se vorrai riattivare la 2FA in futuro.",
      "enterCodeToConfirm": "Inserisci il codice TOTP per confermare",
      "cancel": "Annulla",
      "disable": "Disabilita",
      "disabledSuccess": "L'autenticazione a due fattori è stata disattivata.",
      "invalidCode": "Codice non valido. Riprova.",
      "errorGeneric": "Si è verificato un errore. Riprova.",
      "retry": "Riprova"
    },
    "passkeyCreateForm": {
      "addDescription": "Continuando, il browser chiederà di verificare con Touch ID, Face ID, Windows Hello o la tua chiave di sicurezza.",
      "continueAuthenticator": "Continua",
      "deviceNameInvalid": "Inserisci un nome dispositivo tra 1 e 100 caratteri.",
      "deviceNameLabel": "Nome dispositivo",
      "deviceNamePlaceholder": "es. MacBook Touch ID",
      "passkeyCancelled": "Accesso con passkey annullato.",
      "registerErrorDeviceAlreadyRegistered": "È già registrata una passkey per questo dispositivo. Usa un altro autenticatore o rimuovi prima la passkey esistente.",
      "registerErrorGeneric": "Non è stato possibile completare la registrazione della passkey. Riprova.",
      "registerErrorNotSupported": "Il browser o il dispositivo non supporta questo tipo di registrazione passkey.",
      "registerSuccess": "Passkey salvato.",
      "title": "Aggiungi un passkey"
    },
    "passkeyEditForm": {
      "deviceNameInvalid": "Inserisci un nome dispositivo tra 1 e 100 caratteri.",
      "deviceNameLabel": "Nome dispositivo",
      "renameError": "Impossibile rinominare il passkey.",
      "renameSuccess": "Passkey rinominato.",
      "saveLabel": "Salva",
      "title": "Rinomina passkey"
    },
    "passkeysForm": {
      "addPasskey": "Aggiungi passkey",
      "browserUnsupported": "Il browser non supporta i passkey. Usa una versione recente di Chrome, Safari, Edge o Firefox.",
      "empty": "Nessun passkey ancora. Aggiungine uno per accedere più velocemente e usarlo come secondo fattore.",
      "lastUsed": "Ultimo utilizzo",
      "loadError": "Impossibile caricare lo stato dei passkey.",
      "maxReached": "Puoi registrare fino a {{max}} passkey.",
      "never": "Mai",
      "passwordless": "Senza password",
      "passwordlessDisabled": "Accesso senza password disattivato.",
      "passwordlessEnabled": "Accesso senza password attivato.",
      "passwordlessUnavailable": "Non disponibile su questo dispositivo",
      "policyDisabled": "La tua organizzazione ha disabilitato i passkey.",
      "registered": "Registrato",
      "remove": "Rimuovi",
      "removeConfirm": "Rimuovere il passkey \"{{name}}\"? Non potrai più usarlo per accedere.",
      "removeError": "Impossibile rimuovere il passkey.",
      "removeLastWarning": "È il tuo unico passkey. Rimuovendolo disattiverai l'accesso con passkey finché non ne aggiungi uno nuovo.",
      "removeSuccess": "Passkey rimosso.",
      "removeTitle": "Rimuovere passkey?",
      "rename": "Rinomina",
      "title": "Passkey",
      "toggleError": "Impossibile aggiornare l'accesso senza password.",
      "transport": "Tipo di dispositivo",
      "transportBle": "Chiave di sicurezza Bluetooth",
      "transportHybrid": "Telefono",
      "transportHybridInternal": "Passkey sincronizzato (telefono)",
      "transportInternal": "Questo dispositivo (Touch ID, Face ID, Windows Hello)",
      "transportNfc": "Chiave di sicurezza (NFC)",
      "transportUsb": "Chiave di sicurezza (USB)",
      "transportUsbNfc": "Chiave di sicurezza (USB + NFC)",
      "transportUnknown": "Non indicato"
    },
    "filesSelectForm": {
      "confirmDeselectParent": "Deselezionare la cartella padre?",
      "confirmDeselectParentDescription": "Selezionando questa cartella, verranno deselezionate la cartella padre e tutte le cartelle allo stesso livello. Vuoi continuare?",
      "ariaLabel": "Modulo di condivisione file",
      "selectUsersOrGroups": "Seleziona utenti o gruppi",
      "userMultiSelectAria": "Selezione utenti e gruppi",
      "actions": "Azioni"
    },
    "fileTagsForm": {
      "title": "Modifica Tag - {{resource}}",
      "availableTags": "Tag disponibili",
      "assignedTags": "Tag associati",
      "searchAvailableTags": "Cerca tag disponibili",
      "searchAssignedTags": "Cerca tag associati",
      "noAssignedTags": "Nessun tag associato",
      "clickHintAdd": "Clicca un tag per aggiungerlo.",
      "clickHintRemove": "Clicca un tag per rimuoverlo. Trascina la maniglia per riordinare.",
      "clickToAdd": "Aggiungi tag {{title}}",
      "clickToRemove": "Rimuovi tag {{title}}",
      "dragToReorder": "Trascina per riordinare {{title}}",
      "aiScrapingOnlyPdfOffice": "Lo scraping AI è attivo solo su file PDF e Office.",
      "watermarkOnlyPdfOffice": "La protezione watermark è attiva solo su file PDF e Office."
    },
    "openFileFromTrash": {
      "title": "Questo file è nel cestino",
      "description": "Per visualizzare <strong>{{resource}}</strong>, devi ripristinarlo dal cestino."
    },
    "fileUploadOptionsForm": {
      "title": "Opzioni di caricamento",
      "description": "<strong>{{resource}}</strong> esiste già in questa posizione. Vuoi sostituire il file esistente con una nuova versione o mantenere entrambi? La sostituzione non cambierà le opzioni di condivisione",
      "description_other": "Uno o più elementi esistono già in questa posizione. Vuoi sostituire i file esistenti con nuove versioni o mantenere entrambi? La sostituzione non cambierà le opzioni di condivisione",
      "replaceExistingFile": "Sostituisci file esistente",
      "replaceExistingFile_other": "Sostituisci i file esistenti",
      "keepBothFiles": "Mantieni entrambi i file",
      "keepBothFiles_other": "Mantieni entrambi i file",
      "newOnly": "Solo nuovi"
    },
    "filePermanentlyDeleteForm": {
      "title": "Elimina definitivamente {{resource}}",
      "title_other": "Elimina definitivamente {{count}} file",
      "description": "Sei sicuro di voler eliminare definitivamente <strong>{{resource}}</strong>? Questa azione non può essere annullata.",
      "description_other": "Sei sicuro di voler eliminare definitivamente <strong>questi file</strong>? Questa azione non può essere annullata."
    },
    "fileSellForm": {
      "title": "Vendi file",
      "message": "Vendi il file con FileGrant",
      "uploadPreview": "Clicca o trascina per caricare l’anteprima",
      "uploadPreviewHint": "Immagine quadrata - Max 5MB",
      "removeImage": "Rimuovi immagine",
      "pleaseEnterPrice": "Inserisci un prezzo",
      "invalidNumber": "Numero non valido",
      "priceMin": "Il prezzo deve essere almeno €{{amount}}",
      "allowDownload": "Consenti download del file",
      "removeFromStore": "Rimuovi dallo store",
      "listedSuccess": "File messo in vendita con successo!",
      "purchaseLink": "Link di acquisto",
      "previewUploadError": "Errore durante il caricamento dell’anteprima",
      "imageTooLarge": "L’immagine deve essere più piccola di 5MB",
      "unableToReadImage": "Impossibile leggere l’immagine",
      "previewAlt": "Anteprima",
      "mustBeImage": "Il file deve essere un’immagine",
      "previewImage": "Immagine di anteprima"
    },
    "emptyFilesTrash": {
      "title": "Svuota cestino",
      "description": "Sei sicuro di voler svuotare il cestino? Digita <strong>{{keyword}}</strong> per confermare, questa azione non può essere annullata."
    },
    "settingExceptionsForm": {
      "title": "Modifica eccezioni",
      "description": "Modifica le eccezioni per l'impostazione.",
      "currentExceptions": "Eccezioni attuali",
      "unsavedExceptions": "Eccezioni non salvate"
    },
    "aiSummary": {
      "title": "Riepilogo IA"
    },
    "aiDocumentChat": {
      "title": "Chat con documento"
    },
    "sendInvitationToGroupUsers": {
      "title": "Invia invito",
      "description": "Puoi inviare un messaggio personalizzato ai nuovi utenti del gruppo oppure chiudere questa finestra senza ulteriori azioni.",
      "success": "Invito inviato con successo",
      "error": "Errore nell'invio dell'invito",
      "customMessagePlaceholder": "Opzionale: messaggio personalizzato"
    },
    "sendInvitationToUsers": {
      "title": "Invia invito",
      "description": "Puoi inviare un messaggio personalizzato a {{resource}} oppure chiudere questa finestra senza ulteriori azioni.",
      "description_other": "Puoi inviare un messaggio personalizzato a {{count}} utenti oppure chiudere questa finestra senza ulteriori azioni.",
      "success": "Invito inviato con successo",
      "error": "Errore nell'invio dell'invito",
      "customMessagePlaceholder": "Opzionale: messaggio personalizzato"
    },
    "restoreFileVersion": {
      "title": "Ripristina versione file",
      "description": "Sei sicuro di voler ripristinare <strong>{{resource}}</strong> alla versione <strong>{{version}}</strong>?"
    },
    "fileShareFormUnauthorizedUsers": {
      "title": "Utenti non autorizzati",
      "descriptionForAllUsers": "Non puoi condividere file con questi utenti a causa delle impostazioni correnti",
      "descriptionForSomeUsers": "Non puoi condividere file con questi utenti: <strong> {{users}} </strong> a causa delle impostazioni correnti, vuoi condividere con gli altri utenti che non sono bloccati dall'impostazione?"
    },
    "sessionExpired": {
      "title": "Sessione scaduta",
      "description": "La tua sessione è scaduta. Effettua di nuovo l'accesso per continuare.",
      "redirectMessage": "Sei redirezionato al login in <strong>{{seconds}}</strong> secondi…",
      "goToLoginNow": "Vai subito al login"
    },
    "appUpdated": {
      "title": "Nuova versione disponibile",
      "description": "È disponibile una nuova versione dell'applicazione. Ricarica la pagina per continuare.",
      "reloadButton": "Ricarica"
    },
    "tooManyRequestsOverlay": {
      "title": "Troppe richieste",
      "description": "Hai effettuato troppe richieste in poco tempo. Attendi qualche istante prima di riprovare.",
      "redirectMessage": "Potrai riprovare tra <strong>{{seconds}}</strong> secondi…"
    },
    "activateTotpOverlay": {
      "badge": "Protezione account",
      "title": "I tuoi file meritano una difesa in più",
      "description1": "In CyberGrant sappiamo che i dati riservati non hanno un prezzo — o meglio, ce l'hanno, ed è altissimo per chi te li vuole sottrarre.",
      "description2": "L'autenticazione a due fattori (2FA) aggiunge un secondo livello di verifica che blocca gli accessi non autorizzati anche in caso di credenziali compromesse.",
      "stat1Value": "99,9%",
      "stat1Label": "degli attacchi automatizzati bloccati con 2FA",
      "stat2Value": "< 30s",
      "stat2Label": "per completare la configurazione iniziale",
      "featuresTitle": "Con il 2FA attivo",
      "feature1": "Nessun accesso possibile senza il tuo telefono",
      "feature2": "Notifica immediata su ogni tentativo sospetto",
      "feature3": "Conformità rafforzata con NIS2 e GDPR",
      "actionActivate": "Attiva 2FA ora",
      "actionRemind": "Ricordamelo tra {{count}} giorno",
      "actionRemind_other": "Ricordamelo tra {{count}} giorni",
      "actionSkipForever": "Accetto il rischio e non voglio attivare la 2FA",
      "skipForever": "Salta per sempre",
      "skipForeverConfirmTitle": "Conferma la scelta",
      "skipForeverConfirmBody1": "Stai scegliendo di non attivare la verifica in due passaggi (2FA). La 2FA è la misura di sicurezza più semplice ed efficace che puoi adottare. Non attivarla è un rischio inutile e facilmente evitabile.",
      "skipForeverConfirmBody2": "Sei sicuro di voler continuare senza attivare la verifica in due passaggi (2FA)?",
      "skipForeverConfirmEnableNow": "Attivala subito",
      "skipForeverConfirmDecline": "Non voglio attivarla",
      "footer": "Potrai gestire il 2FA in qualsiasi momento dalle Impostazioni di sicurezza del tuo account.",
      "badgeMandatory": "Azione richiesta",
      "titleMandatory": "L'autenticazione a due fattori è ora obbligatoria",
      "description1Mandatory": "La tua organizzazione richiede l'autenticazione a due fattori (2FA) per il tuo account e il periodo di tolleranza per configurarla è terminato. Devi attivarla ora per continuare a usare Filegrant.",
      "footerMandatory": "Questo passaggio è richiesto dalla politica di sicurezza della tua organizzazione e non può essere rimandato."
    },
    "openFileLocallyError": {
      "title": "Client non trovato",
      "description": "Per aprire documenti localmente, devi avere Remotegrant installato. Contatta l'amministratore per installarlo."
    },
    "offline": {
      "title": "Offline",
      "description": "Sei offline. Verifica la tua connessione internet e riprova.",
      "message": "In attesa di connessione internet..."
    },
    "webAppUpdateAvailable": {
      "title": "Aggiornamento app web disponibile",
      "description": "Una nuova versione dell'app web è disponibile. Aggiorna la pagina per applicare le ultime modifiche.",
      "okText": "Update",
      "cancelText": "Dopo"
    },
    "keepFilesOfflineError": {
      "title": "Client non trovato",
      "description": "Per mantenere i file sul tuo PC, devi avere l'agente RemoteGrant installato. Contatta il tuo amministratore per installarlo."
    },
    "sharingApprovalRequirementReviewTeamForm": {
      "title": "Gestisci Team di Revisione",
      "description": "Gestisci il team di revisione per la richiesta di condivisione."
    },
    "tagsRequiredForShare": {
      "title": "Tag richiesti per la condivisione",
      "description": "Il file <strong>{{resource}}</strong> richiede tag per essere condiviso. Aggiungi tag al file e riprova.",
      "description_other": "Alcuni di questi file richiedono tag per essere condivisi. Aggiungi tag ai file e riprova."
    },
    "tagsRequiredForDownload": {
      "title": "Tag richiesti per il download",
      "description": "Il file <strong>{{resource}}</strong> richiede tag per essere scaricato. Aggiungi tag al file e riprova.",
      "description_other": "Alcuni di questi file richiedono tag per essere scaricati. Aggiungi tag ai file e riprova."
    },
    "filesWithShortcutsDeleteConfirmation": {
      "title": "Eliminare i file?",
      "description": "Sei sicuro di voler eliminare <strong>{{resource}}</strong>? Sono stati trovati collegamenti dei file selezionati. Se elimini questo file, quei collegamenti non funzioneranno più <br /><br />Vuoi continuare?",
      "description_other": "Sei sicuro di voler eliminare <strong>questi file</strong>? Sono stati trovati collegamenti dei file selezionati. Se elimini questi file, quei collegamenti non funzioneranno più <br /><br />Vuoi continuare?"
    },
    "officeTokenExpired": {
      "title": "La sessione è scaduta",
      "description": "Aggiornare la pagina per continuare"
    },
    "officeEditorBeta": {
      "title": "Provare il nuovo FileGrant Office?",
      "description": "FileGrant Office è disponibile in beta. Puoi continuare con l'editor classico oppure provare la nuova esperienza per questa sessione.",
      "tryNew": "Prova il nuovo",
      "useClassic": "Usa classico"
    },
    "officeEditorDelete": {
      "title": "Spostare nel cestino e chiudere l'editor?",
      "description": "Il file verrà spostato nel cestino e l'editor si chiuderà. Le modifiche non salvate sono gestite dall'autosalvataggio."
    },
    "applyIsUsedForFileVisibilityTags": {
      "title": "Applica tag ai file",
      "description": "L'applicazione dei tag selezionati condividerà automaticamente questi file con altri utenti, secondo le impostazioni di visibilità dei file con tag.<br /><br />Tag interessati:<br /><strong>{{resource}}</strong><br /><br />Vuoi continuare?",
      "description_other": "L'applicazione di alcuni dei tag selezionati condividerà automaticamente questi file con altri utenti, secondo le impostazioni di visibilità dei file con tag.<br /><br />Tag interessati:<br /><strong>{{resource}}</strong><br /><br />Vuoi continuare?"
    },
    "activeDirectoryUsersImportForm": {
      "importFromActiveDirectory": "Importa da Active Directory",
      "title": "Importa utenti da Active Directory",
      "searchUsers": "Cerca utenti...",
      "selectNew": "Seleziona solo nuovi",
      "existing": "Esistente",
      "new": "Nuovo",
      "importSelected": "Importa ({{count}})",
      "importSuccess": "Importazione completata: {{created}} creati, {{updated}} aggiornati",
      "importError": "Errore durante l'importazione",
      "errorLoadingUsers": "Errore nel caricamento utenti da Active Directory",
      "noUsersFound": "Nessun utente trovato",
      "resultSummary": "Creati: {{created}}, Aggiornati: {{updated}}, Saltati: {{skipped}}, Falliti: {{failed}}",
      "defaultRole": "Ruolo predefinito",
      "openSettings": "Apri impostazioni LDAP"
    },
    "activeDirectoryGroupsImportForm": {
      "importFromActiveDirectory": "Importa da Active Directory",
      "title": "Importa gruppi da Active Directory",
      "searchGroups": "Cerca gruppi...",
      "selectNew": "Seleziona solo nuovi",
      "existing": "Esistente",
      "new": "Nuovo",
      "importSelected": "Importa ({{count}})",
      "importSuccess": "Importazione completata: {{created}} creati, {{updated}} aggiornati",
      "importError": "Errore durante l'importazione",
      "errorLoadingGroups": "Errore nel caricamento gruppi da Active Directory",
      "noGroupsFound": "Nessun gruppo trovato",
      "resultSummary": "Creati: {{created}}, Aggiornati: {{updated}}, Saltati: {{skipped}}, Falliti: {{failed}}",
      "defaultRole": "Ruolo predefinito",
      "openSettings": "Apri impostazioni LDAP",
      "importMembers": "Importa membri",
      "usersImported": "{{count}} membro/i anche importati",
      "linked": "Collegato"
    },
    "entraIdFullSync": {
      "menuLabel": "Sincronizzazione completa (Entra ID)",
      "title": "Sincronizzazione completa Entra ID",
      "syncUsers": "Sincronizza utenti",
      "syncGroups": "Sincronizza gruppi",
      "createMissingUsers": "Crea utenti mancanti",
      "createMissingGroups": "Crea gruppi mancanti",
      "updateExisting": "Aggiorna esistenti",
      "disableMissingUsers": "Disabilita utenti non più presenti nella directory",
      "disableMissingUsersTitle": "Disabilitare gli utenti mancanti?",
      "disableMissingUsersConfirm": "Gli utenti importati da questa directory che non sono più presenti verranno disabilitati in Filegrant. Gli utenti disabilitati da un amministratore non verranno riabilitati dalla sincronizzazione. Continuare?",
      "confirmSync": "Sincronizza e disabilita",
      "groupFilter": "Filtro nome gruppo (opzionale)",
      "defaultRole": "Ruolo predefinito per i nuovi utenti",
      "runSync": "Esegui sincronizzazione completa",
      "syncSuccess": "Sincronizzazione completa completata",
      "syncError": "Sincronizzazione completa non riuscita",
      "resultSummary": "Creati: {{created}}, Aggiornati: {{updated}}, Saltati: {{skipped}}, Falliti: {{failed}}"
    },
    "activeDirectoryFullSync": {
      "menuLabel": "Sincronizzazione completa (Active Directory)",
      "title": "Sincronizzazione completa Active Directory",
      "syncUsers": "Sincronizza utenti",
      "syncGroups": "Sincronizza gruppi",
      "createMissingUsers": "Crea utenti mancanti",
      "createMissingGroups": "Crea gruppi mancanti",
      "updateExisting": "Aggiorna esistenti",
      "disableMissingUsers": "Disabilita utenti non più presenti nella directory",
      "disableMissingUsersTitle": "Disabilitare gli utenti mancanti?",
      "disableMissingUsersConfirm": "Gli utenti importati da questa directory che non sono più presenti verranno disabilitati in Filegrant. Gli utenti disabilitati da un amministratore non verranno riabilitati dalla sincronizzazione. Continuare?",
      "confirmSync": "Sincronizza e disabilita",
      "groupFilter": "Filtro nome gruppo (opzionale)",
      "defaultRole": "Ruolo predefinito per i nuovi utenti",
      "runSync": "Esegui sincronizzazione completa",
      "syncSuccess": "Sincronizzazione completa completata",
      "syncError": "Sincronizzazione completa non riuscita",
      "resultSummary": "Creati: {{created}}, Aggiornati: {{updated}}, Saltati: {{skipped}}, Falliti: {{failed}}"
    },
    "directorySync": {
      "usersDisabled": "{{count}} utente/i disabilitati",
      "disableThemAnyway": "Disabilitali comunque",
      "suggestFullSync": "Suggerimento: una full sync può ri-collegare un gruppo ricreato nella directory.",
      "massDisableConfirmTitle": "Confermare la disabilitazione di massa?",
      "massDisableConfirmFallback": "Verrebbe disabilitata una quota ampia di utenti. Conferma per procedere."
    }
  },
  "specialFolders": {
    "FTA27E720F2F2BD4718893095FE4354A4F6": "Quick share"
  },
  "viewer": {
    "eml": {
      "attachments": "Allegati",
      "cc": "Cc",
      "date": "Data",
      "downloadAttachment": "Scarica {{name}}",
      "emptyBody": "Questo messaggio non ha contenuto nel corpo.",
      "from": "Da",
      "parseError": "Impossibile analizzare questo file email.",
      "showRawSource": "Mostra sorgente grezza",
      "subject": "Oggetto",
      "to": "A"
    },
    "ics": {
      "description": "Descrizione",
      "empty": "Nessun evento di calendario trovato in questo file.",
      "end": "Fine",
      "location": "Luogo",
      "organizer": "Organizzatore",
      "parseError": "Impossibile analizzare questo file calendario.",
      "showRaw": "Mostra sorgente grezza",
      "start": "Inizio",
      "untitled": "Evento senza titolo"
    },
    "msg": {
      "attachments": "Allegati",
      "cc": "Cc",
      "date": "Data",
      "downloadAttachment": "Scarica {{name}}",
      "emptyBody": "Questo messaggio non ha contenuto nel corpo.",
      "from": "Da",
      "parseError": "Impossibile analizzare questo messaggio Outlook.",
      "showRawSource": "Mostra sorgente grezza",
      "subject": "Oggetto",
      "to": "A"
    },
    "vcf": {
      "email": "Email",
      "empty": "Nessun contatto trovato in questo file.",
      "note": "Nota",
      "organization": "Organizzazione",
      "parseError": "Impossibile analizzare questo file contatto.",
      "phone": "Telefono",
      "showRaw": "Mostra sorgente grezza",
      "title": "Titolo",
      "unnamed": "Contatto senza nome"
    },
    "htmlPreview": {
      "title": "Apri anteprima HTML",
      "description": "Questo file HTML potrebbe contenere codice JavaScript potenzialmente pericoloso. L'anteprima verrà visualizzata in un ambiente sandbox per sicurezza. Vuoi procedere?",
      "button": "Anteprima HTML",
      "hideButton": "Nascondi anteprima"
    },
    "error": {
      "decryptFailed": {
        "title": "Decifratura non riuscita",
        "description": "Il file non può essere decifrato. Riprova."
      },
      "officeNoPreview": {
        "title": "Nessuna anteprima disponibile",
        "description": "Attenzione: verifica l'affidabilità della fonte prima di scaricare il file originale."
      },
      "blobFetchFailed": {
        "title": "File non trovato",
        "description": "Il file non è stato trovato. Riprova."
      },
      "videoPlayback": {
        "title": "Errore di riproduzione video",
        "description": "Impossibile riprodurre il video. Prova a ricaricare la pagina."
      },
      "videoUnsupported": {
        "title": "Formato video non supportato",
        "description": "Il browser non riesce a decodificare questo video (ad esempio HEVC/H.265 o video a 10 bit). Chiedi una versione codificata in H.264 (MP4) per riprodurlo qui."
      },
      "fetchFilePermissionsFailed": {
        "title": "Recupero permessi file non riuscito",
        "description": "Impossibile recuperare i permessi del file. Riprova."
      },
      "isFolder": {
        "title": "Il file è una cartella",
        "description": "Il file è una cartella. Non può essere aperto nel viewer."
      },
      "fetchFileFailed": {
        "title": "Recupero file non riuscito",
        "description": "Impossibile recuperare il file. Riprova."
      },
      "noPreviewAvailable": {
        "title": "Nessuna anteprima disponibile",
        "description": "Attenzione: verifica l'affidabilità della fonte prima di scaricare il file originale."
      },
      "noPermissions": {
        "title": "Nessun permesso",
        "description": "Non hai i permessi per aprire questo file."
      }
    },
    "sign": {
      "title": "Aggiungi firma",
      "add": "Aggiungi firma",
      "delete": "Rimuovi firma",
      "pickFolder": "Scegli cartella di destinazione",
      "saveSignature": "Salva anche questa firma nei File",
      "selectFolderHint": "Seleziona una posizione per mostrare il percorso della cartella in cui vuoi salvare la firma",
      "unavailable": "La firma PDF non è disponibile con la licenza attuale del visualizzatore.",
      "success": "PDF firmato salvato",
      "error": "Impossibile salvare il PDF firmato",
      "flattenWarning": "La firma non potrà essere rimossa dopo il salvataggio. Assicurati prima di salvare.",
      "modeEnabled": "Modalità firma attiva",
      "modeDisabled": "Modalità firma disattivata",
      "tab": {
        "draw": "Disegna",
        "upload": "Carica",
        "drive": "Dai File"
      },
      "draw": {
        "hint": "Disegna la firma nel riquadro",
        "clear": "Cancella"
      },
      "upload": {
        "dropHint": "Trascina un'immagine qui o clicca per sfogliare"
      },
      "replaceOrCopy": {
        "title": "Salva PDF firmato",
        "replace": "Sostituisci originale",
        "replaceHint": "Sovrascrivi il PDF attuale con la versione firmata",
        "copy": "Salva come copia",
        "copyHint": "Mantieni l'originale e salva il PDF firmato in una cartella a scelta"
      }
    }
  },
  "store": {
    "fileSalesOverview": "Panoramica vendite file",
    "totalSales": "Unità vendute",
    "fileRevenue": "Ricavi del file",
    "unitRevenue": "Prezzo unitario",
    "stock": "Stock",
    "openStoreLink": "Apri link dello store",
    "salesDashboard": "Dashboard vendite",
    "confirmEmail": "Conferma email",
    "confirmEmailPlaceholder": "Conferma la tua email",
    "emailPlaceholder": "tu@esempio.com",
    "pleaseEnterEmail": "Inserisci la tua email",
    "pleaseConfirmEmail": "Conferma la tua email",
    "emailsDoNotMatch": "Le due email non coincidono!",
    "invalidEmail": "L’email non è valida!",
    "payNow": "Paga ora",
    "paymentSuccessful": "Pagamento riuscito!",
    "fileAlreadySold": "File già venduto a questa email",
    "emailsMismatch": "Email e conferma non coincidono.",
    "invalidEmailFormat": "Formato email non valido",
    "fileNotFound": "File non trovato",
    "filePreview": "Anteprima file",
    "filePreviewAlt": "Anteprima file",
    "fileFullPreviewAlt": "Anteprima completa file",
    "byOwner": "Di {{name}}",
    "purchase": "Acquista"
  },
  "dashboard": {
    "title": "Report esecutivo",
    "tabs": {
      "overview": "Panoramica"
    },
    "riskIndicators": {
      "title": "Indicatori di Rischio",
      "untaggedFiles": {
        "label": "File senza TAG",
        "description": "Percentuale di file non classificati con TAG. Un valore alto indica rischio di non conformità alle policy di classificazione dati."
      },
      "sharingWithoutExpiration": {
        "label": "Condivisioni senza scadenza",
        "description": "Percentuale di condivisioni senza data di scadenza. Condivisioni perpetue aumentano il rischio di accesso non autorizzato nel tempo."
      },
      "editorSharing": {
        "label": "Condivisioni con permessi Editor",
        "description": "Percentuale di condivisioni con permessi di modifica. Valori alti aumentano il rischio di alterazione non autorizzata dei dati."
      },
      "externalSharing": {
        "label": "Condivisioni esterne",
        "description": "Percentuale di condivisioni verso domini esterni. Valori alti possono indicare rischio di fuga di dati sensibili."
      },
      "excessiveExpiration": {
        "label": "Scadenze eccessive",
        "description": "Percentuale di condivisioni attive con scadenza superiore a 90 giorni. Accessi prolungati aumentano il rischio di compromissione."
      },
      "userConcentration": {
        "label": "Concentrazione utente",
        "description": "Percentuale massima di condivisioni effettuate da un singolo utente. Alta concentrazione indica rischio di insider threat o account compromesso."
      },
      "thresholds": "Soglie"
    },
    "ssoCoverage": {
      "label": "Utenti interni senza SSO",
      "asOfNow": "Aggiornato adesso",
      "excluded": "Esclusi dall'SSO",
      "outsideDomains": "Dominio e-mail non coperto da SSO",
      "description": "Istantanea attuale degli utenti interni abilitati (tutti i ruoli tranne External, non scaduti) che accedono con OTP e-mail invece che con SSO. L'esclusione dall'SSO ha precedenza sul dominio non coperto. Non segue l'intervallo di date del report."
    },
    "riskDetail": {
      "viewDetails": "Dettagli",
      "user": "Utente",
      "domain": "Dominio",
      "domains": "Domini",
      "shares": "Condivisioni",
      "noData": "Nessun dato disponibile per questo indicatore",
      "totalUsers": "{{count}} utenti coinvolti",
      "countLabel": {
        "editorSharing": "Condivisioni Editor",
        "untaggedFiles": "File senza TAG",
        "sharingWithoutExpiration": "Senza scadenza",
        "externalSharing": "Condivisioni esterne",
        "excessiveExpiration": "Scadenze eccessive",
        "userConcentration": "Totale condivisioni"
      }
    },
    "volumeData": {
      "volume": "Volume",
      "files": "File",
      "folders": "Cartelle",
      "total": "Totale Elementi"
    },
    "classification": {
      "title": "Classificazione TAG",
      "withTag": "Con TAG",
      "withoutTag": "Senza TAG"
    },
    "sharing": {
      "title": "Condivisioni",
      "internal": "Interne",
      "external": "Esterne",
      "readOnly": "Solo Lettura",
      "editor": "Editor",
      "warning": "Attenzione"
    },
    "expiration": {
      "title": "Scadenze Condivisioni",
      "withExpiration": "con scadenza",
      "withoutExpiration": "senza scadenza"
    },
    "expirationAnalysis": {
      "title": "Analisi Scadenze Dettagliata",
      "count": "Conteggio",
      "average": "Durata Media",
      "active": "Attive",
      "expired": "Scadute",
      "min": "Durata Min",
      "max": "Durata Max",
      "days": "giorni",
      "distribution": {
        "expired": "Scaduti",
        "expiringSoon": "0-7 giorni",
        "shortTerm": "7-30 giorni",
        "mediumTerm": "30-90 giorni",
        "longTerm": "90-365 giorni",
        "excessive": ">365 giorni"
      }
    },
    "domains": {
      "title": "Domini Destinatari",
      "domain": "Dominio",
      "type": "Tipo",
      "count": "Conteggio",
      "distribution": "Distribuzione",
      "internal": "Interno",
      "external": "Esterno",
      "openRecipients": "Apri i destinatari delle condivisioni per {{domain}}"
    },
    "users": {
      "title": "Statistiche Utenti",
      "user": "Utente",
      "files": "File",
      "folders": "Cartelle",
      "total": "Totale",
      "sharing": "Condivisioni",
      "withSharing": "Con Condivisioni",
      "withoutSharing": "Senza Condivisioni"
    },
    "refresh": "Aggiorna Report",
    "retry": "Riprova",
    "period": "Periodo",
    "apply": "Applica",
    "lastMonth": "Ultimo Mese",
    "last3Months": "Ultimi 3 Mesi",
    "year": "Anno",
    "all": "Tutti",
    "cachedData": "Dati aggiornati al: {{date}}",
    "internalDomains": "Domini Interni",
    "critical": "critico",
    "warnings": "attenzioni",
    "criticalAlert": "Indicatori di rischio critici rilevati. Azione immediata richiesta.",
    "warningAlert": "Indicatori di rischio di attenzione rilevati. Revisione consigliata.",
    "securityIncidents": {
      "title": "Incidenti e avvisi di sicurezza",
      "noData": "Nessun incidente o avviso di sicurezza in questo periodo",
      "dateTime": "Data e ora",
      "severityColumn": "Gravità",
      "category": "Tipo",
      "description": "Descrizione",
      "user": "Utente",
      "ipAddress": "Indirizzo IP",
      "country": "Paese",
      "viewInActivityLog": "Vedi in Activity Log",
      "severityLevels": {
        "critical": "Critico",
        "error": "Errore",
        "warning": "Avviso",
        "info": "Info"
      },
      "categories": {
        "loginFailed": "Accesso fallito",
        "suspiciousAccess": "Accesso sospetto",
        "policyViolation": "Violazione policy",
        "permissionDenied": "Permesso negato",
        "rateLimitExceeded": "Limite richieste superato",
        "configurationAlert": "Modifica configurazione",
        "sharingViolation": "Violazione condivisione",
        "dataExportAlert": "Export dati"
      }
    },
    "securityAnomalies": {
      "title": "Anomalie di sicurezza",
      "noData": "Nessuna anomalia di sicurezza aperta in questo periodo",
      "criticalAlert": "{{count}} anomalia di sicurezza critica richiede attenzione",
      "criticalAlert_other": "{{count}} anomalie di sicurezza critiche richiedono attenzione",
      "byDetectorTitle": "Anomalie per tipo",
      "summary": {
        "totalOpen": "Anomalie aperte",
        "critical": "Critiche",
        "warning": "Avvisi",
        "info": "Info"
      },
      "severityColumn": "Severità",
      "type": "Tipo",
      "anomaly": "Anomalia",
      "events": "Eventi",
      "lastSeen": "Ultimo avvistamento",
      "actionsColumn": "Azioni",
      "handledAt": "Gestita il",
      "tabs": {
        "open": "Aperte",
        "managed": "Gestite"
      },
      "actions": {
        "hide": "Segna come gestita",
        "restore": "Ripristina"
      },
      "hideConfirmTitle": "Segnare questa anomalia come gestita?",
      "hideNotePlaceholder": "Nota facoltativa (motivo)…",
      "restoreConfirmTitle": "Ripristinare questa anomalia?",
      "hideSuccess": "Anomalia segnata come gestita",
      "hideError": "Impossibile segnare l'anomalia come gestita",
      "restoreSuccess": "Anomalia ripristinata",
      "restoreError": "Impossibile ripristinare l'anomalia",
      "managedLoadError": "Impossibile caricare le anomalie gestite",
      "managedNoData": "Nessuna anomalia gestita",
      "severityLevels": {
        "critical": "Critica",
        "warning": "Avviso",
        "info": "Info"
      },
      "detectors": {
        "admin_ip_blocked": "Accesso admin da IP bloccato",
        "unauthorized_country": "Accesso da paese non autorizzato",
        "brute_force_login": "Brute-force sul login",
        "password_spray": "Password spray",
        "folder_password_brute_force": "Brute-force password cartella",
        "public_link_brute_force": "Brute-force link pubblico",
        "security_signal": "Segnale di sicurezza"
      }
    },
    "activityMap": {
      "title": "Attività per paese",
      "noData": "Nessun dato di localizzazione attività in questo periodo",
      "activities": "{{count}} attività",
      "failedLogins": "{{count}} accessi falliti",
      "legendLow": "Basso",
      "legendHigh": "Alto",
      "selectedCountry": "{{country}}",
      "hint": "Clicca un paese sulla mappa per i dettagli.",
      "viewDetails": "Vedi dettaglio accessi",
      "periodNote": "I dati della mappa si riferiscono agli ultimi 90 giorni.",
      "periodRange": "I dati della mappa vanno dal {{from}} al {{to}}."
    },
    "geoDetail": {
      "title": "Dettaglio accessi — {{country}}",
      "totalUsers": "{{count}} utenti",
      "user": "Utente",
      "activities": "Attività",
      "failedLogins": "Accessi falliti",
      "distinctIps": "IP",
      "lastAccess": "Ultimo accesso",
      "anonymous": "Anonimo",
      "noData": "Nessun dato di accesso per questo paese nel periodo selezionato",
      "geoUnavailable": "Geolocalizzazione non disponibile"
    },
    "recipients": {
      "title": "Destinatari condivisioni",
      "domainSubtitle": "Dominio: {{domain}}",
      "refreshHint": "Ricalcola i dati (al massimo una volta ogni 30 secondi)",
      "topTitle": "Top 10 destinatari per elementi condivisi",
      "noData": "Nessun destinatario nel periodo selezionato",
      "countingRulesTitle": "Come vengono contati i destinatari",
      "countingRules": {
        "active": "Contano solo le condivisioni attive: sono escluse quelle scadute, in attesa, rifiutate, revocate o esaurite e i file nel cestino.",
        "direct": "Contano solo le condivisioni dirette: una cartella condivisa è un solo elemento, il suo contenuto non viene espanso.",
        "group": "Un gruppo è un solo destinatario (i membri sono indicati a titolo informativo); tutti i link pubblici sono una sola riga.",
        "domainCount": "Questi totali possono essere inferiori ai conteggi di Domini destinatari, che includono ogni condivisione del periodo."
      },
      "summary": {
        "internalUsers": "Utenti interni",
        "externalUsers": "Utenti esterni",
        "groups": "Gruppi",
        "publicLinks": "Link pubblici",
        "totalShares": "Condivisioni totali"
      },
      "types": {
        "all": "Tutti i tipi",
        "internal": "Interno",
        "external": "Esterno",
        "group": "Gruppo",
        "public": "Pubblico"
      },
      "type": "Tipo",
      "domain": "Dominio",
      "domainPlaceholder": "Filtra per dominio",
      "searchPlaceholder": "Cerca nome o email",
      "editorOnly": "Solo condivisioni editor",
      "withoutExpirationOnly": "Solo senza scadenza",
      "sortBy": "Ordina per",
      "sortByValue": "Ordina per: {{field}}",
      "sort": {
        "items": "Elementi",
        "editor": "Condivisioni editor",
        "withoutExpiration": "Senza scadenza",
        "lastShared": "Ultima condivisione",
        "owners": "Proprietari",
        "name": "Nome"
      },
      "totalRecipients": "{{count}} destinatari",
      "name": "Nome",
      "email": "Email",
      "members": "Membri",
      "items": "Elementi",
      "filesFolders": "{{files}} file / {{folders}} cartelle",
      "editorShares": "Editor",
      "withoutExpiration": "Senza scadenza",
      "withoutPassword": "Senza password",
      "owners": "Proprietari",
      "lastShared": "Ultima condivisione",
      "highestRisk": "Rischio massimo",
      "publicLinks": "Link pubblici",
      "unknown": "Sconosciuto",
      "itemsTitle": "Condiviso con {{name}}",
      "totalItems": "{{count}} elementi condivisi",
      "noItems": "Nessuna condivisione attiva nel periodo selezionato",
      "itemName": "Nome",
      "file": "File",
      "folder": "Cartella",
      "size": "Dimensione",
      "owner": "Proprietario",
      "permission": "Permesso",
      "editor": "Editor",
      "viewer": "Visualizzatore",
      "expiration": "Scadenza",
      "never": "Mai",
      "createdAt": "Condiviso il",
      "canDownload": "Download",
      "passwordProtected": "Password",
      "accesses": "Accessi",
      "accessCountValue": "{{count}} / {{max}}",
      "unlimited": "Illimitati",
      "yes": "Sì",
      "no": "No"
    },
    "errors": {
      "accessDenied": "Accesso Negato",
      "accessDeniedDescription": "Non hai i permessi per visualizzare il Report Esecutivo. Solo gli Administrator possono accedere a questa sezione.",
      "serverError": "Errore di Sistema",
      "serverErrorDescription": "Impossibile generare il report. Riprova più tardi.",
      "noData": "Nessun Dato Disponibile",
      "pdfExportFailed": "Export del dashboard in PDF non riuscito. Riprova o contatta l'assistenza.",
      "folderPasswordForm": {
        "title": "Protezione Password Cartella"
      },
      "invalidFilter": "Filtro non valido: è stato reimpostato.",
      "recipientNotFound": "Destinatario non trovato. L'elenco è stato aggiornato."
    }
  },
  "aiClassificationStatus": {
    "none": "Nessuna",
    "queued": "In coda...",
    "classifying": "Classificazione in corso...",
    "done": "Completato",
    "error": "Errore",
    "unknown": "Sconosciuto"
  },
  "webSocketStatus": {
    "idle": "Inattivo",
    "connecting": "Connessione",
    "open": "Aperto",
    "closing": "Chiusura",
    "closed": "Chiuso",
    "error": "Errore"
  },
  "fileOfflineStatus": {
    "Pending": "In coda per sincronizzazione dispositivo",
    "Downloading": "Download in corso sul dispositivo",
    "Downloaded": "Sincronizzato sul dispositivo"
  },
  "file": {
    "antivirus": {
      "pending": "Scansione antivirus in corso",
      "rescanPending": "Nuova scansione in coda — il file resta bloccato ({{threatName}})",
      "infected": "Minaccia rilevata: {{threatName}}",
      "error": "L'antivirus non ha potuto verificare questo file",
      "errors": {
        "STREAM_TOO_LARGE": "Non verificato dall'antivirus — file troppo grande per la scansione",
        "ENGINE_UNREACHABLE": "Motore antivirus non raggiungibile",
        "SCAN_TIMEOUT": "Scansione antivirus scaduta",
        "MAX_RETRIES": "Scansione antivirus non riuscita dopo più tentativi"
      },
      "rescanFailed": "Nuova scansione non riuscita — il file resta bloccato ({{threatName}})",
      "retry": "Ripeti scansione",
      "contactAdmin": "Contatta l'amministratore se ritieni che sia un falso positivo.",
      "stickyNote": "Ricaricare, ripristinare una versione o modificare in Office non rimuoverà questa minaccia.",
      "tooLarge": "Non verificato dall'antivirus — file troppo grande per la scansione"
    }
  },
  "batch": {
    "status": {
      "all": "Tutti",
      "queued": "In coda",
      "processing": "In elaborazione",
      "completed": "Completato",
      "failed": "Fallito",
      "partiallycompleted": "Parzialmente completato",
      "cancelled": "Annullato"
    },
    "operation": {
      "all": "Tutte le operazioni",
      "classification": "Classificazione IA",
      "folderexpansion": "Espansione cartella",
      "delete": "Eliminazione"
    },
    "failedFiles": "{{count}} file fallito",
    "failedFiles_other": "{{count}} file falliti",
    "eta": "Tempo stimato",
    "failedFilesDetail": "Dettaglio file falliti",
    "noFailedFiles": "Nessun file fallito",
    "fileCancelled": "Annullamento richiesto per questo file.",
    "fileCancelError": "Errore nella richiesta di annullamento del file.",
    "fileRetried": "File rimesso in coda per il retry",
    "fileRetryError": "Errore nel retry del file",
    "cancelAllFailed": "Annulla tutti i batch falliti (non in elaborazione)",
    "cancelAllFailedConfirmTitle": "Annullare tutti i batch falliti?",
    "cancelAllFailedConfirmContent": "Verranno cancellati solo i batch con stato Fallito. I batch in elaborazione o in coda continuano e non vengono interessati. L'operazione non può essere annullata."
  },
  "entraId": {
    "importFromEntraId": "Importa da Entra ID",
    "importGroupsTitle": "Importa gruppi da Microsoft Entra ID",
    "importUsersTitle": "Importa utenti da Microsoft Entra ID",
    "searchGroups": "Cerca gruppi...",
    "selectNew": "Seleziona solo nuovi",
    "existing": "Esistente",
    "new": "Nuovo",
    "importMembers": "Importa anche i membri del gruppo",
    "importSelected": "Importa ({{count}})",
    "importSuccess": "Importazione completata: {{created}} creati, {{updated}} aggiornati",
    "importError": "Errore durante l'importazione",
    "errorLoadingGroups": "Errore nel caricamento dei gruppi da Entra ID",
    "errorLoadingUsers": "Errore nel caricamento degli utenti da Entra ID",
    "noGroupsFound": "Nessun gruppo trovato",
    "noUsersFound": "Nessun utente trovato",
    "resultSummary": "Creati: {{created}}, Aggiornati: {{updated}}, Saltati: {{skipped}}, Falliti: {{failed}}",
    "usersImported": "{{count}} membro/i importato/i",
    "permissionErrorTitle": "Permessi Azure AD insufficienti",
    "permissionErrorDescription": "L'applicazione Azure AD non ha i permessi necessari per accedere a Microsoft Graph API.",
    "permissionErrorSteps": "Per risolvere il problema:",
    "permissionErrorStep1": "Vai su Azure Portal > Registrazioni app > La tua app",
    "permissionErrorStep2": "Naviga su Autorizzazioni API",
    "permissionErrorStep3": "Aggiungi i permessi Applicazione richiesti (non Delegati)",
    "permissionErrorStep4": "Clicca su \"Concedi consenso amministratore\" per autorizzare i permessi",
    "requiredPermissions": "Permessi richiesti",
    "filterBySync": "Filtra per sincronizzazione",
    "syncedWithEntraId": "Sincronizzato con Entra ID",
    "syncedTooltip": "Sincronizzato con Microsoft Entra ID",
    "searchUsers": "Cerca utenti...",
    "importUsersSuccess": "Importazione completata: {{created}} creati, {{updated}} aggiornati",
    "usersResultSummary": "Creati: {{created}}, Aggiornati: {{updated}}, Saltati: {{skipped}}, Falliti: {{failed}}",
    "defaultRole": "Ruolo predefinito"
  },
  "continents": {
    "europe": "Europa",
    "asia": "Asia",
    "africa": "Africa",
    "northAmerica": "Nord America",
    "southAmerica": "Sud America",
    "oceania": "Oceania",
    "antarctica": "Antartide"
  },
  "components": {
    "countrySelect": {
      "placeholder": "Seleziona paesi...",
      "euOption": "Unione Europea (Tutti i 27 paesi)",
      "searchPlaceholder": "Cerca paesi..."
    },
    "regionSelect": {
      "placeholder": "Seleziona regioni o inserisci codici ISO...",
      "euOption": "Unione Europea",
      "searchPlaceholder": "Cerca regioni..."
    },
    "ipCidrInput": {
      "placeholder": "Inserisci indirizzi IP o range CIDR, separati da virgole",
      "helperText": "Esempi: 192.168.1.100, 10.0.0.0/8, 2001:db8::/32",
      "invalidEntry": "Inserisci un indirizzo IP o un range CIDR valido",
      "invalidEntries": "Voci non valide: {{entries}}"
    },
    "ipRegionExceptionForm": {
      "title": "Gestisci Eccezioni IP/Regione",
      "description": "Concedi criteri di accesso aggiuntivi a utenti o gruppi specifici",
      "typeLabel": "Tipo di Eccezione",
      "additionalIpsTitle": "IP Aggiuntivi Consentiti",
      "addAllowedIp": "Aggiungi IP o CIDR",
      "additionalCountriesTitle": "Paesi Aggiuntivi Consentiti",
      "additionalRegionsTitle": "Regioni Aggiuntive Consentite",
      "expirationTitle": "Data di Scadenza",
      "expirationNone": "Nessuna Scadenza",
      "expirationCustom": "Scade il:",
      "reasonTitle": "Motivo (per audit)",
      "reasonPlaceholder": "es., Viaggio d'affari a Londra - Feb 2026",
      "addException": "Aggiungi eccezione",
      "existingExceptions": "Eccezioni esistenti",
      "fetchError": "Si è verificato un errore nel recupero delle eccezioni. Riprova.",
      "selectAtLeastOne": "Seleziona almeno un utente o gruppo",
      "atLeastOneCriterion": "Aggiungi almeno un indirizzo IP, paese o regione: un'eccezione senza criteri non concede nulla",
      "alreadyPresent": "Gli utenti o gruppi selezionati hanno già un'eccezione su questa restrizione"
    }
  },
  "email": {
    "inbox": "Ricevute",
    "sent": "Inviate",
    "favorites": "Preferite",
    "trash": "Cestino",
    "drafts": "Bozze",
    "noEmails": "Nessuna email in questa cartella",
    "noEmailsFound": "Nessuna email trovata",
    "noSubject": "(Nessun oggetto)",
    "searchPlaceholder": "Cerca email",
    "newMessage": "Nuovo Messaggio",
    "newEmail": "Email",
    "folders": "Cartelle",
    "to": "A",
    "from": "Da",
    "cc": "Cc",
    "bcc": "Ccn",
    "subject": "Oggetto",
    "date": "Data",
    "body": "Corpo",
    "send": "Invia",
    "sending": "Invio in corso...",
    "cancel": "Annulla",
    "draftIdle": "In attesa di modifiche",
    "draftSaveError": "Salvataggio fallito",
    "draftSaved": "Bozza salvata",
    "draftSaving": "Salvataggio...",
    "editDraft": "Modifica bozza",
    "saveDraft": "Salva bozza",
    "sendError": "Errore nell'invio dell'email",
    "errorExternalSharingNotAllowed": "I seguenti destinatari non sono autorizzati",
    "errorSharingDenied": "Non hai il permesso di condividere questi file",
    "errorPartialSharingDenied": "Alcuni allegati non possono essere condivisi con i destinatari selezionati",
    "errorCannotAccessFiles": "Non hai accesso ai file allegati",
    "attachmentReadOnly": "Sola lettura",
    "attachmentEditor": "Può modificare",
    "attachmentExpirationWarning": "La condivisione scadrà tra {{days}} giorni",
    "attachmentPermission": "Permesso",
    "writeMessage": "Scrivi il tuo messaggio...",
    "attachFiles": "Allega file",
    "attachments": "Allegati",
    "hasAttachments": "Con allegati",
    "addFavorite": "Aggiungi ai preferiti",
    "removeFavorite": "Rimuovi dai preferiti",
    "moveToTrash": "Sposta nel cestino",
    "archive": "Archivio",
    "archiveAction": "Archivia",
    "unarchiveAction": "Sposta in Inbox",
    "restore": "Ripristina",
    "deleteDraft": "Elimina bozza",
    "deleteDraftConfirm": "Spostare questa bozza nel cestino? Potrai ripristinarla dal Cestino in seguito.",
    "deletePermanently": "Elimina definitivamente",
    "bold": "Grassetto",
    "italic": "Corsivo",
    "underline": "Sottolineato",
    "bulletList": "Elenco puntato",
    "fontSmall": "Piccolo",
    "fontNormal": "Normale",
    "fontLarge": "Grande",
    "fontHuge": "Enorme",
    "sendingInProgress": "Invio in Corso",
    "stepPreparing": "Preparazione del messaggio per la consegna",
    "stepValidating": "Validazione dei destinatari",
    "stepArchiving": "Archiviazione nello storage sicuro",
    "stepDelivering": "Consegna ai destinatari...",
    "secureDelivery": "Consegna Sicura - Protezione Enterprise",
    "protect": "Proteggi con password",
    "protectionTitle": "Protezione con password",
    "protectionPassword": "Password",
    "protectionConfirm": "Conferma password",
    "protectionHint": "Suggerimento (facoltativo)",
    "protectionMismatch": "Le password non corrispondono",
    "protectionWarning": "Il contenuto dell'email verrà cifrato localmente. Se perdi questa password, il messaggio non potrà essere recuperato.",
    "protectedMessage": "Questo messaggio è protetto da una password.",
    "protectedSnippet": "Messaggio protetto",
    "protectedHintLabel": "Suggerimento",
    "enterPassword": "Inserisci la password per leggere il messaggio",
    "unlock": "Sblocca",
    "wrongPassword": "Password errata. Riprova.",
    "reply": "Rispondi",
    "forward": "Inoltra",
    "forwardedMessage": "Messaggio inoltrato",
    "forwardExpired": "Il messaggio originale è scaduto, l'inoltro è stato annullato.",
    "forwardAttachmentsTitle": "Inoltra allegati",
    "forwardAttachmentsMessage": "Questo messaggio contiene degli allegati. Vuoi includerli nel messaggio inoltrato?",
    "forwardWithAttachments": "Con allegati",
    "forwardWithoutAttachments": "Senza allegati",
    "selectFromFileGrant": "Seleziona da FileGrant",
    "uploadFromDevice": "Carica da dispositivo",
    "selectFiles": "Seleziona file",
    "selectFolderForUpload": "Seleziona cartella di upload",
    "filesSelected": "{{count}} file selezionati",
    "confirm": "Conferma",
    "expiration": "Scadenza",
    "expirationTitle": "Data di scadenza",
    "expirationDescription": "L'email non sarà più accessibile dopo la data selezionata.",
    "expirationPlaceholder": "Seleziona data e ora di scadenza",
    "expiresOn": "Scade il {{date}}",
    "expired": "Scaduta il {{date}}",
    "selected": "{{count}} selezionate",
    "markAsRead": "Segna come letto",
    "markAsUnread": "Segna come non letto",
    "deletePermanentlyConfirm": "Sei sicuro di voler eliminare definitivamente {{count}} email? Questa azione non può essere annullata.",
    "selectAll": "Seleziona tutto",
    "deselectAll": "Deseleziona tutto",
    "removeAttachment": "Rimuovi allegato",
    "removeAttachmentConfirm": "Vuoi rimuovere questo allegato? L'accesso verrà revocato per tutti i destinatari.",
    "attachmentNotFound": "Allegato non trovato",
    "featureNotAvailable": "Funzionalità non disponibile",
    "removeRecipient": "Rimuovi destinatario",
    "removeRecipientsConfirm": "Vuoi rimuovere {{count}} destinatari? Non potranno più vedere questa email e l'accesso agli allegati verrà revocato.",
    "emailNotFound": "Email non trovata",
    "recipientNotFound": "Destinatario non trovato",
    "mustKeepOneRecipient": "Deve restare almeno un destinatario",
    "replyAll": "Rispondi a tutti",
    "activity": "Attività",
    "cannotCreateEmail": "Non hai i permessi per creare nuove email",
    "blockForward": "Blocca inoltro",
    "blockForwardDescription": "I destinatari non potranno inoltrare questa email",
    "advancedProtection": "Protezione avanzata",
    "protectDescription": "I destinatari dovranno inserire una password per leggere questa email"
  },
  "note": {
    "createNote": "Nota",
    "createTitle": "Crea nota",
    "newNote": "Nuova nota",
    "fileName": "Nome file",
    "fileNameRequired": "Il nome del file è obbligatorio",
    "placeholder": "Scrivi la tua nota...",
    "loadError": "Impossibile caricare la nota",
    "sidebarTitle": "Note",
    "editing": "Modifica",
    "reading": "Lettura",
    "codeBlock": "Blocco di codice",
    "rename": "Rinomina",
    "renamed": "File rinominato",
    "renameError": "Impossibile rinominare il file",
    "saved": "Nota salvata",
    "saveError": "Impossibile salvare la nota",
    "checklist": "Lista di controllo",
    "linkUrl": "URL del link",
    "linkText": "Testo del link",
    "insertLink": "Inserisci link",
    "saving": "Salvataggio…",
    "savedShort": "Salvato",
    "delete": "Elimina nota",
    "deleteTitle": "Elimina nota",
    "deleteConfirm": "Eliminare la nota \"{{name}}\"? Verrà spostata nel cestino.",
    "deleted": "Nota eliminata",
    "deleteError": "Impossibile eliminare la nota",
    "expandSidebar": "Espandi sidebar",
    "collapseSidebar": "Comprimi sidebar"
  },
  "aiSummary": {
    "generationInProgress": "La generazione del riassunto potrebbe richiedere un po' di tempo: puoi chiudere questa finestra, ti avviseremo quando è pronto.",
    "closeAndNotify": "Chiudi, ti avvisiamo noi"
  },
  "imagePreview": {
    "loadFullQuality": "Carica qualità massima",
    "loadFullQualityTooltip": "Carica l'immagine originale a risoluzione completa (file grande)",
    "loadingFullQuality": "Caricamento qualità massima…",
    "openInViewer": "Apri nel viewer"
  },
  "shortcuts": {
    "title": "Scorciatoie da tastiera",
    "then": "poi",
    "searchLabel": "Cerca scorciatoie da tastiera",
    "searchPlaceholder": "Cerca scorciatoie…",
    "listLabel": "Elenco scorciatoie da tastiera",
    "noResults": "Nessuna scorciatoia corrisponde alla ricerca.",
    "categories": {
      "app": "Applicazione",
      "create": "Crea",
      "file": "File",
      "navigation": "Navigazione",
      "selection": "Selezione",
      "view": "Vista"
    },
    "app": {
      "focusSearch": "Focus ricerca",
      "openShortcutsHelp": "Apri scorciatoie da tastiera"
    },
    "create": {
      "openMenu": "Apri menu Crea",
      "folder": "Nuova cartella",
      "uploadFile": "Carica file",
      "uploadFolder": "Carica cartella",
      "word": "Nuovo documento Word",
      "excel": "Nuovo foglio Excel",
      "powerpoint": "Nuova presentazione PowerPoint",
      "note": "Nuova nota",
      "secret": "Nuove credenziali di accesso",
      "secretCard": "Nuova carta di pagamento",
      "secretIdentity": "Nuova identità",
      "secretSshKey": "Nuova chiave SSH",
      "secretCustom": "Nuovo segreto personalizzato"
    },
    "file": {
      "open": "Apri",
      "openNewTab": "Apri in nuova scheda",
      "rename": "Rinomina",
      "share": "Condividi",
      "move": "Sposta",
      "favorite": "Aggiungi ai preferiti",
      "delete": "Rimuovi",
      "copyLink": "Copia link",
      "createShortcut": "Crea collegamento",
      "details": "Dettagli",
      "download": "Scarica",
      "publicLink": "Link pubblico",
      "setPassword": "Imposta password",
      "aiSummary": "Riepilogo IA",
      "tags": "Modifica tag"
    },
    "view": {
      "toggleGridList": "Alterna griglia o elenco"
    },
    "nav": {
      "focusSidebar": "Focus navigazione",
      "focusMain": "Focus elenco file",
      "focusDetails": "Focus pannello dettagli",
      "focusUploadDrawer": "Focus caricamento"
    },
    "selection": {
      "selectAll": "Seleziona tutto",
      "clear": "Deseleziona tutto",
      "toggle": "Alterna selezione",
      "moveFocusUp": "Sposta focus su",
      "moveFocusDown": "Sposta focus giù",
      "moveFocusLeft": "Sposta focus a sinistra",
      "moveFocusRight": "Sposta focus a destra",
      "extendUp": "Estendi selezione su",
      "extendDown": "Estendi selezione giù",
      "extendLeft": "Estendi selezione a sinistra",
      "extendRight": "Estendi selezione a destra"
    }
  },
  "chat": {
    "thinking": {
      "working": "Sto elaborando la richiesta. Potrebbero volerci alcuni secondi."
    },
    "stream": {
      "tools": {
        "routing": "Classificazione richiesta",
        "rag_search": "Ricerca nei documenti",
        "filename_search": "Ricerca per nome file",
        "metadata_search": "Ricerca metadati",
        "open_file": "Apertura file",
        "relevance_assessment": "Valutazione rilevanza",
        "search_refinement": "Affinamento ricerca",
        "activity_log_search": "Ricerca nel registro attività",
        "calculator": "Calcolo",
        "chart_generation": "Generazione grafico",
        "aggregation": "Aggregazione risultati",
        "answer_generation": "Generazione risposta",
        "paused": "In coda",
        "unknown": "Elaborazione"
      },
      "descriptions": {
        "routing": {
          "start": "Capisco cosa ti serve…",
          "done": "Richiesta classificata{{intentDetail}}."
        },
        "rag_search": {
          "start": "Cerco nei tuoi documenti{{queryDetail}}…",
          "done": "Trovati passaggi pertinenti nella libreria{{countDetail}}."
        },
        "filename_search": {
          "start": "Scorro i file in base al nome{{patternDetail}}…",
          "done": "Trovati i file con nomi corrispondenti{{countDetail}}."
        },
        "metadata_search": {
          "start": "Controllo tag, date e altre proprietà…",
          "done": "Proprietà dei documenti controllate{{countDetail}}."
        },
        "open_file": {
          "start": "Leggo il documento scelto{{filenameDetail}}…",
          "done": "Contenuto del documento pronto{{filenameDetail}}."
        },
        "relevance_assessment": {
          "start": "Valuto quali risultati rispondono meglio{{candidateCountDetail}}…",
          "done": "Tenuti i risultati più solidi{{countDetail}}."
        },
        "search_refinement": {
          "start": "Restringo la query per risultati migliori{{queryDetail}}…",
          "done": "Criteri di ricerca aggiornati."
        },
        "activity_log_search": {
          "start": "Controllo chi ha fatto cosa, e quando{{queryDetail}}…",
          "done": "Voci di attività corrispondenti recuperate{{countDetail}}."
        },
        "calculator": {
          "start": "Elaboro i numeri{{expressionDetail}}…",
          "done": "Numeri pronti{{expressionDetail}}."
        },
        "chart_generation": {
          "start": "Trasformo i dati in un grafico…",
          "done": "Grafico pronto da mostrare."
        },
        "aggregation": {
          "start": "Unisco le corrispondenze in un unico insieme…",
          "done": "Risultati combinati pronti{{countDetail}}."
        },
        "answer_generation": {
          "start": "Metto insieme la risposta…",
          "done": "Risposta pronta."
        },
        "paused": {
          "start": "GPU occupata — turno in coda{{reasonDetail}}…",
          "done": "Ripresa — continuo la richiesta."
        },
        "unknown": {
          "start": "Lavoro su questo passaggio…",
          "done": "Questo passaggio è completo."
        }
      },
      "param": {
        "query": " per «{{query}}»",
        "pattern": " per «{{pattern}}»",
        "filename": " «{{filename}}»",
        "expression": " ({{expression}})",
        "count": " ({{count}})",
        "candidateCount": " ({{count}} candidati)",
        "reason": " — {{reason}}",
        "intent": " come «{{intent}}»"
      },
      "reasons": {
        "gpu_overload": "GPU sovraccarica"
      },
      "toolsUsed": "Strumenti usati ({{count}})"
    },
    "disclaimer": "AIGrant può commettere errori. Verifica le informazioni importanti.",
    "offlineHint": "Connessione in tempo reale assente. Puoi sfogliare le chat; invia quando torna online.",
    "offlineDisclaimer": "Offline: potrai inviare messaggi non appena la connessione sarà ristabilita.",
    "connectingHint": "Collegamento in tempo reale in corso. Potrai inviare non appena sarà pronto.",
    "connectingDisclaimer": "Connessione in corso: potrai inviare messaggi non appena il collegamento sarà attivo.",
    "placeholder": "Scrivi il tuo messaggio... (Invio per inviare, Maiusc+Invio per nuova riga)",
    "dictate": "Dettatura",
    "stopDictation": "Interrompi dettatura",
    "speechUnsupported": "Il riconoscimento vocale non è supportato in questo browser",
    "dictationFailed": "Impossibile avviare la dettatura",
    "regenerate": "Rigenera",
    "readAloud": "Leggi ad alta voce",
    "stopReading": "Interrompi lettura",
    "speechUnavailable": "Sintesi vocale non disponibile",
    "requestCancelled": "Richiesta annullata",
    "genericError": "Si è verificato un errore durante l'elaborazione della richiesta.",
    "gpuBusyBody": "Il sistema è temporaneamente sovraccarico. Riprova tra poco.",
    "gpuBusyRetrying": "Sistema occupato — riprovo una volta…",
    "responseTimeout": "Non è stato possibile completare la richiesta entro il tempo massimo (10 minuti). Riprovare più tardi o contattare il supporto se il problema persiste.",
    "jumpToLatest": "Vai all'ultimo messaggio"
  },
  "sharePointStatus": {
    "menuLabel": "SharePoint",
    "title": "Stato SharePoint",
    "openConfiguration": "Configura",
    "refreshHint": "Legge lo stato in tempo reale dal tuo tenant. Usalo con parsimonia.",
    "never": "Mai",
    "notAvailableTitle": "Non inclusa nella tua licenza",
    "notAvailable": "L'integrazione SharePoint non è inclusa nella tua licenza. Contatta il supporto per abilitarla.",
    "loadFailedTitle": "Non è stato possibile caricare lo stato",
    "loadFailed": "Si è verificato un errore durante la lettura dello stato dell'integrazione.",
    "verdict": {
      "encrypting": "I file del perimetro vengono cifrati",
      "notEncrypting": "Nulla viene cifrato"
    },
    "unmatched": {
      "title": "Alcuni siti del perimetro non esistono nel tuo tenant",
      "body": "La corrispondenza è esatta, quindi un sito rinominato o eliminato non corrisponde più. I file di questi siti non vengono ispezionati né cifrati:",
      "allMissingTitle": "Nessun sito del perimetro esiste nel tuo tenant",
      "allMissingBody": "Non viene monitorato nulla. Nessuno di questi siti è stato trovato:",
      "repickAction": "Seleziona di nuovo questi siti"
    },
    "blocking": {
      "notConfiguredTitle": "L'integrazione non è configurata",
      "notConfigured": "Nessuna credenziale è memorizzata, quindi non sta avvenendo nulla.",
      "configInvalid": "La configurazione salvata è stata rifiutata dalla stessa convalida che esegue la scansione, quindi non sta avvenendo nulla.",
      "workerDisabledTitle": "La scansione non è attiva su questa installazione",
      "workerDisabled": "Il servizio di scansione non è registrato su questo deployment, quindi nulla verrà ispezionato. Non è una cosa che puoi modificare: contatta il supporto.",
      "noCertificateTitle": "Nessun certificato di cifratura selezionato",
      "noCertificate": "Nessun certificato RemoteGrant è selezionato, quindi non c’è alcuna chiave e nulla verrà cifrato.",
      "certificateUnusableTitle": "Il certificato di cifratura non è più utilizzabile",
      "certificateUnusable": "Ri-seleziona il certificato e salva per riprendere la cifratura. Può essere stato cancellato in RemoteGrant, la sua chiave può essere stata sostituita, oppure RemoteGrant può non essere raggiungibile.",
      "noKeyWhileArmed": "La modalità discovery è disattiva, quindi questa configurazione sembra attiva mentre non sta cifrando nulla.",
      "emptyPerimeterTitle": "Il perimetro è vuoto",
      "emptyPerimeter": "Nessun sito del perimetro viene risolto sul tuo tenant, quindi non viene monitorato nulla."
    },
    "certificate": {
      "label": "Certificato di cifratura",
      "none": "Nessuno selezionato",
      "unnamed": "Certificato n. {{id}}",
      "repickAction": "Ri-seleziona il certificato"
    },
    "perimeterUnresolvedTitle": "Non è stato possibile verificare il perimetro sul tuo tenant",
    "perimeterUnresolvedBody": "I contatori qui sotto sono comunque validi, ma i siti e le cartelle monitorati non sono leggibili in questo momento. Questo non significa che il perimetro sia vuoto.",
    "perimeterError": {
      "unauthorized": "Microsoft Graph ha rifiutato le credenziali: il client secret potrebbe essere scaduto, oppure ai permessi applicativi potrebbe mancare il consenso amministratore.",
      "unavailable": "Microsoft Graph è temporaneamente non raggiungibile.",
      "siteNotFound": "Un sito del perimetro non è più visibile con queste credenziali.",
      "generic": "Non è stato possibile raggiungere il tenant."
    },
    "countersTitle": "Attività della scansione",
    "pendingInQueue": "File in attesa di elaborazione",
    "totalFilesEncrypted": "File cifrati finora",
    "scanInterval": "Perimetro controllato",
    "everyNMinutes": "Ogni {{minutes}} minuti",
    "lastEncryptedAt": "Ultimo file cifrato",
    "lastDeltaAdvancedAt": "Ultimo ciclo di scansione",
    "lastVerifiedAt": "Ultima verifica delle credenziali",
    "verifyOk": "Superata",
    "verifyKo": "Rifiutata",
    "perimeterTitle": "Perimetro monitorato",
    "perimeterUnknown": "In questo momento non è stato possibile leggere il perimetro dal tuo tenant.",
    "perimeterEmpty": "Nessun sito è monitorato.",
    "crossLibraryCaveat": "Ogni cartella qui sotto viene confrontata con la radice di tutte le raccolte documenti del suo sito, non solo di quella da cui è stata selezionata.",
    "wholeSiteTag": "Tutto il sito",
    "wholeSiteBody": "Nessun filtro sulle cartelle: ogni file di questo sito è incluso.",
    "allFileTypes": "Tutti i tipi di file",
    "filteredFileTypes": "Solo: {{extensions}}",
    "notAllowedTitle": "Non hai i permessi per visualizzare questa pagina",
    "notAllowed": "Non hai i permessi per gestire l'integrazione SharePoint. Chiedi a un SuperAdmin di abilitarti a questa impostazione.",
    "box": {
      "active": "Attiva",
      "dryRunDiscovery": "Discovery",
      "dryRunEncryption": "Cifratura",
      "dryRunLabel": "Modalità",
      "dryRunOffCaption": "I file corrispondenti vengono cifrati sul posto, senza ritorno.",
      "dryRunOnCaption": "Il perimetro viene solo ispezionato: nulla viene riscritto.",
      "inactive": "Non attiva",
      "off": "Disattivo",
      "on": "Attivo",
      "scanLabel": "Scansione"
    },
    "issuesTitle": "Condizioni che richiedono la tua attenzione"
  },
  "sharePoint": {
    "editor": {
      "error": {
        "disabled": {
          "description": "L'integrazione SharePoint non è abilitata su questa installazione.",
          "title": "Integrazione non disponibile"
        },
        "forbidden": {
          "description": "Non hai il permesso di aprire questo file su SharePoint.",
          "title": "Accesso negato"
        },
        "generic": {
          "description": "Non è stato possibile aprire il file nell'editor. Riprova, oppure aprilo nel visualizzatore.",
          "title": "Impossibile aprire l'editor"
        },
        "notProtected": {
          "description": "Questo file non è cifrato da FileGrant: si apre direttamente su SharePoint con Office.",
          "title": "Niente da aprire qui"
        },
        "tooLarge": {
          "description": "Il file supera il limite di dimensione per la modifica. Puoi comunque aprirlo nel visualizzatore.",
          "title": "File troppo grande per la modifica"
        },
        "unsupported": {
          "description": "Questo formato non è modificabile online. Puoi comunque aprirlo nel visualizzatore.",
          "title": "Formato non modificabile"
        }
      },
      "loading": "Apertura del file nell'editor…",
      "readOnly": {
        "description": "SharePoint non ti ha concesso il permesso di modificare questo file, oppure non è disponibile un certificato con cui cifrare il salvataggio. Puoi leggerlo, ma non salvarlo.",
        "title": "Documento in sola lettura"
      },
      "signIn": {
        "button": "Accedi per modificare il file",
        "description": "Accedi con il tuo account Microsoft per modificare questo file. La modifica richiede il permesso di cambiare i file su SharePoint, che potrebbe dover essere autorizzato da un amministratore.",
        "failed": "L'accesso non è stato completato. Verifica che il browser non stia bloccando i popup e riprova.",
        "title": "Accesso richiesto"
      }
    },
    "signIn": {
      "failed": {
        "description": "Non è stato possibile caricare la configurazione di accesso Microsoft. Ricarica la pagina o riprova tra qualche istante.",
        "title": "Accesso non disponibile"
      },
      "loading": "Preparazione dell’accesso Microsoft…",
      "notConfigured": {
        "description": "Impossibile aprire il file: un amministratore non ha configurato la registrazione app Microsoft con cui il browser esegue l’accesso. Chiedi di completare l’impostazione dell’integrazione SharePoint.",
        "title": "Accesso non configurato"
      }
    },
    "viewer": {
      "edit": "Modifica",
      "error": {
        "authFailed": {
          "description": "Non è stato possibile ottenere il permesso di leggere i tuoi file SharePoint. Esegui di nuovo l'accesso oppure chiedi a un amministratore di autorizzare FileGrant.",
          "title": "Accesso richiesto"
        },
        "disabled": {
          "description": "L'integrazione con SharePoint non è abilitata su questa installazione.",
          "title": "Integrazione non disponibile"
        },
        "forbidden": {
          "description": "Non hai i permessi per aprire questo file su SharePoint.",
          "title": "Accesso negato"
        },
        "generic": {
          "description": "Non è stato possibile aprire il file da SharePoint. Riprova.",
          "title": "Impossibile aprire il file"
        },
        "invalidLink": {
          "description": "Questo collegamento a SharePoint non è valido. Riapri il file da SharePoint.",
          "title": "Collegamento non valido"
        },
        "notFound": {
          "description": "File non trovato: potrebbe essere stato spostato o eliminato.",
          "title": "File non trovato"
        },
        "reopen": {
          "description": "Il permesso di aprire questo file è scaduto, oppure il file è cambiato nel frattempo. Riaprilo da SharePoint.",
          "title": "Riapri il file"
        },
        "tooLarge": {
          "description": "Questo file supera il limite di dimensione del viewer SharePoint.",
          "title": "File troppo grande"
        }
      },
      "loading": "Lettura del file da SharePoint…",
      "signIn": {
        "button": "Accedi per aprire il file",
        "description": "Accedi con il tuo account Microsoft per aprire questo file. Viene decifrato solo se hai il permesso di leggerlo.",
        "failed": "L'accesso non è stato completato. Verifica che il browser non stia bloccando i popup, poi riprova.",
        "title": "Accesso richiesto"
      },
      "source": "Da SharePoint"
    }
  },
  "activeDirectory": {
    "syncedWithActiveDirectory": "Sincronizzato con Active Directory"
  }
}
